import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {contentType ,assetGroupType ,sorting ,orderby} from '../../../../../configurations/configuration';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, FormArray,Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ToastrService } from 'ngx-toastr';
import {AssetService} from '../../../../../services/asset/asset.service';
import { StatusService } from '../../../../../services/status_management/status.service';
import {ProductConfigurationService} from '../../../../../services/product_configuration/product_configuration.service';
import {CommonService} from '../../../../../services/common_Service/common.service';
import {awsPath, deviceType,displayIndexingPattern} from '../../../../../configurations/configuration';
import { errorMessages } from './../../../././././../../configurations/errorMessages';
import { AssetGroupService } from '../../../../../services/asset_group/asset_group.service';
import { Subject } from 'rxjs';
import {Observable}  from 'rxjs/Observable';
import {SessionHelper} from '../../../../../services/localstorage';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'app-addAssetGroup',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponentAssetGroup implements OnInit {
    public categories: any = ["Indian", "American", "Canadian", "Chinese"];

  results$ = Observable;
  mainObj : any;
  filterObj :any = {};
  subject = new Subject();
  public route: ActivatedRoute;
  activeSearchBox ='';
  isCreateNewShow:boolean = true;
  applyBlackTheme = localStorage.getItem('boolThemeFlag');
  deviceType = deviceType;
  createAssetGroupForm:FormGroup;
  contentType=contentType;
  assetGroupType = assetGroupType;
  Orderby = orderby;
  sorting = sorting;
  loader:boolean=false;
  createAssetGroupSubmitted=false;
  errorMessages=errorMessages;
  geoZoneList:any=[];
  mapSponsoreList:any=[];
  dropdownList:any=[];
  primaryNavigationList=[];
  menuCategoryList:any=[];
  mapCertificatList:any=[];
  mapClassificationList:any=[];
  mapReviewList:any=[];
  mapLanguageList:any=[];
  audioLanguageList:any=[];
  subtitleLanguageList:any=[];
  mapCastList=[];
  mapLibraryList:any=[];
  selectedmenuCategoryList:any=[];
  multipleDeviceForm:FormGroup;
  mapcastDynamicForm:FormGroup;
  mapcasts: FormArray;
  sponsoredFiter:any =[];

  mapMenuCategoryArrayTemp:any=[];
  mapPrimaryNavigationArrayTemp:any =[];

  startPrimary:number = 0;
  startLibrary:number = 0;
  startReview:number = 0;
  startNaviagation:number = 0;
  reviewFilter:any ={};

  startGenre:number = 0;
  genreFilter:any ={};

  deviceTypeFull:boolean = false;
  deviceTypeDublicate:boolean = false;

  uploadImgFilePathVertical:any=[];
  uploadImgFilePathHorizontal:any=[];
  uploadImgFilePathVertical2:any=[];
  uploadImgFilePathHorizontal2:any=[];
  uploadImgFilePathVertical3:any=[];
  uploadImgFilePathHorizontal3:any=[];
  uploadImgFilePathVertical4:any=[];
  uploadImgFilePathHorizontal4:any=[];
  uploadImgFilePathVertical5:any=[];
  uploadImgFilePathHorizontal5:any=[];
  uploadImgFilePathVerticalPlain:any=[];
  uploadImgFilePathVerticalPlain2:any=[];
  uploadImgFilePathVerticalPlain3:any=[];
  uploadImgFilePathVerticalPlain4:any=[];
  uploadImgFilePathVerticalPlain5:any=[];
  selectedItems:any=[];
  selectedmapCast:any=[];
  selectedProductlist:any=[];
  selectedprimaryNavigationList=[];
  selectedcertificationList:any=[];
  mapProductTypeArrayTemp:any=[];
  trailerVideoList=[];
  producTypeList:any=[];
  ProducTypeDropdownList:any=[];

  menuCategorySettings = {};

  languageFilter:any={};
  devices: FormArray;

  mapGenreList:any = [];
  mapGenreSettings = {};
  mapCharacterList:any=[];
  trailerVideoVirtualSettings={};
  start:number = 0;

  geoZoneObj:any ={};

  startProduct:number = 0;
  startCategory:number = 0;
  startLanguage:number = 0;
  startAudioLanguage:number = 0;
  startSubtitleLanguage:number = 0;
  audioLanguageFilter:any = {};
  subtitleLanguageFilter:any = {};

    //pravin code end
    //start mapping filter
    productTypeMappingFilter:any={};
    primaryNavigationMappingFilter:any={};
    menuCategoryMappingFilter:any={};
    //end mapping filter

    private searchDecouncer$: Subject<string> = new Subject();

    libraryFilter:any={};
    certificateFilter:any={};
    classificationFilter:any={};

    uploadImgFilePosterImage:any=[];
    uploadImgFileclosedCaption:any=[];
    removeTrailerIndex:any='';

    all:boolean = false;
    assetPath: Params;
    startTrailer = 0;
    filterTrailer = {};

    web:boolean;
    android:boolean;
    iOS:boolean;
    roku:boolean;

    dTypeDublicateError:any;
    uploadImgFilePath:any=[];
    img:any=[];
    img2:any=[];
    img3:any=[];
    img4:any=[];
    img5:any=[];
    imgPlain:any=[];
    imgPlain2:any=[];
    imgPlain3:any=[];
    imgPlain4:any=[];
    imgPlain5:any=[];
    id:any;
    update=false;

    isDeleteAction: boolean=false;
    deleteDeviceTypeIndex:any;

    langId:any;

    isDeleteHorizontalImageAction:boolean = false;
    isDeleteVerticalImageAction:boolean = false;
    FilePosterImageURL:any;
    FilePosterImageURL2:any;
    FilePosterImageURL3:any;
    FilePosterImageURL4:any;
    FilePosterImageURL5:any;

    contentReadyToReview:boolean = false;
    shareMassage:any;
    title : any;
    isGroupSearch : boolean = false;

    assetTitle:any='';
    verticalfilepath:any;
    createdDate:any;
    vendorName:any = '';
    isHeaderVisible: any;

    formTabs:any = {

        assetInfo:{

         asset:true,
         mapGeoZone:true,
         information:false,
         HierarchyMapping:false,
         seo:false,
        },
        deviceType:{

            configurationType:false,
            configuration:false,
            horizontal:false,
            vertical:false

        },
        assetLiveVod:{

            vod:false,
            live:false,
            assetLiveVod:false
        },
        metadata:{

            metadata:false,
            metadataHierarchy:false,
            Information:false,
            castAndCrew:false,
            orderingAndSorting:false

        },
        // ordering:false,
        // otherMapping:false
    }

    //pagination related variable

    startCharacter:number = 0;
    characterScrollCount:number = 0;
    charcterInfoObj:any = {};
    settings:any ={};

    reviewScrollCount:number = 0;
    reviewInfoObj:any = {};

    productScrollCount:number = 0;
    productInfoObj:any = {
        pageCount:-1
    };

    isSearch = false;

    onInit:boolean = false;

    classificationScrollCount:number = 0;

    classificationInfoObj:any = {
        pageCount:-1
    };
    startClassification:number = 0;
    startCertificate:number = 0;

    SponsoredScrollCount:number = 0;

    SponsoredInfoObj:any = {
        pageCount:-1
    };
    startSponsored:number = 0;
    mapGeoZoneError = false;
    isLabelError = false;

    isDeletePosterImageAction:boolean=false;
    isDeleteClosedCaptionImageAction:boolean=false;
    //@Input() contentId:any;
    @Output() actionApiSend = new EventEmitter<any>();
    @Output() updateSend = new EventEmitter<any>();
    mapCastSettings={};
    ClosedCaption: any;
    FiletitleImageURL: string | ArrayBuffer;
    FilethumbImageURL: string | ArrayBuffer;
    FiletitleImageURL2: string | ArrayBuffer;
    FilethumbImageURL2: string | ArrayBuffer;
    FiletitleImageURL3: string | ArrayBuffer;
    FilethumbImageURL3: string | ArrayBuffer;
    FiletitleImageURL4: string | ArrayBuffer;
    FilethumbImageURL4: string | ArrayBuffer;
    FiletitleImageURL5: string | ArrayBuffer;
    FilethumbImageURL5: string | ArrayBuffer;
    setupBannerImageURL: string | ArrayBuffer;
    marketingSetupData: any = {};
    isDeletetitleImageAction: boolean = false;
    isDeleteThumbImageAction: boolean = false;
   //New Code for right side for from
    //New Code start
    @Input() set contentId(value: any) {
        this.startSponsored = 0;

        if(value == 'reset'){

            this.resetForm();

        }else   {

            //start code for hide create new button
            if(value != 'null'){
                this.showCreateNewButton('hide');
            }
            //end code for hide create new button
            this.onLoad(value);
        }

    }
    //New Code end


    editorConfig = {
        "toolbar": [
            ["bold", "italic", "underline"],
            ["justifyLeft", "justifyCenter", "justifyRight"]
        ]
    }


    initProductType:boolean=true;
    initNavigation:boolean=true;
    initMenu:boolean=true;
    initGroup:boolean=true;
    initCategory:boolean=true;
    uploadImgFileTitleImage: any[];

    filterAsset:any = [];
    filterAssetSort: any = [];
    constructor(private router:Router,private activatedRoute:ActivatedRoute,private statusService: StatusService, private assetService:AssetService,private commonService:CommonService,private assetGroupService: AssetGroupService,private productConfigurationService:ProductConfigurationService,private spinnerService:Ng4LoadingSpinnerService,private toastrService:ToastrService,private formBuilder:FormBuilder) {
        this.commonService.notify.subscribe((result) => {
            // this.loader = false;
            this.commonService.changeloader(false);
        })
    }


    roleAsses:any={};
    roleConfiguration:any=[];

    ngOnInit() {
      this.onLoad('null');
        this.activatedRoute.params.subscribe((params: Params) => {
            if(this.isGroupSearch == false) {
                this.assetPath = params['id'];
                this.getAllAssetFilter();
            }
        });
        this.startSponsored = 0;




        localStorage.removeItem('langItem');

        this.primaryNavigationMappingFilter.productTypeId = [];

        this.roleAsses.assetGroupEdit = false;
        this.roleAsses.assetGroup = false;
        this.roleAsses.assetGroupCreate = false;

        this.roleConfiguration = SessionHelper.getRole();

        this.roleConfiguration.forEach((element , i) => {
              if((element.isView == 1 && element.pageTitle == 'Asset Group') ){

                  this.roleAsses.assetGroup = true;
              }

              if((element.isEdit == 1 && element.pageTitle == 'Asset Group') ){

                  this.roleAsses.assetGroupEdit = true;
              }

              if((element.isCreate == 1 && element.pageTitle == 'Asset Group')){

                  this.roleAsses.assetGroupCreate = true;

              }

        })

        // if (this.assetPath != undefined) {
        //     // this.onLoad(this.assetPath);
        //     this.editCreate = true;
        //     this.showCreateNewButton('hide');
        //     this.roleAsses.primaryNavigationEdit = true;
        //     this.onLoad(this.assetPath);
        // }
        // else {
        //     this.roleAsses.primaryNavigation = true;
        //     this.roleAsses.primaryNavigationCreate = true;
        //       this.showCreateNewButton('show');
        // }
        // this.results$ = this.subject.pipe(
        //     debounce(() => Rx.Observable.interval(1000)),
        //     map(searchText => this.httpClient.get("/api/search?q=" + searchText))
        // )
         //start code for hide create new button
         if(this.assetPath == undefined){
            this.editCreate = true;
            this.roleAsses.assetGroupCreate = true;
            this.showCreateNewButton('show');
            let headerTitle = {
                title:'Asset Management',
                subTitle:'Asset Group (Series Setup)',
                pageName:'Create Group'

            }

            this.commonService.changeHeaderTitle(headerTitle);
            this.isHeaderVisible = false;
        } else {
        //end code for hide create new button
        this.onLoad(this.assetPath);
        this.showCreateNewButton('hide');
        this.isHeaderVisible = true;
        }

        this.setupSearchDebouncer();

        this.productScrollCount = 0;

        this.onAssetInfoTabClick();
        // theme update code start

    //     this.commonService.currentThemelight.subscribe((result:any)=>{

    //         this.applyBlackTheme = localStorage.getItem('boolThemeFlag');

    //    })

    this.commonService.currentThemelight.subscribe((result:any)=>{

        if(localStorage.getItem('langItem')!=null && localStorage.getItem('activePage')=='assetGroup'){

                    let item = JSON.parse(localStorage.getItem('langItem'));


                    if(item.id!=undefined)
                    this.id = item.id;

                    this.createAssetGroupForm.controls['id'].setValue(this.id);

                    if(item.id != null && this.roleAsses.assetGroupEdit == true){
                        this.editCreate = true;
                        this.isCreateNewShow = false;
                        this.update = true;
                    }else{

                    }

                    this.createAssetGroupForm.controls['langId'].setValue(localStorage.getItem('languageId'));
                    this.createAssetGroupForm.controls['productDeviceTypeConfigure'].setValue([[]]);

                    this.isCreateNewShow = false;
                    // this.postCAllAssetGroup();
                    this.getAssetGroupInfo(this.id)
                    // localStorage.removeItem('langItem');

            }
                this.applyBlackTheme = localStorage.getItem('boolThemeFlag');
      })


    //    this.commonService.currentThemelight.subscribe((result:any)=>{

    //         if(result.id == this.id){

    //                 this.update = true;

    //                 this.createAssetGroupForm.controls['langId'].setValue(localStorage.getItem('languageId'))

    //                 this.postCAllAssetGroup();

    //         }

    //     this.applyBlackTheme = localStorage.getItem('boolThemeFlag');
    //    })

       // theme update code start
    }
    getAllAssetFilter() {
      this.filterObj.languageId = localStorage.getItem('languageId');
      this.assetGroupService.getAllAssetGroup(this.filterAsset, 0 ,10).subscribe((result: any) => {
        if(result.data.data.length > 0){
          this.filterAsset = result.data.data;
          this.filterAssetSort = result.data.data.slice(0, 10);
          console.log('result.......................', this.filterAsset);
        }
      })
    }
    gotoAsset(item){
      console.log('item', item)
      let filtered = this.filterAsset.filter(p => p.title===item)
      this.isGroupSearch = true;
      this.assetPath = filtered[0].id;
      this.router.navigate(['/asset_management/asset_group/add',this.assetPath]);
      this.ngOnInit();
    }
    onPrevious(){
        const index = this.filterAsset.findIndex(obj => obj.id == this.assetPath);
        if (index !== -1) {
        this.assetPath = this.filterAsset[index + 1].id;
        this.router.navigate(['/asset_management/asset_group/add',this.assetPath]);
        this.isGroupSearch = true;
        this.ngOnInit();
      }
    }
    onNext(){
        const index = this.filterAsset.findIndex(obj => obj.id == this.assetPath);
        if (index !== -1 && index > 0) {
        this.assetPath = this.filterAsset[index - 1].id;
        this.router.navigate(['/asset_management/asset_group/add',this.assetPath]);
        this.isGroupSearch = true;
        this.ngOnInit();
      }
    }

    private setVendorName(assetId:any, title:string): void {
      const matchedAsset = this.filterAsset.find((item:any) => String(item.id) === String(assetId));
      if (matchedAsset && (matchedAsset.vendor_name || matchedAsset.vendor_title)) {
        this.vendorName = matchedAsset.vendor_name || matchedAsset.vendor_title;
        return;
      }

      const vendorFilter:any = {
        languageId: localStorage.getItem('languageId') || '1',
        keyword: title
      };

      this.assetGroupService.getAllAssetGroup(vendorFilter, 0, 10).subscribe((result:any) => {
        const assetList = result && result.data && result.data.data ? result.data.data : [];
        const exactMatch = assetList.find((item:any) => String(item.id) === String(assetId));
        this.vendorName = exactMatch ? (exactMatch.vendor_name || exactMatch.vendor_title || '') : '';
      });
    }

    onCreateNew(){

        if(this.roleAsses.assetGroupCreate == true){

               this.editCreate = true;

        }

        this.isCreateNewShow = false;

    }

    editCreate:boolean = false;
    onLoad(id) {

        this.start = 0;
        this.id = id;
        if(this.id != 'null' && this.roleAsses.assetGroupEdit == true){

            this.editCreate = true;
            this.isCreateNewShow = false;

        }else{

            // this.editCreate = false;

        }
        this.getCastInfo();

        this.mapCertificatList=[];
        this.mapProductTypeArrayTemp = [];
        this.mapMenuCategoryArrayTemp = [];
        this.mapPrimaryNavigationArrayTemp = [];
        this.trailerVideoList = [];
        this.start = 0;
        this.startProduct = 0;
        this.startCategory = 0;
        this.startCharacter = 0;
        this.startReview = 0;
        this.startClassification = 0;
        this.startSponsored = 0;

        this.productScrollCount = 0;

        this.onAssetInfoTabClick();

        this.classificationScrollCount = 0;

        this.reviewScrollCount =0

        this.startReview = 0;

        this.settings = {

            singleSelection: false,
            text:"Select",
            selectAllText:'Select All',
            unSelectAllText:'UnSelect All',
            enableSearchFilter: true,
            // searchBy: ['name'],
            // lazyLoading: true,
            classes:"myclass custom-class"
        }

        this.characterScrollCount = 0;

        this.getGlobalCharacter();

        let headerTitle = {
            title:'Asset Management',
            subTitle:'Asset Group (Series Setup)'

        }

        this.commonService.changeHeaderTitle(headerTitle);

        this.onAssetInfoTabClick();

        // this.activatedRoute.params.subscribe(params => {
            // this.id = +params['id']; // (+) converts string 'id' to a number
            // this.langId = +params['langId']? +params['langId'] :"1";

            this.id = id;

            // if(localStorage.getItem("languageId")!= null){

            //     this.langId =localStorage.getItem("languageId");

            // }else {

            //     this.langId = "1";

            // }

            this.langId = "1";

            this.mapcastDynamicForm = this.formBuilder.group({
                mapcasts: this.formBuilder.array([this.createcast()])
            });

       //New Code start
            if(this.id!='null'){
            console.log('this.id===>>>',this.id);

                this.update=true;
                this.getAssetGroupInfo(this.id)
            }else{
                this.img.push({
                    horizontalURL:'',
                    verticalURL:''
                })
                this.imgPlain.push({
                    verticalPlainURL:''
                })

                let objH = {
                    'index':"",
                    'deviceType':"",
                    'selectedFiles':"",
                    "horizontalFileName": "",
                    "horizontalFilePath": "",
                    "horizontalFileType": "",
                    'horizontalFile':false
                }

                let objV = {
                    'index':"",
                    'deviceType':"",
                    'selectedFiles':"",
                    "verticalFileName":"",
                    "verticalFilePath": "",
                    "verticalFileType":"",
                    'verticalFile':false,

                }

                let objVPlain = {
                    'index':"",
                    'deviceType':"",
                    'selectedFiles':"",
                    "verticalFileNamePlain":"",
                    "verticalFilePathPlain": "",
                    "verticalFileTypePlain":"",
                    'verticalFilePlain':false,
                }

                this.uploadImgFilePathHorizontal.push(objH);
                this.uploadImgFilePathVertical.push(objV);
                this.uploadImgFilePathVerticalPlain.push(objVPlain);
            }
            //New Code end

        // In a real app: dispatch action to load the details here.
        // });

        //pravin start code
        this.multipleDeviceForm = this.formBuilder.group({
            devices: this.formBuilder.array([this.createItem()])
        });

        this.createAssetGroupForm = this.formBuilder.group({
            id:[""],
            assetGroupType : [""],
            contentType :[""],
            isActive : ["1"],
            langId: [this.langId],
            companyId : [""],
            isVisible:[''],
            title :["",Validators.required],
            displayIndexing :[""],
            permaLink:[''],
            productionYear:[''],
            sameForAllZone : [''],
            sameForAllProductType : [''],
            airStartDate : [''],
            airEndDate : [""],
            airStartTime:[''],
            airEndTime:[''],
            exclusionText : [""],
            description : [""],
            seconddescription : [""],
            mapTrailerVideo : [""],
            trailerUrl : [""],
            previewUrl : [""],
            seoTitle : [""],
            seoKeyword : [""],
            seoDescription : [""],
            orderBy : [""],
            sorting : [""],
            mapGeoZone:[[]],
            langMetadata:[[]],
            productDeviceTypeConfigure:[[]],
            mapProductType:[[]],
            mapPrimaryNavigation:[[]],
            mapMenuCategory:[[]],
            mapCertification:[[]],
            mapClassification:[[]],
            mapCast:[[]],
            mapGenre:[[]],
            mapCharacter:[[]],
            vodOrLivePosterImageFileName: [''],
            vodOrLivePosterImageFilePath: [''],
            vodOrLivePosterImageFileType:[''],
            TitleImageFileName: [''],
            ThumbnailImage: [''],
            TitleImageFileType:[''],
            marketingBannerFileName: [''],
            marketingBannerFilePath: [''],
            // mapAssetLibrary:[[]],
            mapLibrary:[[]],
            mapLanguage:[[]],
            audioLanguage:[[]],
            subtitleLanguage:[[]],
            mapSponsor:[[]],
            mapReview:[[]],
            contentState:['In-Progress'],
            publisherState:['Un-published'],
            reviewerState:['Un-approved'],
            created_by:[localStorage.getItem('ud')],
            coinsType: ['uniform', Validators.required],
            coinsToRedeem: [0, [Validators.required, Validators.min(0)]]

        })

        this.menuCategorySettings = {

            singleSelection: false,
            text:"Select",
            selectAllText:'Select All',
            unSelectAllText:'UnSelect All',
            enableSearchFilter: true,
            classes:"myclass custom-class",
            searchBy: ['name'],
            maxHeight:130,
            lazyLoading: true

        }

        this.mapCastSettings = {
            singleSelection: true,
            text:"Select",
            selectAllText:'Select All',
            unSelectAllText:'UnSelect All',
            enableSearchFilter: true,
            classes:"myclass custom-class",
            searchBy: ['name'],
            maxHeight:160,
            minHeight:30,
            lazyLoading: true
        }
        console.log(this.mapCastSettings)
        this.trailerVideoVirtualSettings = {
            singleSelection: true,
            text:"Select",
            selectAllText:'Select All',
            unSelectAllText:'UnSelect All',
            enableSearchFilter: true,
            classes:"myclass custom-class",
            searchBy: ['name'],
            maxHeight:140,
            minHeight:30,
            lazyLoading: true,
        }

        this.settings = {

            singleSelection: false,
            text:"Select",
            selectAllText:'Select All',
            maxHeight:140,
            enableSearchFilter: true,
            unSelectAllText:'UnSelect All',
            classes:"myclass custom-class",
            searchBy: ['name'],
            lazyLoading: true,
        }

        this.productTypeMappingFilter.geoZoneId = [];
        this.primaryNavigationMappingFilter.productTypeId = [];
        this.menuCategoryMappingFilter.primaryNavigationId = [];

        this.getGeoZoneInfo({});

        // this.getProductTypeInfo(this.productTypeMappingFilter);
        // this.getNavigationInfo(this.primaryNavigationMappingFilter);
        // this.getGlobalMenuCategory(this.menuCategoryMappingFilter);
        this.getGlobaltrailervideo();
        this.getGenreInfo();
        this.getCertificate({});
        this.getLibrary();
        this.getCastInfo();
        this.getLanguageInfo();
        this.getAudioLanguageInfo();
        this.getSubtitleLanguageInfo();
        this.getSponsoreInfo({});
        this.getGlobalReviewInfo({});
        this.getGlobalclassification({});


    }

    get l() { return this.createAssetGroupForm.controls; }

    get m(): FormArray {
        return this.multipleDeviceForm.get('devices') as FormArray;
    }

    onItemSelect(item:any, mappingName){


        if(mappingName == 'mapGeoZone'){

            this.productTypeMappingFilter.geoZoneId.push(item.id);
            this.productTypeMappingFilter.geoZoneId.filter((item, index) => this.productTypeMappingFilter.geoZoneId.indexOf(this.productTypeMappingFilter.geoZoneId) === index);

            this.startProduct = 0;
            this.producTypeList = [];
            this.getProductTypeInfo(this.productTypeMappingFilter);

        }

        else if(mappingName == 'mapProductType'){

            this.primaryNavigationMappingFilter.productTypeId.push(item.id);
            this.primaryNavigationMappingFilter.productTypeId.filter((item, index) => this.primaryNavigationMappingFilter.productTypeId.indexOf(this.primaryNavigationMappingFilter.productTypeId) === index);

            this.startPrimary = 0;
            this.primaryNavigationList = [];
            this.getNavigationInfo(this.primaryNavigationMappingFilter);

        }

        else if(mappingName == 'mapPrimaryNavigation'){

            // this.selectedprimaryNavigationList.push(item);
            this.menuCategoryMappingFilter.primaryNavigationId.push(item.id);
            this.menuCategoryMappingFilter.primaryNavigationId.filter((item, index) => this.menuCategoryMappingFilter.primaryNavigationId.indexOf(item) === index);

            this.startCategory = 0;
            this.menuCategoryList = [];

            this.getGlobalMenuCategory(this.menuCategoryMappingFilter);

        }
    }

    OnItemDeSelect(item:any, mappingName){


        if(mappingName == 'mapGeoZone'){

            for (let index=0; index<this.productTypeMappingFilter.geoZoneId.length;index++){

                if(this.productTypeMappingFilter.geoZoneId[index] == item.id){

                    this.productTypeMappingFilter.geoZoneId.splice(index, 1);

                    if(this.productTypeMappingFilter.geoZoneId.length == 0){

                        this.mapProductTypeArrayTemp = [];
                        this.mapMenuCategoryArrayTemp = [];
                        this.mapPrimaryNavigationArrayTemp = [];

                        this.createAssetGroupForm.controls['mapPrimaryNavigation'].setValue([]);
                        this.primaryNavigationList = [];

                        this.createAssetGroupForm.controls['mapMenuCategory'].setValue([]);
                        this.menuCategoryList = [];

                        this.createAssetGroupForm.controls['mapProductType'].setValue([]);
                        this.producTypeList = [];



                    }else{

                        this.startProduct = 0;

                        this.getProductTypeInfo(this.productTypeMappingFilter);

                    }


                }
            }
        } else if(mappingName == 'mapProductType'){

            console.log("this.primaryNavigationMappingFilter.productTypeId>>>",this.primaryNavigationMappingFilter.productTypeId);

            for (let index=0; index<this.primaryNavigationMappingFilter.productTypeId.length;index++){

                if(this.primaryNavigationMappingFilter.productTypeId[index] == item.id){

                    this.primaryNavigationMappingFilter.productTypeId.splice(index, 1);

                    if(this.primaryNavigationMappingFilter.productTypeId.length == 0){


                    }else{

                        this.getNavigationInfo(this.primaryNavigationMappingFilter);


                    }


                }
            }
        }
        else if(mappingName == 'mapPrimaryNavigation'){

            for (let index=0; index<this.menuCategoryMappingFilter.primaryNavigationId.length;index++){

                if(this.menuCategoryMappingFilter.primaryNavigationId[index] == item.id){

                    this.menuCategoryMappingFilter.primaryNavigationId.splice(index, 1);

                    if(this.menuCategoryMappingFilter.primaryNavigationId.length == 0){

                        this.createAssetGroupForm.controls['mapMenuCategory'].setValue([]);
                        this.menuCategoryList = [];
                        this.mapMenuCategoryArrayTemp = [];



                    }else{

                        this.getGlobalMenuCategory(this.menuCategoryMappingFilter);


                    }

                }
            }
        }
    }

    onSelectAll(item:any, mappingName){


        if(mappingName == 'mapGeoZone'){
            let filterObj ={ geoZoneId :[] };
            item.forEach(function (value) {
                filterObj.geoZoneId.push(value.id);
            });
            this.productTypeMappingFilter = filterObj;
            this.getProductTypeInfo(filterObj);
        }
        else if(mappingName == 'mapProductType'){
            let filterObj ={ productTypeId :[] };
            item.forEach(function (value) {
                filterObj.productTypeId.push(value.id);
            });
            this.primaryNavigationMappingFilter = filterObj;
            this.startPrimary = 0;
            this.getNavigationInfo(filterObj);
        }
        else if(mappingName == 'mapPrimaryNavigation'){
            let filterObj ={ primaryNavigationId :[] };
            item.forEach(function (value) {
                filterObj.primaryNavigationId.push(value.id);
            });
            this.menuCategoryMappingFilter= filterObj;
            this.getGlobalMenuCategory(filterObj);
        }
    }

    onDeSelectAll(event, info){

        if(info =='mapGeoZone'){

            this.createAssetGroupForm.controls['mapGeoZone'].setValue([]);
            this.productTypeMappingFilter.geoZoneId=[];
            this.producTypeList = [];
            this.mapProductTypeArrayTemp=[];

            this.createAssetGroupForm.controls['mapProductType'].setValue([]);
            this.primaryNavigationMappingFilter.primaryNavigationId = [];
            this.primaryNavigationList = [];
            this.mapProductTypeArrayTemp =[];

            this.createAssetGroupForm.controls['mapPrimaryNavigation'].setValue([]);
            this.menuCategoryMappingFilter.menuCategoryId = [];
            this.menuCategoryList = [];
            this.mapPrimaryNavigationArrayTemp=[];


            this.mapProductTypeArrayTemp = [];
            this.mapMenuCategoryArrayTemp = [];
            this.mapPrimaryNavigationArrayTemp = [];


            this.createAssetGroupForm.controls['mapMenuCategory'].setValue([]);
            this.menuCategoryList = [];

            console.log("DeSelect All from = ",info);

        }
        else if(info =='mapProductType'){

            this.createAssetGroupForm.controls['mapProductType'].setValue([]);
            this.mapMenuCategoryArrayTemp = [];
            // this.producTypeList = [];
            this.mapProductTypeArrayTemp =[];


            this.createAssetGroupForm.controls['mapMenuCategory'].setValue([]);
            this.mapMenuCategoryArrayTemp = [];
            this.menuCategoryList = [];
            this.mapPrimaryNavigationArrayTemp=[];


            this.createAssetGroupForm.controls['mapPrimaryNavigation'].setValue([]);
            this.mapPrimaryNavigationArrayTemp = [];
            this.primaryNavigationList = [];

        }
        else if(info =='mapPrimaryNavigation'){

            this.createAssetGroupForm.controls['mapPrimaryNavigation'].setValue([]);
            this.mapPrimaryNavigationArrayTemp = [];
            // this.primaryNavigationList = [];

            this.createAssetGroupForm.controls['mapMenuCategory'].setValue([]);
            this.mapMenuCategoryArrayTemp = [];
            this.menuCategoryList = [];


        }
        else if(info =='mapMenuCategory'){

            this.createAssetGroupForm.controls['mapMenuCategory'].setValue([]);
            this.mapMenuCategoryArrayTemp = [];

        }
        else if(info =='mapClassification'){
            this.createAssetGroupForm.controls['mapClassification'].setValue([]);
        }
        else if(info =='mapCertification'){
            this.createAssetGroupForm.controls['mapCertification'].setValue([]);
        }
        else if(info =='mapLibrary'){
            this.createAssetGroupForm.controls['mapLibrary'].setValue([]);
        }
        else if(info =='mapGenre'){
            this.createAssetGroupForm.controls['mapGenre'].setValue([]);
        }
        else if(info =='mapLanguage'){
            this.createAssetGroupForm.controls['mapLanguage'].setValue([]);
        }
        else if(info =='audioLanguage'){
            this.createAssetGroupForm.controls['audioLanguage'].setValue([]);
        }
        else if(info =='subtitleLanguage'){
            this.createAssetGroupForm.controls['subtitleLanguage'].setValue([]);
        }
        else if(info =='mapSponsor'){
            this.createAssetGroupForm.controls['mapSponsor'].setValue([]);
        }
        else if(info =='mapReview'){
            this.createAssetGroupForm.controls['mapReview'].setValue([]);
        }
        else if(info =='mapCast'){
            this.createAssetGroupForm.controls['mapCast'].setValue([]);
        }
        else if(info =='mapCharacter'){
            this.createAssetGroupForm.controls['mapCharacter'].setValue([]);
        }
    }

    onCoinsTypeChange(type: string) {
        // Reset coins to redeem value when changing type
        if (type === 'uniform') {
            this.createAssetGroupForm.controls['coinsToRedeem'].setValue(0);
        } else if (type === 'incremental') {
            this.createAssetGroupForm.controls['coinsToRedeem'].setValue(0);
        }
    }

    getGlobalclassification(obj){

    //s    this.commonService.changeloader(true);
       // this.classificationFilter = obj;

        this.commonService.getglobalclassification(this.classificationFilter,this.startClassification,10).subscribe((result:any)=>{

          //  this.mapClassificationList = [];
        //  this.commonService.changeloader(false);

         // this.mapReviewList = [];
         this.searchDecouncer$.next(null);


            if(result.data.data.length > 0){

                if(this.isSearch == true){

                    this.isSearch = false;
                   this.mapClassificationList = [];

                }

                this.classificationInfoObj.pageCount == result.data.data.pageCount;

                for (let menuCategoryList of result.data.data) {

                    if(menuCategoryList.classificationId!=''){

                        this.mapClassificationList.push(
                        {
                            'id': menuCategoryList.classificationId,
                            'itemName': menuCategoryList.classificationName
                        });

                        this.mapClassificationList = this.removeDuplicates(this.mapClassificationList, "id");

                    }
                }
            }

        });

    }

    fetchMoreGetClassification(event){

        if ((event.endIndex >= this.mapClassificationList.length - 3)&& (this.mapClassificationList.length >= 8)) {

            //  this.classificationScrollCount ++;

            // if(this.classificationScrollCount <= this.classificationInfoObj.pageCount)   {

                this.startClassification = this.startClassification + 10;

                this.getGlobalclassification(this.classificationFilter);
            // }

        }

    }

    //pravin code start
    getGeoZoneInfo(obj){

        // if(this.isSearch)
        //  this.commonService.changeloader(true);

            this.productConfigurationService.getAllGeoZone(obj,this.start,10)
            .subscribe((result:any)=>{
                this.searchDecouncer$.next(null);

            //    this.dropdownList = [];

                this.commonService.changeloader(false);

                if(this.isSearch == true){
                    this.start = 0;
                    this.isSearch = false;
                    this.geoZoneList = [];
                }

                if(result.data.data.length > 0){

                    this.dropdownList = result.data.data;

                    for (let geoZoneObj of this.dropdownList) {
                        this.geoZoneList.push(
                        {
                            'id': geoZoneObj.geoZoneId,
                            'itemName': geoZoneObj.geoZoneName
                        });

                    }

                    this.geoZoneList = this.removeDuplicates(this.geoZoneList, "id");

                }

            })
    }

    fetchMoreGetGeoZone(event){

    if ((event.endIndex >= this.geoZoneList.length - 1) && (this.geoZoneList.length>=9)) {

         this.start = this.start + 10;

         this.getGeoZoneInfo(this.geoZoneObj);

        }

    }
    //////////////////


    getProductTypeInfo(filterObj){

      this.commonService.getGlobalProductType(filterObj,this.startProduct,10)
      .subscribe((result:any)=>{

          this.searchDecouncer$.next(null);


          this.ProducTypeDropdownList = [];
          this.commonService.changeloader(false);
          // let mapProductTypeArrayTemp = [];
         // this.mapProductTypeArrayTemp = [];
          // this.producTypeList = [];

          let mapProductTypeArray = this.createAssetGroupForm.value.mapProductType;

          if(result.data.data.length > 0){

              this.initProductType = false;

              this.productInfoObj.pageCount = result.data.data.pageCount;

              if(this.isSearch == true){

                  this.isSearch = false;
                  this.producTypeList = [];

              }

              // this.primaryNavigationMappingFilter.productTypeId = [];
              this.ProducTypeDropdownList = result.data.data;
              let asyc = result.data.data.length;

              for (let ProducTypeLists of this.ProducTypeDropdownList) {

                  asyc--;

                  mapProductTypeArray.forEach(element => {

                      if(element.id == ProducTypeLists.productTypeId) {

                          this.mapProductTypeArrayTemp.push(element);
                          this.primaryNavigationMappingFilter.productTypeId.push(element.id);
                          this.mapProductTypeArrayTemp = this.removeDuplicates(this.mapProductTypeArrayTemp, "id");

                      }

                  });


                  if(ProducTypeLists.productTypeName!=''){

                      this.producTypeList.push(
                          {
                              'id': ProducTypeLists.productTypeId,
                              'itemName': ProducTypeLists.productTypeName
                          });

                  }

                  this.producTypeList = this.removeDuplicates(this.producTypeList, "id");

              }

             if(asyc == 0){


                  // for (let ProducTypeLists of this.producTypeList) {

                  //     mapProductTypeArray.forEach(element => {

                  //         if(element.id == ProducTypeLists.id) {
                  //             mapProductTypeArrayTemp.push(element);
                  //             this.primaryNavigationMappingFilter.productTypeId.push(element.id);
                  //         }
                  //         this.createAssetGroupForm.controls['mapProductType'].setValue(mapProductTypeArrayTemp);

                  //     });
                  // }

                  this.createAssetGroupForm.controls['mapProductType'].setValue(this.mapProductTypeArrayTemp);


                 if(this.mapProductTypeArrayTemp.length == 0){

                  this.createAssetGroupForm.controls['mapPrimaryNavigation'].setValue([]);
                  this.primaryNavigationList = [];

                  this.createAssetGroupForm.controls['mapMenuCategory'].setValue([]);
                  this.menuCategoryList = [];

                 }else {

                  this.getNavigationInfo(this.primaryNavigationMappingFilter);

                 }

             }

          }else{

              if(this.initProductType = false && this.isSearch == false){

                         this.createAssetGroupForm.controls['mapProductType'].setValue([]);
                         this.producTypeList = [];

                          this.createAssetGroupForm.controls['mapPrimaryNavigation'].setValue([]);
                          this.primaryNavigationList = [];

                          this.createAssetGroupForm.controls['mapMenuCategory'].setValue([]);
                          this.menuCategoryList = [];
              }

          }
      });


}


    fetchMoreGetProductType(event){

        if(this.productInfoObj.pageCount == undefined){

            this.productInfoObj.pageCount = 0;

        }

        if ((event.endIndex == this.producTypeList.length - 1) && (this.producTypeList.length>=8)) {

                this.startProduct = this.startProduct + 10;
                console.log("in");

                this.getProductTypeInfo(this.productTypeMappingFilter);

         }

    }
    ///////////////

    getNavigationInfo(filterObj){


        // if(this.isSearch == true)
        //    this.commonService.changeloader(true);


        this.commonService.getGlobalPrimaryNavigation(filterObj,this.startPrimary,10).subscribe((result:any)=>{

         //   this.primaryNavigationList = [];
            // let mapPrimaryNavigationArrayTemp = [];
           // this.mapPrimaryNavigationArrayTemp = [];

           // this.primaryNavigationList = [];

               this.searchDecouncer$.next(null);


            let mapPrimaryNavigationArray = this.createAssetGroupForm.value.mapPrimaryNavigation;
            let asyc = result.data.data.length;


            if(result.data.data.length > 0){

                if(this.isSearch == true){

                    this.loader =false;

                    this.isSearch = false;

                    this.primaryNavigationList = [];
                }

              //  this.menuCategoryMappingFilter.primaryNavigationId = [];

                for (let primaryNavigationLists of result.data.data) {

                    asyc --;
                    mapPrimaryNavigationArray.forEach(element => {
                        if(element.id == primaryNavigationLists.primaryNavigationId) {

                            this.mapPrimaryNavigationArrayTemp.push(element);
                            this.menuCategoryMappingFilter.primaryNavigationId.push(element.id);
                            this.mapPrimaryNavigationArrayTemp = this.removeDuplicates(this.mapPrimaryNavigationArrayTemp, "id");


                        }
                    });

                    if(primaryNavigationLists.primanyNavigationName!=''){
                       this.primaryNavigationList.push(
                        {
                            'id': primaryNavigationLists.primaryNavigationId,
                            'itemName': primaryNavigationLists.primanyNavigationName
                        });

                    }

                    this.primaryNavigationList = this.removeDuplicates(this.primaryNavigationList, "id");

                }


                 if(asyc == 0){

                    // this.createAssetGroupForm.controls['mapPrimaryNavigation'].setValue(this.mapPrimaryNavigationArrayTemp);

                    if(this.mapPrimaryNavigationArrayTemp.length == 0){

                        this.createAssetGroupForm.controls['mapMenuCategory'].setValue([]);
                        this.menuCategoryList = [];

                       }else {

                        this.getGlobalMenuCategory(this.menuCategoryMappingFilter);

                    }

                }

            }else {
            //    this.createAssetGroupForm.controls['mapPrimaryNavigation'].setValue([]);
            //    this.primaryNavigationList= [];

            //     this.createAssetGroupForm.controls['mapMenuCategory'].setValue([]);
            //     this.menuCategoryList = [];
            }
        })
    }

    fetchMoreGetPrimary(event){

        console.log("event=list-count",event.endIndex , this.primaryNavigationList.length ,this.SponsoredScrollCount)

        if ( ((event.endIndex >= this.primaryNavigationList.length - 2)) && (this.primaryNavigationList.length >=10)) {

                this.startPrimary = this.startPrimary + 10;

                this.getNavigationInfo(this.primaryNavigationMappingFilter);

        }

    }
    //////////////

    getGlobalMenuCategory(filterObj){

      //  this.commonService.changeloader(true);
        this.commonService.getGlobalMenuCategory(filterObj,this.startCategory,10).subscribe((result:any)=>{

           // let mapMenuCategoryArrayTemp = [];
          //  this.menuCategoryList = [];
            this.commonService.changeloader(false);
            this.searchDecouncer$.next(null);

            let mapMenuCategoryArray = this.createAssetGroupForm.value.mapMenuCategory;

            if(result.data.data.length > 0){

                    if(this.isSearch == true){

                        this.startCategory = 0;
                        this.menuCategoryList = [];
                        this.isSearch = false;

                    }

                    for (let menuCategoryList of result.data.data) {

                        mapMenuCategoryArray.forEach(element => {

                            if(element.id == menuCategoryList.menuCategoryId) {
                                this.mapMenuCategoryArrayTemp.push(element);
                                this.mapMenuCategoryArrayTemp = this.removeDuplicates(this.mapMenuCategoryArrayTemp, "id");

                            }
                        });

                        if(menuCategoryList.menuCategoryName!=''){

                            this.menuCategoryList.push(
                            {
                                'id': menuCategoryList.menuCategoryId,
                                'itemName': menuCategoryList.menuCategoryName
                            });
                        }

                        this.menuCategoryList = this.removeDuplicates(this.menuCategoryList, "id");

                    }

                this.createAssetGroupForm.controls['mapMenuCategory'].setValue(this.mapMenuCategoryArrayTemp);

            }

        });
    }

    fetchMoreGetCategory(event){

        if ( ((event.endIndex >= this.menuCategoryList.length - 2)) && (this.menuCategoryList.length >= 9)) {

                this.startCategory = this.startCategory + 10;

                this.getGlobalMenuCategory(this.menuCategoryMappingFilter);

        }
    }
    /////////////

    getLanguageInfo(){

        this.commonService.getGlobalLanguage(this.languageFilter, this.startLanguage,10).subscribe((result:any)=>{

            // this.mapLanguageList = [];

            if(result.data.data.length > 0){

                this.searchDecouncer$.next(null);

                if(this.isSearch == true){

                    this.isSearch = false;
                    this.mapLanguageList = [];

                }

                for (let menuCategoryList of result.data.data) {

                    if(menuCategoryList.languageId!=''){

                        this.mapLanguageList.push(
                        {
                            'id': menuCategoryList.languageId,
                            'itemName': menuCategoryList.languageName
                        });
                    }
                }

                this.mapLanguageList = this.removeDuplicates(this.mapLanguageList, "id");

            }

        });
    }

    getAudioLanguageInfo(){
        this.assetService.getAudioLanguage(this.audioLanguageFilter, this.startAudioLanguage, 10).subscribe((result:any)=>{
            let source = [];

            if(result && result.data && Array.isArray(result.data.data)){
                source = result.data.data;
            } else if(result && Array.isArray(result.data)){
                source = result.data;
            }

            if(!source.length){
                return;
            }

            let audioLanguageOptions = [];
            for(let i = 0; i < source.length; i++){
                const option = this.formatAudioLanguageOption(source[i], i + this.startAudioLanguage);
                if(option){
                    audioLanguageOptions.push(option);
                }
            }

            if(this.startAudioLanguage === 0){
                this.audioLanguageList = [];
            }
            this.audioLanguageList = this.removeDuplicates(this.audioLanguageList.concat(audioLanguageOptions), "id");

            if(this.createAssetGroupForm && this.createAssetGroupForm.controls['audioLanguage']){
                const selectedAudioLanguage = this.createAssetGroupForm.controls['audioLanguage'].value || [];
                if(Array.isArray(selectedAudioLanguage) && selectedAudioLanguage.length){
                    this.audioLanguageList = this.removeDuplicates(this.audioLanguageList.concat(selectedAudioLanguage), "id");
                }
            }
        });
    }

    getSubtitleLanguageInfo(){
        this.assetService.getAudioLanguage(this.subtitleLanguageFilter, this.startSubtitleLanguage, 10).subscribe((result:any)=>{
            let source = [];

            if(result && result.data && Array.isArray(result.data.data)){
                source = result.data.data;
            } else if(result && Array.isArray(result.data)){
                source = result.data;
            }

            if(!source.length){
                return;
            }

            let subtitleLanguageOptions = [];
            for(let i = 0; i < source.length; i++){
                const option = this.formatAudioLanguageOption(source[i], i + this.startSubtitleLanguage);
                if(option){
                    subtitleLanguageOptions.push(option);
                }
            }

            if(this.startSubtitleLanguage === 0){
                this.subtitleLanguageList = [];
            }
            this.subtitleLanguageList = this.removeDuplicates(this.subtitleLanguageList.concat(subtitleLanguageOptions), "id");

            if(this.createAssetGroupForm && this.createAssetGroupForm.controls['subtitleLanguage']){
                const selectedSubtitleLanguage = this.createAssetGroupForm.controls['subtitleLanguage'].value || [];
                if(Array.isArray(selectedSubtitleLanguage) && selectedSubtitleLanguage.length){
                    this.subtitleLanguageList = this.removeDuplicates(this.subtitleLanguageList.concat(selectedSubtitleLanguage), "id");
                }
            }
        });
    }

    fetchMoreGetLanguage(event){

        if ((event.endIndex == this.mapLanguageList.length - 1)&& (this.mapLanguageList.length >= 8)) {

            //  this.characterScrollCount ++;

            // if(this.characterScrollCount <= this.charcterInfoObj.pageCount)   {

                this.startLanguage = this.startLanguage + 10;
                this.getLanguageInfo();
            // }

        }
    }

    fetchMoreGetAudioLanguage(event){
        if((event.endIndex == this.audioLanguageList.length - 1) && (this.audioLanguageList.length >= 8)){
            this.startAudioLanguage = this.startAudioLanguage + 10;
            this.getAudioLanguageInfo();
        }
    }

    fetchMoreGetSubtitleLanguage(event){
        if((event.endIndex == this.subtitleLanguageList.length - 1) && (this.subtitleLanguageList.length >= 8)){
            this.startSubtitleLanguage = this.startSubtitleLanguage + 10;
            this.getSubtitleLanguageInfo();
        }
    }
    /////////////

    getSponsoreInfo(obj){

        // this.sponsoredFiter = obj;

        this.commonService.getGlobalSponsore(this.sponsoredFiter,this.startSponsored,10).subscribe((result:any)=>{

            this.searchDecouncer$.next(null);

         //   this.mapSponsoreList = [];

            if(result.data.data.length > 0){

                if(this.isSearch == true){

                    this.isSearch = false;
                    this.mapSponsoreList = [];
                }

                this.SponsoredInfoObj.pageCount = result.data.data.pageCount ;

                for (let mapSponsoreList of result.data.data) {

                        this.mapSponsoreList.push(
                        {
                            'id': mapSponsoreList.sponsorId,
                            'itemName': mapSponsoreList.sponsorName
                        });
                }



                this.mapSponsoreList = this.removeDuplicates(this.mapSponsoreList, "id");

            }

        });

    }

    fetchMoreGetSponsore(event){

        if ( ((event.endIndex == this.mapSponsoreList.length - 1)) && (this.mapSponsoreList.length >= 7)) {

            //  this.reviewScrollCount++;

            // if(this.reviewScrollCount <= this.reviewInfoObj.pageCount)   {

                this.startSponsored = this.startSponsored + 10;
                this.getSponsoreInfo(this.sponsoredFiter);
            // }

        }
    }
    ////////////////


    getGenreInfo(){

        this.commonService.getGlobalGenre(this.genreFilter,this.startGenre,10).subscribe((result:any)=>{

        //    this.mapGenreList = [];
        this.searchDecouncer$.next(null);

            if(result.data.data.length > 0){

                if(this.isSearch == true){

                    this.isSearch = false;
                    this.mapGenreList = [];

                }

                for (let ProducTypeLists of result.data.data) {

                    if(ProducTypeLists.productTypeName!=''){
                    this.mapGenreList.push(
                        {
                            'id': ProducTypeLists.genreId,
                            'itemName': ProducTypeLists.genreName
                        });
                    }
                }

                this.mapGenreList = this.removeDuplicates(this.mapGenreList, "id");

            }

        });
    }

    fetchMoreGetGenre(event){

        if ( ((event.endIndex == this.mapGenreList.length - 1)) && (this.mapGenreList.length >= 7)) {

                this.startGenre = this.startGenre + 10;

                this.getGenreInfo();
            // }

        }
    }
    ////////////

    getCertificate(obj){

        this.commonService.getGlobalCertification(this.certificateFilter,this.startCertificate,10).subscribe((result:any)=>{

            this.searchDecouncer$.next(null);

            if(result.data.data.length > 0){

                    if(this.isSearch == true){

                        this.isSearch = false;
                        this.mapCertificatList = [];

                    }
                    for (let ProducTypeLists of result.data.data) {

                        if(ProducTypeLists.productTypeName!=''){
                        this.mapCertificatList.push(
                            {
                                'id': ProducTypeLists.certificationId,
                                'itemName': ProducTypeLists.certificationName
                            });
                        }
                    }
                    this.mapCertificatList = this.removeDuplicates(this.mapCertificatList, "id");

            }

        });
    }

    fetchMoreGetCertificate(event){

        if ( ((event.endIndex == this.mapClassificationList.length - 1)) && (this.mapClassificationList.length >= 7)) {

                this.startClassification = this.startClassification + 10;

                this.getCertificate({});


        }

    }
    /////////////


    getLibrary(){

        this.commonService.getglobalLibrary(this.libraryFilter,this.startLibrary,10).subscribe((result:any)=>{

            this.searchDecouncer$.next(null);

            if(result.data.data.length > 0){

                if(this.isSearch == true){

                    this.isSearch = false;
                    this.mapLibraryList = [];

                }

                for (let ProducTypeLists of result.data.data) {

                    if(ProducTypeLists.libraryId!=''){
                    this.mapLibraryList.push(
                        {
                            'id': ProducTypeLists.libraryId,
                            'itemName': ProducTypeLists.libraryName
                        });
                    }
                }

                this.mapLibraryList = this.removeDuplicates(this.mapLibraryList, "id");

            }
        });

    }

    fetchMoreGetlibrary(event){

        if ( ((event.endIndex == this.mapLibraryList.length - 1)) && (this.mapLibraryList.length >= 9)) {

                // this.reviewScrollCount++;

                this.startLibrary = this.startLibrary + 10;

                this.getLibrary();

        }

    }
    ////////////////


    getGlobalReviewInfo(obj){

        this.commonService.getGlobalReview(this.reviewFilter,this.startReview,10).subscribe((result:any)=>{

            this.searchDecouncer$.next(null);

            if(result.data.data.length > 0){

                if(this.isSearch == true){

                    this.isSearch = false;
                    this.mapReviewList = [];

                }

                for (let ProducTypeLists of result.data.data) {

                    this.mapReviewList.push(
                        {
                            'id': ProducTypeLists.reviewId,
                            'itemName': ProducTypeLists.reviewFirstName
                        });

                }

                this.mapReviewList = this.removeDuplicates(this.mapReviewList, "id");

            }
        });
    }

    fetchMoreGetReviews(event){

        // console.log("event=list-count",event.endIndex , this.mapReviewList.length ,this.reviewScrollCount)

        if ( ((event.endIndex == this.mapReviewList.length - 1)) && (this.mapReviewList.length >= 7)) {

            // if(this.reviewScrollCount <= this.reviewInfoObj.pageCount)   {

                this.startReview = this.startReview + 10;

                this.getGlobalReviewInfo({});
            // }

        }

    }
    /////////////////

    characterFilter:any={};

    getGlobalCharacter(){

        this.commonService.getGlobalCharacter(this.characterFilter,this.startCharacter,10).subscribe((result:any)=>{

           // this.mapCharacterList = [];
           this.searchDecouncer$.next(null);


            if(result.data.data.length > 0){

                if(this.isSearch == true){

                    this.isSearch = false;
                    this.mapCharacterList = [];
                }

                this.charcterInfoObj.pageCount = result.data.data.pageCount;

                for (let CharacterLists of result.data.data) {

                    // if(CharacterLists.characterFirstName!=''){
                    this.mapCharacterList.push(
                        {
                            'id': CharacterLists.characterId,
                            'itemName': CharacterLists.characterFirstName
                        });
                    // }
                }

                this.mapCharacterList = this.removeDuplicates(this.mapCharacterList, "id");

            }
        });
    }

    fetchMoreGetCharacter(event){

        if ( ((event.endIndex == this.mapCharacterList.length - 1)) && (this.mapCharacterList.length >= 9)) {

            this.startCharacter = this.startCharacter + 10;

            this.getGlobalCharacter();

       }
    }


    eventValue:any='fr';

    onSearch(event, info){

        if(this.eventValue == '' && event.target.value == '')
        return;

        this.eventValue = event.target.value;
        this.activeSearchBox = info;
        var obj = {};
        this.isSearch = true;


        if(info == 'trailer'){

            if(event.target.value!=''){

                this.filterTrailer =  obj = { 'assetName': event.target.value };
                // this.trailerVideoList = [];

            }else {
                // this.mapClassificationList=[];
                this.filterTrailer =   obj = { }
            }

            this.startTrailer = 0;

            this.searchDecouncer$.next(event.target.value);

        }

        if(info == 'cast'){

            if(event.target.value!=''){
                obj = { 'castFirstName': event.target.value };
                this.startCast = 0;
                this.mapCastList = [];
                this.castFilter = obj ;

                this.searchDecouncer$.next(event.target.value);

            }else {

                obj = { };
                this.castFilter = obj ;
                this.mapCastList = [];
                this.startCast = 0;

                this.searchDecouncer$.next(event.target.value);

            }
        }

        if(info == 'character'){

            if(event.target.value!=''){

                obj = { 'characterFirstName': event.target.value };
                this.startCharacter = 0;
                this.mapCharacterList = [];
                this.characterFilter = {} ;
                this.characterFilter = obj;
                // this.characterFilter = {};
                this.searchDecouncer$.next(event.target.value);

            }else {

                obj = { };
                this.characterFilter = obj ;
                this.mapCharacterList = [];
                this.startCharacter = 0;
                this.searchDecouncer$.next(event.target.value);

            }

        }

        if(info == 'classification'){


            if(event.target.value!=''){

                this.classificationFilter =  obj = { 'classificationName': event.target.value };
                // this.classificationFilter = obj = { };
                this.mapClassificationList=[];


            }else {
                this.mapClassificationList=[];
                this.classificationFilter =   obj = { }
            }

            this.startClassification = 0;
            this.classificationScrollCount = 0;

            this.searchDecouncer$.next(event.target.value);

        }

        if(info == 'review'){

            if(event.target.value!=''){

               this.reviewFilter = obj = { 'reviewFirstName': event.target.value };
            //    this.reviewFilter = obj = { }
            this.mapReviewList = [];


            }else {

                this.mapReviewList = [];
                this.reviewFilter = obj = { }
            }

            this.startReview = 0;
            this.reviewScrollCount = 0;

            this.searchDecouncer$.next(event.target.value);

        }

        if(info == 'genre'){

            if(event.target.value!=''){

               this.genreFilter = obj = { 'genreName': event.target.value };
            //    this.genreFilter = obj = { }

            this.mapGenreList= [];


            }else {

                this.genreFilter = obj = { };
                this.mapGenreList= [];
            }

            this.startGenre = 0;
            this.reviewScrollCount = 0;

            this.searchDecouncer$.next(event.target.value);

        }

        if(info == 'sponsore'){


            if(event.target.value!=''){

                this.sponsoredFiter = obj = { 'sponsorName': event.target.value };
                this.mapSponsoreList = [];

            }else {

                this.sponsoredFiter =  obj = { }
            }

            this.startSponsored = 0;
            this.SponsoredScrollCount = 0;

            this.mapSponsoreList = [];


            // setTimeout(()=>{

            //     this.getSponsoreInfo(obj);

            //  },200)

            this.searchDecouncer$.next(event.target.value);



        }

        if(info == 'language'){

            if(event.target.value!=''){

                this.languageFilter =  obj = { 'languageName': event.target.value };
                this
                this.mapLibraryList=[];
                // this.languageFilter =  obj = { }


            }else {
                this.mapLibraryList=[];
                this.languageFilter =  obj = { }
            }

            this.startLanguage = 0;
            this.SponsoredScrollCount = 0;
            // setTimeout(()=>{

            //     this.getLanguageInfo();

            //  },200)on

            this.searchDecouncer$.next(event.target.value);
        }

        if(info == 'library'){

            if(event.target.value!=''){

                 this.libraryFilter =  obj = { 'libraryName': event.target.value };
                 this.mapLibraryList = [];
                // this.libraryFilter =  obj = { }


            }else {

                this.libraryFilter =  obj = { };
                this.mapLibraryList = [];
            }

            this.startClassification = 0;
            this.SponsoredScrollCount = 0;

            this.searchDecouncer$.next(event.target.value);
        }

        if(info == 'certification'){

            if(event.target.value!=''){

                obj = { 'certificationName': event.target.value };
                this.mapCertificatList=[];
                this.certificateFilter = obj;
                this.startCertificate = 0;

                this.searchDecouncer$.next(event.target.value);


            }else {

                this.certificateFilter = obj = { };
            }

            this.startCertificate = 0;
            this.certificateFilter = obj ;

            this.mapCertificatList=[];
            // setTimeout(()=>{

            //     this.getCertificate(obj);

            //  },200)

            this.searchDecouncer$.next(event.target.value);
        }

        if(info == 'geoZone'){


            if(event.target.value!=''){

                obj = { 'keyword': event.target.value };
                this.start = 0;
                this.geoZoneList = [];
                this.geoZoneObj = obj ;

                this.searchDecouncer$.next(event.target.value);


            }else {

                obj = { };
                this.geoZoneObj = obj ;
                this.geoZoneList = [];
                this.start = 0;

                this.searchDecouncer$.next(event.target.value);
            }

        }

        if(info == 'productType'){

            console.log("producttype",event);

            if(event.target.value!=''){

                this.productTypeMappingFilter.productTypeName = event.target.value;
                this.producTypeList = [];
                this.startProduct = 0;
                this.productScrollCount = 0;
               // this.subject.next(event.target.value);
               this.searchDecouncer$.next(event.target.value);
                //this.getProductTypeInfo(this.productTypeMappingFilter);


            }else {

                delete this.productTypeMappingFilter.productTypeName;
                this.producTypeList = [];
                this.startProduct = 0;
                this.productScrollCount = 0;
                // this.subject.next(event.target.value);
                this.searchDecouncer$.next(event.target.value);
                //  this.getProductTypeInfo(this.productTypeMappingFilter);

            }


        }

        if(info == 'navigation'){

            if(event.target.value!=''){

                this.primaryNavigationMappingFilter.primanyNavigationName = event.target.value;
                this.primaryNavigationList = [];
                this.startPrimary = 0;
                this.searchDecouncer$.next(event.target.value);

            }else {

                delete this.primaryNavigationMappingFilter.primanyNavigationName;
                this.primaryNavigationList = [];
                this.startPrimary = 0;
                // this.getNavigationInfo(this.primaryNavigationMappingFilter);
                this.searchDecouncer$.next(event.target.value);


            }

        }

        if(info == 'category'){

            if(event.target.value!=''){

                   this.menuCategoryMappingFilter.menuCategoryName = event.target.value;
                   this.menuCategoryList = [];
                   this.startCategory = 0;
                   //this.getGlobalMenuCategory(this.menuCategoryMappingFilter);
                   this.searchDecouncer$.next(event.target.value);

            }else {

                delete this.menuCategoryMappingFilter.menuCategoryName;
                this.menuCategoryList = [];
                this.startCategory = 0;
                // this.getGlobalMenuCategory(this.menuCategoryMappingFilter);
                this.searchDecouncer$.next(event.target.value);


            }

        }

    }
       onOpen(info){

        this.activeSearchBox = info;


         if(this.activeSearchBox == 'character'){

             this.mapCharacterList=[];
             this.characterFilter={};
             this.startCharacter = 0;
             this.getGlobalCharacter();

         }

         if(this.activeSearchBox == 'cast'){

             this.castFilter = {};
             this.mapCastList = [];
             this.startCast = 0;
             this.getCastInfo();

         }

         if(this.activeSearchBox == 'classification'){

                 this.classificationFilter={};
                 this.mapClassificationList=[];
                 this.startClassification = 0;
                 this.getGlobalclassification(this.classificationFilter);

         }

         if(this.activeSearchBox == 'review'){

                 this.reviewFilter={};
                 this.mapReviewList = [];
                 this.startReview = 0;
                 this.getGlobalReviewInfo(this.reviewFilter);

         }

         if(this.activeSearchBox =='genre'){

                 this.genreFilter = {};
                 this.mapGenreList = [];
                 this.startGenre=0;
                 this.getGenreInfo();

         }

         if(this.activeSearchBox == 'sponsore'){

                this.sponsoredFiter = {};
                this.mapSponsoreList = [];
                this.startSponsored = 0;
                 this.getSponsoreInfo(this.sponsoredFiter);

         }

         if(this.activeSearchBox == 'language'){


             this.languageFilter ={};
             this.mapLanguageList = [];
             this.startLanguage = 0;
             this.getLanguageInfo();

         }

         if(this.activeSearchBox == 'audioLanguage'){
             this.audioLanguageFilter = {};
             this.audioLanguageList = [];
             this.startAudioLanguage = 0;
             this.getAudioLanguageInfo();
         }

         if(this.activeSearchBox == 'subtitleLanguage'){
             this.subtitleLanguageFilter = {};
             this.subtitleLanguageList = [];
             this.startSubtitleLanguage = 0;
             this.getSubtitleLanguageInfo();
         }

         if(this.activeSearchBox == 'library'){

                this.libraryFilter = {};
                this.mapLibraryList = [];
                this.startLibrary = 0;
                 this.getLibrary();
         }

         if(this.activeSearchBox == 'certification'){

             this.mapCertificatList = [];
             this.certificateFilter = {};
             this.startCertificate = 0;

             this.getCertificate(this.certificateFilter);
         }

         if(this.activeSearchBox == 'geoZone'){

             this.geoZoneObj = {};
             this.geoZoneList = [];
             this.start = 0;
             this.getGeoZoneInfo(this.geoZoneObj);

         }

         if(this.activeSearchBox == 'productType'){

            var geoZoneId = this.productTypeMappingFilter.geoZoneId;
            this.productTypeMappingFilter ={};
            this.productTypeMappingFilter.geoZoneId = geoZoneId;
            this.startProduct= 0;
            this.producTypeList = [];
            this.getProductTypeInfo(this.productTypeMappingFilter);

         }

         if(this.activeSearchBox == 'navigation'){

            this.primaryNavigationMappingFilter.productTypeId = [];

            var productTypeId = this.primaryNavigationMappingFilter.productTypeId;

            if(productTypeId.length == 0){

                this.primaryNavigationMappingFilter.productTypeId = [];

            }else {

                this.primaryNavigationMappingFilter.productTypeId = productTypeId;

            }

            this.startPrimary = 0;
            this.startNaviagation = 0;
            this.primaryNavigationList=[];
            this.getNavigationInfo(this.primaryNavigationMappingFilter);

         }
         if(info == 'trailer'){

            this.trailerVideoList=[];
            this.startTrailer = 0;
            this.filterTrailer = {};
            this.getGlobaltrailervideo();

        }
        
         if(this.activeSearchBox == 'category'){

            this.menuCategoryMappingFilter.primaryNavigationId =  this.menuCategoryMappingFilter.primaryNavigationId.filter((item, index) => {
                return this.menuCategoryMappingFilter.primaryNavigationId.indexOf(item) === index
              });


                var primaryNavigationId = this.menuCategoryMappingFilter.primaryNavigationId;
                this.menuCategoryMappingFilter = {};
                this.menuCategoryMappingFilter.primaryNavigationId = primaryNavigationId;
                this.startCategory = 0;
                this.menuCategoryList = [];
                this.startCategory = 0;

             this.getGlobalMenuCategory(this.menuCategoryMappingFilter);

         }


      }

    private setupSearchDebouncer(): void {
        // Subscribe to `searchDecouncer$` values,
        // but pipe through `debounceTime` and `distinctUntilChanged`
        this.searchDecouncer$.pipe(
          debounceTime(1000),
          distinctUntilChanged(),
        ).subscribe((term: string) => {
            if(this.activeSearchBox == 'trailer') {
                this.getGlobaltrailervideo()
            }

            if(this.activeSearchBox == 'classification'){

                    this.getGlobalclassification(this.classificationFilter);

            }


            if(this.activeSearchBox == 'character'){

                this.getGlobalCharacter();

            }

            if(this.activeSearchBox == 'cast'){

                this.getCastInfo();

            }

            if(this.activeSearchBox == 'review'){

                    this.getGlobalReviewInfo(this.reviewFilter);

            }

            if(this.activeSearchBox =='genre'){

                    this.getGenreInfo();

            }

            if(this.activeSearchBox == 'sponsore'){

                    this.getSponsoreInfo(this.SponsoredInfoObj);

            }

            if(this.activeSearchBox == 'language'){

                    this.getLanguageInfo();

            }

            if(this.activeSearchBox == 'library'){

                    this.getLibrary();
            }

            if(this.activeSearchBox == 'certification'){


                 this.getCertificate(this.certificateFilter);
            }

            if(this.activeSearchBox == 'geoZone'){

                this.getGeoZoneInfo(this.geoZoneObj);

            }

            if(this.activeSearchBox == 'productType'){


                this.getProductTypeInfo(this.productTypeMappingFilter);

            }

            if(this.activeSearchBox == 'navigation'){

                this.getNavigationInfo(this.primaryNavigationMappingFilter);

            }

            if(this.activeSearchBox == 'category'){

                this.getGlobalMenuCategory(this.menuCategoryMappingFilter);

            }

        });
    }

    removeDuplicates(originalArray, prop) {

        var newArray = [];
        var lookupObject  = {};

        for(var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for(i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
            return newArray;
    }


    getGlobaltrailervideo(){

        this.commonService.getGlobalTrailerVideo(this.filterTrailer,this.startTrailer,10).subscribe((result:any)=>{

            // this.trailerVideoList = [];

            if(result.data.data.length > 0){

                this.searchDecouncer$.next(null);


                if(this.isSearch){

                    this.trailerVideoList = [];
                    this.isSearch = false;

                }

                for (let trailerVideoLists of result.data.data) {

                    if(trailerVideoLists.assetName!=null){

                        this.trailerVideoList.push(
                        {
                            'id': trailerVideoLists.assetId,
                            'itemName': trailerVideoLists.assetName
                        });

                    this.trailerVideoList = this.removeDuplicates(this.trailerVideoList, "itemName");

                    }
                }

                console.log("this.trailerVideoList>>",this.trailerVideoList);
            }

        });

    }

    fetchMoreGetTrailer(event){

        if ( ((event.endIndex == this.trailerVideoList.length - 1)) && (this.trailerVideoList.length >= 7)) {

                this.startTrailer = this.startTrailer + 10;

                this.getGlobaltrailervideo();


        }

    }
    fetchMoreGetLibrary(event){

        if ((event.endIndex == this.mapLibraryList.length - 1)&& (this.mapLibraryList.length >= 8)) {

            //  this.characterScrollCount ++;

            // if(this.characterScrollCount <= this.charcterInfoObj.pageCount)   {

                this.startLibrary = this.startLibrary + 10;
                this.getLibrary();
            // }

        }
    }

   //product type dropdown code end

    //Pravin code mulitple from
    createItem(): FormGroup {

        return this.formBuilder.group({
            label: [''],
            description: '',
            secondlabel: [''],
            isCarouselApplicable:'',
            trailerUrl:[''],
            previewUrl:[''],
            dtypeId:['4',Validators.required],
            isVisible:[''],
            thumbFileName: "",
            thumbFilePath: "",
            thumbFileType: "",
            verticalFileName: "",
            verticalFilePath: "",
            verticalFileType: "",
            verticalFileNamePlain: "",
            verticalFilePathPlain: "",
            verticalFileTypePlain: "",
            uploadVerticalImagePlain: "",
            horizontalFileName: "",
            horizontalFilePath: "",
            horizontalFileType: "",
            verticalFileName2: "",
            verticalFilePath2: "",
            verticalFileType2: "",
            verticalFileNamePlain2: "",
            verticalFilePathPlain2: "",
            verticalFileTypePlain2: "",
            uploadVerticalImagePlain2: "",
            horizontalFileName2: "",
            horizontalFilePath2: "",
            horizontalFileType2: "",
            vodOrLivePosterImageFilePath2: "",
            TitleFilePath2: "",
            thumbFilePath2: "",
            verticalFileName3: "",
            verticalFilePath3: "",
            verticalFileType3: "",
            verticalFileNamePlain3: "",
            verticalFilePathPlain3: "",
            verticalFileTypePlain3: "",
            uploadVerticalImagePlain3: "",
            horizontalFileName3: "",
            horizontalFilePath3: "",
            horizontalFileType3: "",
            posterFilePath3: "",
            titleFilePath3: "",
            thumbFilePath3: "",
            verticalFileName4: "",
            verticalFilePath4: "",
            verticalFileType4: "",
            verticalFileNamePlain4: "",
            verticalFilePathPlain4: "",
            verticalFileTypePlain4: "",
            uploadVerticalImagePlain4: "",
            horizontalFileName4: "",
            horizontalFilePath4: "",
            horizontalFileType4: "",
            posterFilePath4: "",
            titleFilePath4: "",
            thumbFilePath4: "",
            verticalFileName5: "",
            verticalFilePath5: "",
            verticalFileType5: "",
            verticalFileNamePlain5: "",
            verticalFilePathPlain5: "",
            verticalFileTypePlain5: "",
            uploadVerticalImagePlain5: "",
            horizontalFileName5: "",
            horizontalFilePath5: "",
            horizontalFileType5: "",
            posterFilePath5: "",
            titleFilePath5: "",
            thumbFilePath5: ""
        });
    }

    //pravin code start
    updateItem(objProductDeviceTypeConfigure, groupTrailerUrl: string = '', groupPreviewUrl: string = ''): FormGroup {
     console.log("objProductDeviceTypeConfigure",objProductDeviceTypeConfigure);
        if(objProductDeviceTypeConfigure.dtypeId === 4){
            this.all = true;
        }

        const trailerUrlValue = objProductDeviceTypeConfigure.trailerUrl
            || objProductDeviceTypeConfigure.trailer_url
            || groupTrailerUrl
            || objProductDeviceTypeConfigure.mapTrailerVideoName
            || objProductDeviceTypeConfigure.mapTrailerVideo
            || '';
        const previewUrlValue = objProductDeviceTypeConfigure.previewUrl
            || objProductDeviceTypeConfigure.preview_url
            || groupPreviewUrl
            || '';
        const verticalFilePathPlain = this.resolveRenderableImageUrl(objProductDeviceTypeConfigure.verticalFilePathPlain, 'verticalFilePathPlain');
        const verticalFilePathPlain2 = this.resolveRenderableImageUrl(
            objProductDeviceTypeConfigure.verticalFilePathPlain2 || objProductDeviceTypeConfigure.verticalFilePathPlain1,
            'verticalFilePathPlain2'
        ) || this.resolveRenderableImageUrl(objProductDeviceTypeConfigure.verticalFilePathPlain1, 'verticalFilePathPlain1');
        const verticalFilePathPlain3 = this.resolveRenderableImageUrl(objProductDeviceTypeConfigure.verticalFilePathPlain3, 'verticalFilePathPlain3');
        const verticalFilePathPlain4 = this.resolveRenderableImageUrl(objProductDeviceTypeConfigure.verticalFilePathPlain4, 'verticalFilePathPlain4');
        const verticalFilePathPlain5 = this.resolveRenderableImageUrl(objProductDeviceTypeConfigure.verticalFilePathPlain5, 'verticalFilePathPlain5');

        return this.formBuilder.group({
            label: objProductDeviceTypeConfigure.label,
            isCarouselApplicable:objProductDeviceTypeConfigure.isCarouselApplicable,
            secondlabel: objProductDeviceTypeConfigure.secondlabel,
            description: objProductDeviceTypeConfigure.description,
            trailerUrl:[trailerUrlValue],
            previewUrl:[previewUrlValue],
            dtypeId:objProductDeviceTypeConfigure.dtypeId,
            isVisible:objProductDeviceTypeConfigure.isVisible,
            thumbFileName: objProductDeviceTypeConfigure.thumbFileName || objProductDeviceTypeConfigure.TitleImageFileName || '',
            thumbFilePath: objProductDeviceTypeConfigure.thumbFilePath || '',
            thumbFileType: objProductDeviceTypeConfigure.thumbFileType || objProductDeviceTypeConfigure.TitleImageFileType || '',
            verticalFileName: objProductDeviceTypeConfigure.verticalFileName,
            verticalFilePath: objProductDeviceTypeConfigure.verticalFilePath,
            verticalFileType: objProductDeviceTypeConfigure.verticalFileType,
            verticalFileNamePlain: objProductDeviceTypeConfigure.verticalFileNamePlain || '',
            verticalFilePathPlain: verticalFilePathPlain,
            verticalFileTypePlain: objProductDeviceTypeConfigure.verticalFileTypePlain || '',
            uploadVerticalImagePlain: objProductDeviceTypeConfigure.uploadVerticalImagePlain || '',
            horizontalFileName: objProductDeviceTypeConfigure.horizontalFileName,
            horizontalFilePath:objProductDeviceTypeConfigure.horizontalFilePath,
            horizontalFileType:objProductDeviceTypeConfigure.horizontalFileType,
            verticalFileName2: objProductDeviceTypeConfigure.verticalFileName2,
            verticalFilePath2: objProductDeviceTypeConfigure.verticalFilePath2,
            verticalFileType2: objProductDeviceTypeConfigure.verticalFileType2,
            verticalFileNamePlain2: objProductDeviceTypeConfigure.verticalFileNamePlain2 || objProductDeviceTypeConfigure.verticalFileNamePlain1 || '',
            verticalFilePathPlain2: verticalFilePathPlain2,
            verticalFileTypePlain2: objProductDeviceTypeConfigure.verticalFileTypePlain2 || objProductDeviceTypeConfigure.verticalFileTypePlain1 || '',
            uploadVerticalImagePlain2: objProductDeviceTypeConfigure.uploadVerticalImagePlain2 || objProductDeviceTypeConfigure.uploadVerticalImagePlain1 || '',
            horizontalFileName2: objProductDeviceTypeConfigure.horizontalFileName2,
            horizontalFilePath2: objProductDeviceTypeConfigure.horizontalFilePath2,
            horizontalFileType2: objProductDeviceTypeConfigure.horizontalFileType2,
            vodOrLivePosterImageFilePath2: objProductDeviceTypeConfigure.vodOrLivePosterImageFilePath2 || objProductDeviceTypeConfigure.posterFilePath2 || '',
            TitleFilePath2: objProductDeviceTypeConfigure.TitleFilePath2 || objProductDeviceTypeConfigure.titleFilePath2 || '',
            thumbFilePath2: objProductDeviceTypeConfigure.thumbFilePath2 || '',
            verticalFileName3: objProductDeviceTypeConfigure.verticalFileName3,
            verticalFilePath3: objProductDeviceTypeConfigure.verticalFilePath3,
            verticalFileType3: objProductDeviceTypeConfigure.verticalFileType3,
            verticalFileNamePlain3: objProductDeviceTypeConfigure.verticalFileNamePlain3 || '',
            verticalFilePathPlain3: verticalFilePathPlain3,
            verticalFileTypePlain3: objProductDeviceTypeConfigure.verticalFileTypePlain3 || '',
            uploadVerticalImagePlain3: objProductDeviceTypeConfigure.uploadVerticalImagePlain3 || '',
            horizontalFileName3: objProductDeviceTypeConfigure.horizontalFileName3,
            horizontalFilePath3: objProductDeviceTypeConfigure.horizontalFilePath3,
            horizontalFileType3: objProductDeviceTypeConfigure.horizontalFileType3,
            posterFilePath3: objProductDeviceTypeConfigure.posterFilePath3 || '',
            titleFilePath3: objProductDeviceTypeConfigure.titleFilePath3 || '',
            thumbFilePath3: objProductDeviceTypeConfigure.thumbFilePath3 || '',
            verticalFileName4: objProductDeviceTypeConfigure.verticalFileName4,
            verticalFilePath4: objProductDeviceTypeConfigure.verticalFilePath4,
            verticalFileType4: objProductDeviceTypeConfigure.verticalFileType4,
            verticalFileNamePlain4: objProductDeviceTypeConfigure.verticalFileNamePlain4 || '',
            verticalFilePathPlain4: verticalFilePathPlain4,
            verticalFileTypePlain4: objProductDeviceTypeConfigure.verticalFileTypePlain4 || '',
            uploadVerticalImagePlain4: objProductDeviceTypeConfigure.uploadVerticalImagePlain4 || '',
            horizontalFileName4: objProductDeviceTypeConfigure.horizontalFileName4,
            horizontalFilePath4: objProductDeviceTypeConfigure.horizontalFilePath4,
            horizontalFileType4: objProductDeviceTypeConfigure.horizontalFileType4,
            posterFilePath4: objProductDeviceTypeConfigure.posterFilePath4 || '',
            titleFilePath4: objProductDeviceTypeConfigure.titleFilePath4 || '',
            thumbFilePath4: objProductDeviceTypeConfigure.thumbFilePath4 || '',
            verticalFileName5: objProductDeviceTypeConfigure.verticalFileName5,
            verticalFilePath5: objProductDeviceTypeConfigure.verticalFilePath5,
            verticalFileType5: objProductDeviceTypeConfigure.verticalFileType5,
            verticalFileNamePlain5: objProductDeviceTypeConfigure.verticalFileNamePlain5 || '',
            verticalFilePathPlain5: verticalFilePathPlain5,
            verticalFileTypePlain5: objProductDeviceTypeConfigure.verticalFileTypePlain5 || '',
            uploadVerticalImagePlain5: objProductDeviceTypeConfigure.uploadVerticalImagePlain5 || '',
            horizontalFileName5: objProductDeviceTypeConfigure.horizontalFileName5,
            horizontalFilePath5: objProductDeviceTypeConfigure.horizontalFilePath5,
            horizontalFileType5: objProductDeviceTypeConfigure.horizontalFileType5,
            posterFilePath5: objProductDeviceTypeConfigure.posterFilePath5 || '',
            titleFilePath5: objProductDeviceTypeConfigure.titleFilePath5 || '',
            thumbFilePath5: objProductDeviceTypeConfigure.thumbFilePath5 || ''

        });
    }

    private resolveRenderableImageUrl(value:any, fieldName:string): string {
        if (typeof value === 'string') {
            const trimmedValue = value.trim();

            if (!trimmedValue) {
                return '';
            }

            if (this.isRenderableImageUrl(trimmedValue)) {
                return trimmedValue;
            }

            // Only strings that look like a serialized object/JSON blob need URL extraction.
            if (this.looksLikeSerializedValue(trimmedValue)) {
                const extractedUrl = this.extractImageUrlFromSerializedValue(trimmedValue, fieldName);
                return extractedUrl || '';
            }

            // Any other non-empty string (relative path, protocol-relative URL, bare host, etc.)
            // is passed through unchanged, matching how the other image fields are rendered.
            return trimmedValue;
        }

        if (value && typeof value === 'object' && typeof value[fieldName] !== 'undefined') {
            return this.resolveRenderableImageUrl(value[fieldName], fieldName);
        }

        return '';
    }

    private isRenderableImageUrl(value:string): boolean {
        return /^(https?:\/\/|\/\/|data:image\/|blob:|\/)/i.test(value);
    }

    private looksLikeSerializedValue(value:string): boolean {
        return value.indexOf('{') !== -1 || value.indexOf('":"') !== -1 || /":\s*"/.test(value);
    }

    private extractImageUrlFromSerializedValue(value:string, fieldName:string): string {
        const serializedFieldPattern = new RegExp('"' + fieldName + '"\\s*:\\s*"([^"]+)"');
        const serializedFieldMatch = value.match(serializedFieldPattern);

        if (serializedFieldMatch && serializedFieldMatch[1] && this.isRenderableImageUrl(serializedFieldMatch[1])) {
            return serializedFieldMatch[1];
        }

        const urlMatch = value.match(/https?:\/\/[^"'\s]+/i);
        if (urlMatch && urlMatch[0]) {
            return urlMatch[0];
        }

        return '';
    }

    onDtypeId(){
        this.all=false;
    }

    addItem(): void {

        if(!this.multipleDeviceForm.valid){

            this.createAssetGroupSubmitted = true;
            return

          }

        if(this.multipleDeviceForm.value.devices.length >= 4){

            this.createAssetGroupSubmitted = true;
            return;

        }
        this.img.push({
            horizontalURL:'',
            verticalURL:''
        })
        this.imgPlain.push({
            verticalPlainURL:''
        })

        this.devices = this.multipleDeviceForm.get('devices') as FormArray;
        let devices = this.devices
        var all = 0;
        var Web = 0;
        var android = 0;
        var iOS = 0;
        var roku = 0;
        this.all = false;
        this.roku = false;
        this.web = false;
        this.android = false;
        this.iOS = false;

        for(let i = 0;i< devices.value.length;i++){

            if(devices.value[i].dtypeId=='1'){
                Web++;
                this.web=true;
            }

            if(devices.value[i].dtypeId=='2'){
                android++;
                this.android=true;
            }

            if(devices.value[i].dtypeId=='3'){
                iOS++;
                this.iOS=true;
            }

            if(devices.value[i].dtypeId=='5'){
                roku++;
                this.roku=true;
            }

            if(devices.value[i].dtypeId=='4'){
                all++;
                this.all=true;
            }else{

            }

        }

        this.deviceTypeDublicate = false;
        this.deviceTypeFull = false;

        if(Web == 1 && android == 1 && iOS == 1 && roku == 1){

        this.deviceTypeFull = true ;

        }else if(all == 1 || this.all == true ){

            if(all == 1 && devices.value.length>1){

            }

        } else if(Web > 1 || android > 1 || iOS > 1 || roku>1){

            this.deviceTypeDublicate = true;

        }else {

            this.devices.push(this.createItem());

            let objH = {
                'index':"",
                'deviceType':"",
                'selectedFiles':"",
                "horizontalFileName": "",
                "horizontalFilePath": "",
                "horizontalFileType": "",
                'horizontalFile':false
            }

            let objV = {
                'index':"",
                'deviceType':"",
                'selectedFiles':"",
                "verticalFileName":"",
                "verticalFilePath": "",
                "verticalFileType":"",
                'verticalFile':false,

            }

            let objVPlain = {
                'index':"",
                'deviceType':"",
                'selectedFiles':"",
                "verticalFileNamePlain":"",
                "verticalFilePathPlain": "",
                "verticalFileTypePlain":"",
                'verticalFilePlain':false,
            }

            this.uploadImgFilePathHorizontal.push(objH);
            this.uploadImgFilePathVertical.push(objV);
            this.uploadImgFilePathVerticalPlain.push(objVPlain);
        }

    }

    onDeviceType(i){

        this.devices = this.multipleDeviceForm.get('devices') as FormArray;
        let devices = this.devices;

        this.uploadImgFilePathHorizontal[i].deviceType = devices.value[i].dtypeId;
        this.uploadImgFilePathHorizontal[i].index = 1;

        this.uploadImgFilePathVertical[i].deviceType = devices.value[i].dtypeId;
        this.uploadImgFilePathVertical[i].index = 1;

        if(this.uploadImgFilePathVerticalPlain[i]){
            this.uploadImgFilePathVerticalPlain[i].deviceType = devices.value[i].dtypeId;
            this.uploadImgFilePathVerticalPlain[i].index = 1;
        }

        var all = 0;
        var Web = 0;
        var android = 0;
        var iOS = 0;
        var roku = 0 ;
        this.all = false;
        this.web = false;
        this.android = false;
        this.iOS = false;
        this.roku = false;

        for(let i = 0;i< devices.value.length;i++){

            if(devices.value[i].dtypeId == '1'){
                Web++;
                this.web=true;
            }

            if(devices.value[i].dtypeId == '2'){
                android++;
                this.android=true;
            }
            if(devices.value[i].dtypeId == '5'){
                roku++;
                this.roku=true;
            }

            if(devices.value[i].dtypeId == '3'){
                iOS++;
                this.iOS=true;
            }

            if(devices.value[i].dtypeId == '4'){
                all++;
                this.all=true;
            }else{

            }

        }

        this.deviceTypeDublicate = false;
        this.deviceTypeFull = false;

        if(Web == 1 && android == 1 && iOS == 1 && roku == 1){

        this.deviceTypeFull = true ;

        }else if(all == 1 || this.all == true ){

            if(all == 1 && devices.value.length>1){

            }

        } else if(Web > 1 || android > 1 || iOS > 1 || roku>1){

            this.deviceTypeDublicate = true;

        }else {

        }

    }

    delInput(index){

        this.img.splice(index, 1);
        this.imgPlain.splice(index, 1);
        const arrayControl = this.multipleDeviceForm.get('devices') as FormArray;
        arrayControl.removeAt(index);

        this.devices = this.multipleDeviceForm.get('devices') as FormArray;
        this.uploadImgFilePathHorizontal.splice(index, 1);
        this.uploadImgFilePathVertical.splice(index, 1);
        this.uploadImgFilePathVerticalPlain.splice(index, 1);
        let devices = this.devices;

        var all = 0;
        var Web = 0;
        var android = 0;
        var iOS = 0;
        var roku = 0;
        this.all = false;
        this.roku = false;
        this.web = false;
        this.android = false;
        this.iOS = false;

        for(let i = 0;i< devices.value.length;i++){

            if(devices.value[i].dtypeId == '1'){
                Web++;
                this.web=true;
            }

            if(devices.value[i].dtypeId == '2'){
                android++;
                this.android=true;
            }

            if(devices.value[i].dtypeId == '3'){
                iOS++;
                this.iOS=true;
            }

            if(devices.value[i].dtypeId == '5'){
                roku++;
                this.roku=true;
            }

            if(devices.value[i].dtypeId == '4'){
                all++;
                this.all=true;
            }else{

            }

        }

        this.deviceTypeDublicate = false;
        this.deviceTypeFull = false;

        if(Web == 1 && android == 1 && iOS == 1 && roku == 1){

        this.deviceTypeFull = true ;

        }else if(all == 1 || this.all == true ){

            if(all == 1 && devices.value.length>1){

            }

        } else if(Web > 1 || android > 1 || iOS > 1 || roku>1){

            this.deviceTypeDublicate = true;

        }

    }

    saveCreateAssetGroup(){
        this.isLabelError = false;

        const airStartTime = this.createAssetGroupForm.get('airStartTime');
        const airEndTime = this.createAssetGroupForm.get('airEndTime');
        const airStartDate = this.createAssetGroupForm.get('airStartDate');
        const airEndDate = this.createAssetGroupForm.get('airEndDate');
        let mapcastarray = [];
        if(this.createAssetGroupForm.value.airStartDate == ''){
            this.createAssetGroupForm.controls['airStartTime'].setValue(['']);
        }

        if(this.createAssetGroupForm.value.airEndDate == ''){
            this.createAssetGroupForm.controls['airEndTime'].setValue(['']);
        }

        if(this.createAssetGroupForm.value.airStartDate=='' && this.createAssetGroupForm.value.airStartTime!=''){

            // airStartDate.setValidators([Validators.required]);
            // airStartDate.updateValueAndValidity();

        }else if(this.createAssetGroupForm.value.airStartDate!='' && this.createAssetGroupForm.value.airStartTime==''){

            // airStartTime.setValidators([Validators.required]);
            // airStartTime.updateValueAndValidity();
            console.log('update',this.createAssetGroupForm);

        }else {
            airStartTime.setValidators(null);
            airStartDate.setValidators(null);
            airStartTime.updateValueAndValidity();
            airStartDate.updateValueAndValidity();
        }

        if(this.createAssetGroupForm.value.airEndDate=='' && this.createAssetGroupForm.value.airEndTime!=''){

            // airEndDate.setValidators([Validators.required]);
            // airEndDate.updateValueAndValidity();

        }else if(this.createAssetGroupForm.value.airEndDate!='' && this.createAssetGroupForm.value.airEndTime==''){

            // airEndTime.setValidators([Validators.required]);
            // airEndTime.updateValueAndValidity();


        }else{
            airEndTime.setValidators(null);
            airEndDate.setValidators(null);
            airEndTime.updateValueAndValidity();
            airEndDate.updateValueAndValidity();
        }


      this.createAssetGroupSubmitted=true;
        //this.loader= true;
        this.commonService.changeloader(false);

      let tempUploadImgFilePath = this.uploadImgFilePathHorizontal
        .concat(this.uploadImgFilePathVertical)
        .concat(this.uploadImgFilePathVerticalPlain)
        .concat(this.uploadImgFilePathHorizontal2)
        .concat(this.uploadImgFilePathVertical2)
        .concat(this.uploadImgFilePathVerticalPlain2)
        .concat(this.uploadImgFilePathHorizontal3)
        .concat(this.uploadImgFilePathVertical3)
        .concat(this.uploadImgFilePathVerticalPlain3)
        .concat(this.uploadImgFilePathHorizontal4)
        .concat(this.uploadImgFilePathVertical4)
        .concat(this.uploadImgFilePathVerticalPlain4)
        .concat(this.uploadImgFilePathHorizontal5)
        .concat(this.uploadImgFilePathVertical5)
        .concat(this.uploadImgFilePathVerticalPlain5);
      this.uploadImgFilePath=[];

      //remove empty file upload img obj from array.
      tempUploadImgFilePath.forEach((element , i) => {

         if( element.selectedFiles !='') {

          this.uploadImgFilePath.push(element);

         }

      });


    // if(this.multipleDeviceForm.value.devices.length >1 && this.all=== true){
    //     // this.loader= false;
    //     this.commonService.changeloader(false);
    //     return;

    // }

    // if(this.deviceTypeDublicate){
    //     // this.loader= false;
    //     this.commonService.changeloader(false);
    //     return;
    // }

    if(this.multipleDeviceForm.value.devices.length != 0 && this.multipleDeviceForm.value.devices[0].label == ''){
        // this.loader=false;
        this.isLabelError = true;
        this.commonService.changeloader(false);
        return;
      }

    if(this.createAssetGroupForm.value.mapGeoZone.length  == 0){
        // this.loader = false;
        this.commonService.changeloader(false);
        this.mapGeoZoneError = true;
        return;
    }

    if(!this.createAssetGroupForm.valid){
        // this.loader= false;
        this.commonService.changeloader(false);
        return;
    }


    // if(this.multipleDeviceForm.value.devices.length == 0 ){
    //     // this.loader= false;
    //     this.commonService.changeloader(false);
    //     return;
    // }


    let async = this.uploadImgFilePath.length;
    let varialbeArray=[];

        if(!this.update){

            // if(this.roleAsses.assetGroupCreate == false){
            //     this.toastrService.success('no access to create.');

            //     this.commonService.changeloader(false);
            //     return;
            // }

            // uploadImgFilePosterImage upload code finish pravin
            if(this.mapcastDynamicForm.value.mapcasts.length>0){

                for(let i=0;i< this.mapcastDynamicForm.value.mapcasts.length;i++){
            
                    if(this.mapcastDynamicForm.value.mapcasts[i].mapCast.length>0){
            
                        console.log("this.mapAssetGroupDynamicForm.value.mapcasts",this.mapcastDynamicForm.value.mapcasts);
            
                        mapcastarray.push(
                                {
                                    "id": this.mapcastDynamicForm.value.mapcasts[i].mapCast[0].id,
                                    "itemName":this.mapcastDynamicForm.value.mapcasts[i].mapCast[0].itemName,
                                    "displayIndexing":this.mapcastDynamicForm.value.mapcasts[i].displayIndexing,
            
                                });
                                this.createAssetGroupForm.controls['mapCast'].setValue(mapcastarray);
                        }
                    }
                    
                }

            if(this.uploadImgFilePath.length>0){

                for (let i = 0; i < this.uploadImgFilePath.length; i++) {

                    this.productConfigurationService.uploadFile(this.uploadImgFilePath[i].selectedFiles, awsPath.assetGroup).then(res => {

                        if (res && res.Location) {
                                async--;
                                if(this.uploadImgFilePath[i].horizontalFile == true)
                                this.uploadImgFilePath[i].horizontalFilePath=res.Location;

                                if(this.uploadImgFilePath[i].verticalFile == true)
                                this.uploadImgFilePath[i].verticalFilePath=res.Location;

                                if(this.uploadImgFilePath[i].horizontalFile2 == true)
                                this.uploadImgFilePath[i].horizontalFilePath2=res.Location;

                                if(this.uploadImgFilePath[i].verticalFile2 == true)
                                this.uploadImgFilePath[i].verticalFilePath2=res.Location;
                                if(this.uploadImgFilePath[i].horizontalFile3 == true)
                                this.uploadImgFilePath[i].horizontalFilePath3=res.Location;
                                if(this.uploadImgFilePath[i].verticalFile3 == true)
                                this.uploadImgFilePath[i].verticalFilePath3=res.Location;
                                if(this.uploadImgFilePath[i].horizontalFile4 == true)
                                this.uploadImgFilePath[i].horizontalFilePath4=res.Location;
                                if(this.uploadImgFilePath[i].verticalFile4 == true)
                                this.uploadImgFilePath[i].verticalFilePath4=res.Location;
                                if(this.uploadImgFilePath[i].horizontalFile5 == true)
                                this.uploadImgFilePath[i].horizontalFilePath5=res.Location;
                                if(this.uploadImgFilePath[i].verticalFile5 == true)
                                this.uploadImgFilePath[i].verticalFilePath5=res.Location;

                                if(this.uploadImgFilePath[i].verticalFilePlain == true)
                                this.uploadImgFilePath[i].verticalFilePathPlain=res.Location;
                                if(this.uploadImgFilePath[i].verticalFilePlain2 == true)
                                this.uploadImgFilePath[i].verticalFilePathPlain2=res.Location;
                                if(this.uploadImgFilePath[i].verticalFilePlain3 == true)
                                this.uploadImgFilePath[i].verticalFilePathPlain3=res.Location;
                                if(this.uploadImgFilePath[i].verticalFilePlain4 == true)
                                this.uploadImgFilePath[i].verticalFilePathPlain4=res.Location;
                                if(this.uploadImgFilePath[i].verticalFilePlain5 == true)
                                this.uploadImgFilePath[i].verticalFilePathPlain5=res.Location;

                                if (async == 0) {

                                   let asyncs =  this.multipleDeviceForm.value.devices.length;
                                    for(let i = 0;i < this.multipleDeviceForm.value.devices.length;i++){

                                        asyncs --;

                                                varialbeArray.push(
                                                {
                                                    "label": this.multipleDeviceForm.value.devices[i].label,
                                                    "description":this.multipleDeviceForm.value.devices[i].description,
                                                    "secondlabel": this.multipleDeviceForm.value.devices[i].secondlabel,
                                                    "dtypeId":this.multipleDeviceForm.value.devices[i].dtypeId,
                                                    "isCarouselApplicable":this.multipleDeviceForm.value.devices[i].isCarouselApplicable,
                                                    "isVisible":this.multipleDeviceForm.value.devices[i].isVisible,
                                                    "trailerUrl": this.multipleDeviceForm.value.devices[i].trailerUrl,
                                                    "previewUrl": this.multipleDeviceForm.value.devices[i].previewUrl,
                                                    "thumbFileName": this.createAssetGroupForm.value.TitleImageFileName || null,
                                                    "thumbFilePath": this.createAssetGroupForm.value.ThumbnailImage || '',
                                                    "thumbFileType": this.createAssetGroupForm.value.TitleImageFileType || null,
                                                    "verticalFileName": "",
                                                    "verticalFilePath": "",
                                                    "verticalFileType": "",
                                                    "verticalFileNamePlain": this.multipleDeviceForm.value.devices[i].verticalFileNamePlain || "",
                                                    "verticalFilePathPlain": this.multipleDeviceForm.value.devices[i].verticalFilePathPlain || "",
                                                    "verticalFileTypePlain": this.multipleDeviceForm.value.devices[i].verticalFileTypePlain || "",
                                                    "uploadVerticalImagePlain": this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain || "",
                                                    "horizontalFileName": "",
                                                    "horizontalFilePath": "",
                                                    "horizontalFileType": "",
                                                    "verticalFileName2": "",
                                                    "verticalFilePath2": "",
                                                    "verticalFileType2": "",
                                                    "verticalFileNamePlain2": this.multipleDeviceForm.value.devices[i].verticalFileNamePlain2 || "",
                                                    "verticalFilePathPlain2": this.multipleDeviceForm.value.devices[i].verticalFilePathPlain2 || "",
                                                    "verticalFileTypePlain2": this.multipleDeviceForm.value.devices[i].verticalFileTypePlain2 || "",
                                                    "uploadVerticalImagePlain2": this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain2 || "",
                                                    "horizontalFileName2": "",
                                                    "horizontalFilePath2": "",
                                                    "horizontalFileType2": "",
                                                    "verticalFileName3": "",
                                                    "verticalFilePath3": "",
                                                    "verticalFileType3": "",
                                                    "verticalFileNamePlain3": this.multipleDeviceForm.value.devices[i].verticalFileNamePlain3 || "",
                                                    "verticalFilePathPlain3": this.multipleDeviceForm.value.devices[i].verticalFilePathPlain3 || "",
                                                    "verticalFileTypePlain3": this.multipleDeviceForm.value.devices[i].verticalFileTypePlain3 || "",
                                                    "uploadVerticalImagePlain3": this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain3 || "",
                                                    "horizontalFileName3": "",
                                                    "horizontalFilePath3": "",
                                                    "horizontalFileType3": "",
                                                    "verticalFileName4": "",
                                                    "verticalFilePath4": "",
                                                    "verticalFileType4": "",
                                                    "verticalFileNamePlain4": this.multipleDeviceForm.value.devices[i].verticalFileNamePlain4 || "",
                                                    "verticalFilePathPlain4": this.multipleDeviceForm.value.devices[i].verticalFilePathPlain4 || "",
                                                    "verticalFileTypePlain4": this.multipleDeviceForm.value.devices[i].verticalFileTypePlain4 || "",
                                                    "uploadVerticalImagePlain4": this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain4 || "",
                                                    "horizontalFileName4": "",
                                                    "horizontalFilePath4": "",
                                                    "horizontalFileType4": "",
                                                    "verticalFileName5": "",
                                                    "verticalFilePath5": "",
                                                    "verticalFileType5": "",
                                                    "verticalFileNamePlain5": this.multipleDeviceForm.value.devices[i].verticalFileNamePlain5 || "",
                                                    "verticalFilePathPlain5": this.multipleDeviceForm.value.devices[i].verticalFilePathPlain5 || "",
                                                    "verticalFileTypePlain5": this.multipleDeviceForm.value.devices[i].verticalFileTypePlain5 || "",
                                                    "uploadVerticalImagePlain5": this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain5 || "",
                                                    "horizontalFileName5": "",
                                                    "horizontalFilePath5": "",
                                                    "horizontalFileType5": ""

                                                });

                                    }

                                    if(asyncs == 0){

                                        let asyncvariables = varialbeArray.length;

                                        for(let i=0;i< varialbeArray.length;i++){

                                                asyncvariables--;

                                                for(let j = 0 ;j<this.uploadImgFilePath.length; j++){

                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].horizontalFile == true){

                                                        varialbeArray[i].horizontalFileName=this.uploadImgFilePath[j].horizontalFileName;
                                                        varialbeArray[i].horizontalFilePath=this.uploadImgFilePath[j].horizontalFilePath;
                                                        varialbeArray[i].horizontalFileType=this.uploadImgFilePath[j].horizontalFileType;

                                                    }

                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].verticalFile== true){

                                                        varialbeArray[i].verticalFileName=this.uploadImgFilePath[j].verticalFileName;
                                                        varialbeArray[i].verticalFilePath=this.uploadImgFilePath[j].verticalFilePath;
                                                        varialbeArray[i].verticalFileType=this.uploadImgFilePath[j].verticalFileType;

                                                    }

                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].verticalFilePlain== true){

                                                        varialbeArray[i].verticalFileNamePlain=this.uploadImgFilePath[j].verticalFileNamePlain;
                                                        varialbeArray[i].verticalFilePathPlain=this.uploadImgFilePath[j].verticalFilePathPlain;
                                                        varialbeArray[i].verticalFileTypePlain=this.uploadImgFilePath[j].verticalFileTypePlain;

                                                    }

                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].horizontalFile2 == true){

                                                        varialbeArray[i].horizontalFileName2=this.uploadImgFilePath[j].horizontalFileName2;
                                                        varialbeArray[i].horizontalFilePath2=this.uploadImgFilePath[j].horizontalFilePath2;
                                                        varialbeArray[i].horizontalFileType2=this.uploadImgFilePath[j].horizontalFileType2;

                                                    }

                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].verticalFile2== true){

                                                        varialbeArray[i].verticalFileName2=this.uploadImgFilePath[j].verticalFileName2;
                                                        varialbeArray[i].verticalFilePath2=this.uploadImgFilePath[j].verticalFilePath2;
                                                        varialbeArray[i].verticalFileType2=this.uploadImgFilePath[j].verticalFileType2;

                                                    }
                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].verticalFilePlain2== true){
                                                        varialbeArray[i].verticalFileNamePlain2=this.uploadImgFilePath[j].verticalFileNamePlain2;
                                                        varialbeArray[i].verticalFilePathPlain2=this.uploadImgFilePath[j].verticalFilePathPlain2;
                                                        varialbeArray[i].verticalFileTypePlain2=this.uploadImgFilePath[j].verticalFileTypePlain2;
                                                    }
                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].horizontalFile3 == true){
                                                        varialbeArray[i].horizontalFileName3=this.uploadImgFilePath[j].horizontalFileName3;
                                                        varialbeArray[i].horizontalFilePath3=this.uploadImgFilePath[j].horizontalFilePath3;
                                                        varialbeArray[i].horizontalFileType3=this.uploadImgFilePath[j].horizontalFileType3;
                                                    }
                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].verticalFile3== true){
                                                        varialbeArray[i].verticalFileName3=this.uploadImgFilePath[j].verticalFileName3;
                                                        varialbeArray[i].verticalFilePath3=this.uploadImgFilePath[j].verticalFilePath3;
                                                        varialbeArray[i].verticalFileType3=this.uploadImgFilePath[j].verticalFileType3;
                                                    }
                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].verticalFilePlain3== true){
                                                        varialbeArray[i].verticalFileNamePlain3=this.uploadImgFilePath[j].verticalFileNamePlain3;
                                                        varialbeArray[i].verticalFilePathPlain3=this.uploadImgFilePath[j].verticalFilePathPlain3;
                                                        varialbeArray[i].verticalFileTypePlain3=this.uploadImgFilePath[j].verticalFileTypePlain3;
                                                    }
                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].horizontalFile4== true){
                                                        varialbeArray[i].horizontalFileName4=this.uploadImgFilePath[j].horizontalFileName4;
                                                        varialbeArray[i].horizontalFilePath4=this.uploadImgFilePath[j].horizontalFilePath4;
                                                        varialbeArray[i].horizontalFileType4=this.uploadImgFilePath[j].horizontalFileType4;
                                                    }
                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].verticalFile4== true){
                                                        varialbeArray[i].verticalFileName4=this.uploadImgFilePath[j].verticalFileName4;
                                                        varialbeArray[i].verticalFilePath4=this.uploadImgFilePath[j].verticalFilePath4;
                                                        varialbeArray[i].verticalFileType4=this.uploadImgFilePath[j].verticalFileType4;
                                                    }
                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].verticalFilePlain4== true){
                                                        varialbeArray[i].verticalFileNamePlain4=this.uploadImgFilePath[j].verticalFileNamePlain4;
                                                        varialbeArray[i].verticalFilePathPlain4=this.uploadImgFilePath[j].verticalFilePathPlain4;
                                                        varialbeArray[i].verticalFileTypePlain4=this.uploadImgFilePath[j].verticalFileTypePlain4;
                                                    }
                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].horizontalFile5== true){
                                                        varialbeArray[i].horizontalFileName5=this.uploadImgFilePath[j].horizontalFileName5;
                                                        varialbeArray[i].horizontalFilePath5=this.uploadImgFilePath[j].horizontalFilePath5;
                                                        varialbeArray[i].horizontalFileType5=this.uploadImgFilePath[j].horizontalFileType5;
                                                    }
                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].verticalFile5== true){
                                                        varialbeArray[i].verticalFileName5=this.uploadImgFilePath[j].verticalFileName5;
                                                        varialbeArray[i].verticalFilePath5=this.uploadImgFilePath[j].verticalFilePath5;
                                                        varialbeArray[i].verticalFileType5=this.uploadImgFilePath[j].verticalFileType5;
                                                    }
                                                    if(this.uploadImgFilePath[j].deviceType == varialbeArray[i].dtypeId && this.uploadImgFilePath[j].verticalFilePlain5== true){
                                                        varialbeArray[i].verticalFileNamePlain5=this.uploadImgFilePath[j].verticalFileNamePlain5;
                                                        varialbeArray[i].verticalFilePathPlain5=this.uploadImgFilePath[j].verticalFilePathPlain5;
                                                        varialbeArray[i].verticalFileTypePlain5=this.uploadImgFilePath[j].verticalFileTypePlain5;
                                                    }

                                                }
                                        }

                                        if(asyncvariables == 0){

                                            this.createAssetGroupForm.controls['productDeviceTypeConfigure'].setValue(varialbeArray);
                                            console.log("createNewProductForm123",this.createAssetGroupForm);

                                            this.createAssetGroupSubmitted=true;

                                            // if(!this.multipleDeviceForm.valid){
                                            //     // this.loader= false;
                                            //     this.commonService.changeloader(false);
                                            //     return
                                            // }

                                            // if(!this.createAssetGroupForm.valid){
                                            //     // this.loader= false;
                                            //     this.commonService.changeloader(false);
                                            //     return
                                            // }

                                            this.postCAllAssetGroup();

                                            //New Code for right side for from
                                            //this.onContentReadyToReview();
                                        }
                                   }

                               }
                        }

                    });
                }
            }

            if(this.uploadImgFilePath.length==0){
                for(let i=0;i< this.multipleDeviceForm.value.devices.length;i++){

                    if(this.multipleDeviceForm.value.devices[i].trailerUrl == this.removeTrailerIndex){

                        this.multipleDeviceForm.value.devices[i].trailerUrl = '';
                        this.multipleDeviceForm.value.devices[i].previewUrl = '';
                        this.removeTrailerIndex = null;

                    }
                    varialbeArray.push(
                    {
                        "label": this.multipleDeviceForm.value.devices[i].label,
                        "description":this.multipleDeviceForm.value.devices[i].description,
                        "secondlabel": this.multipleDeviceForm.value.devices[i].secondlabel,
                        "dtypeId":this.multipleDeviceForm.value.devices[i].dtypeId,
                        "isCarouselApplicable":this.multipleDeviceForm.value.devices[i].isCarouselApplicable,
                        "isVisible":this.multipleDeviceForm.value.devices[i].isVisible,
                        "trailerUrl": this.multipleDeviceForm.value.devices[i].trailerUrl,
                        "previewUrl": this.multipleDeviceForm.value.devices[i].previewUrl,
                        "thumbFileName": this.createAssetGroupForm.value.TitleImageFileName || null,
                        "thumbFilePath": this.createAssetGroupForm.value.ThumbnailImage || '',
                        "thumbFileType": this.createAssetGroupForm.value.TitleImageFileType || null,
                        "verticalFileName": "",
                        "verticalFilePath": "",
                        "verticalFileType": "",
                        "verticalFileNamePlain": this.multipleDeviceForm.value.devices[i].verticalFileNamePlain || "",
                        "verticalFilePathPlain": this.multipleDeviceForm.value.devices[i].verticalFilePathPlain || "",
                        "verticalFileTypePlain": this.multipleDeviceForm.value.devices[i].verticalFileTypePlain || "",
                        "uploadVerticalImagePlain": this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain || "",
                        "horizontalFileName": "",
                        "horizontalFilePath": "",
                        "horizontalFileType": "",
                        "verticalFileName2": "",
                        "verticalFilePath2": "",
                        "verticalFileType2": "",
                        "verticalFileNamePlain2": this.multipleDeviceForm.value.devices[i].verticalFileNamePlain2 || "",
                        "verticalFilePathPlain2": this.multipleDeviceForm.value.devices[i].verticalFilePathPlain2 || "",
                        "verticalFileTypePlain2": this.multipleDeviceForm.value.devices[i].verticalFileTypePlain2 || "",
                        "uploadVerticalImagePlain2": this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain2 || "",
                        "horizontalFileName2": "",
                        "horizontalFilePath2": "",
                        "horizontalFileType2": "",
                        "verticalFileName3": "",
                        "verticalFilePath3": "",
                        "verticalFileType3": "",
                        "verticalFileNamePlain3": this.multipleDeviceForm.value.devices[i].verticalFileNamePlain3 || "",
                        "verticalFilePathPlain3": this.multipleDeviceForm.value.devices[i].verticalFilePathPlain3 || "",
                        "verticalFileTypePlain3": this.multipleDeviceForm.value.devices[i].verticalFileTypePlain3 || "",
                        "uploadVerticalImagePlain3": this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain3 || "",
                        "horizontalFileName3": "",
                        "horizontalFilePath3": "",
                        "horizontalFileType3": "",
                        "verticalFileName4": "",
                        "verticalFilePath4": "",
                        "verticalFileType4": "",
                        "verticalFileNamePlain4": this.multipleDeviceForm.value.devices[i].verticalFileNamePlain4 || "",
                        "verticalFilePathPlain4": this.multipleDeviceForm.value.devices[i].verticalFilePathPlain4 || "",
                        "verticalFileTypePlain4": this.multipleDeviceForm.value.devices[i].verticalFileTypePlain4 || "",
                        "uploadVerticalImagePlain4": this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain4 || "",
                        "horizontalFileName4": "",
                        "horizontalFilePath4": "",
                        "horizontalFileType4": "",
                        "verticalFileName5": "",
                        "verticalFilePath5": "",
                        "verticalFileType5": "",
                        "verticalFileNamePlain5": this.multipleDeviceForm.value.devices[i].verticalFileNamePlain5 || "",
                        "verticalFilePathPlain5": this.multipleDeviceForm.value.devices[i].verticalFilePathPlain5 || "",
                        "verticalFileTypePlain5": this.multipleDeviceForm.value.devices[i].verticalFileTypePlain5 || "",
                        "uploadVerticalImagePlain5": this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain5 || "",
                        "horizontalFileName5": "",
                        "horizontalFilePath5": "",
                        "horizontalFileType5": ""
                    });

                }

                this.createAssetGroupSubmitted = true;
                this.createAssetGroupForm.controls['productDeviceTypeConfigure'].setValue(varialbeArray);

                // if(!this.multipleDeviceForm.valid){
                //     // this.loader= false;
                //     this.commonService.changeloader(false);
                //     return
                // }

                // if(!this.createAssetGroupForm.valid){
                //     // this.loader= false;
                //     this.commonService.changeloader(false);
                //     return
                // }


                this.postCAllAssetGroup();
                //New Code for right side for from
                //this.onContentReadyToReview();
            }

        }

        if(this.update){

            // if(this.roleAsses.assetGroupEdit == false){

            //     this.toastrService.success('no access to create.');
            //     this.commonService.changeloader(false);
            //     return;
            // }
            if(this.mapcastDynamicForm.value.mapcasts.length>0){

                for(let i=0;i< this.mapcastDynamicForm.value.mapcasts.length;i++){
            
                    if(this.mapcastDynamicForm.value.mapcasts[i].mapCast.length>0){
            
                        console.log("this.mapAssetGroupDynamicForm.value.mapcasts",this.mapcastDynamicForm.value.mapcasts);
            
                        mapcastarray.push(
                                {
                                    "id": this.mapcastDynamicForm.value.mapcasts[i].mapCast[0].id,
                                    "itemName":this.mapcastDynamicForm.value.mapcasts[i].mapCast[0].itemName,
                                    "displayIndexing":this.mapcastDynamicForm.value.mapcasts[i].displayIndexing,
            
                                });
                                this.createAssetGroupForm.controls['mapCast'].setValue(mapcastarray);
                        }
                    }
                    
                }

            let asyncvariables = this.multipleDeviceForm.value.devices.length;
            if(this.uploadImgFilePath.length == 0){
                this.multipleDeviceForm.value.devices.forEach((element,i) => {

                    if(i == this.removeTrailerIndex){

                        this.multipleDeviceForm.value.devices[i].trailerUrl = '';
                        this.multipleDeviceForm.value.devices[i].previewUrl = '';

                    }

                });
                this.createAssetGroupForm.controls['productDeviceTypeConfigure'].setValue(this.multipleDeviceForm.value.devices);
                this.createAssetGroupSubmitted = true;

                // if(!this.multipleDeviceForm.valid){
                //     // this.loader= false;
                //     this.commonService.changeloader(false);
                //     return
                // }


                // if(!this.createAssetGroupForm.valid){
                //     // this.loader= false;
                //     this.commonService.changeloader(false);
                //     return
                // }


                 this.postCAllAssetGroup();
                //New Code for right side for from
                //this.onContentReadyToReview();

            }

            // if(this.uploadImgFilePath.length > 0 && this.createNewAssetForm.value.vodClosedCaptionFilePath!=''){
            // }
            if(this.uploadImgFilePath.length > 0 ){

                for (let i = 0; i < this.uploadImgFilePath.length; i++) {

                    this.productConfigurationService.uploadFile(this.uploadImgFilePath[i].selectedFiles, awsPath.assetGroup).then(res => {

                        if (res && res.Location) {
                            async--;
                            if(this.uploadImgFilePath[i].horizontalFile == true)
                                this.uploadImgFilePath[i].horizontalFilePath=res.Location;

                                if(this.uploadImgFilePath[i].verticalFile == true)
                                this.uploadImgFilePath[i].verticalFilePath=res.Location;
                                if(this.uploadImgFilePath[i].horizontalFile2 == true)
                                this.uploadImgFilePath[i].horizontalFilePath2=res.Location;
                                if(this.uploadImgFilePath[i].verticalFile2 == true)
                                this.uploadImgFilePath[i].verticalFilePath2=res.Location;
                                if(this.uploadImgFilePath[i].horizontalFile3 == true)
                                this.uploadImgFilePath[i].horizontalFilePath3=res.Location;
                                if(this.uploadImgFilePath[i].verticalFile3 == true)
                                this.uploadImgFilePath[i].verticalFilePath3=res.Location;
                                if(this.uploadImgFilePath[i].horizontalFile4 == true)
                                this.uploadImgFilePath[i].horizontalFilePath4=res.Location;
                                if(this.uploadImgFilePath[i].verticalFile4 == true)
                                this.uploadImgFilePath[i].verticalFilePath4=res.Location;
                                if(this.uploadImgFilePath[i].horizontalFile5 == true)
                                this.uploadImgFilePath[i].horizontalFilePath5=res.Location;
                                if(this.uploadImgFilePath[i].verticalFile5 == true)
                                this.uploadImgFilePath[i].verticalFilePath5=res.Location;
                                if(this.uploadImgFilePath[i].verticalFilePlain == true)
                                this.uploadImgFilePath[i].verticalFilePathPlain=res.Location;
                                if(this.uploadImgFilePath[i].verticalFilePlain2 == true)
                                this.uploadImgFilePath[i].verticalFilePathPlain2=res.Location;
                                if(this.uploadImgFilePath[i].verticalFilePlain3 == true)
                                this.uploadImgFilePath[i].verticalFilePathPlain3=res.Location;
                                if(this.uploadImgFilePath[i].verticalFilePlain4 == true)
                                this.uploadImgFilePath[i].verticalFilePathPlain4=res.Location;
                                if(this.uploadImgFilePath[i].verticalFilePlain5 == true)
                                this.uploadImgFilePath[i].verticalFilePathPlain5=res.Location;
                        }

                        if (async == 0) {

                            for(let i=0;i<this.multipleDeviceForm.value.devices.length;i++){

                                asyncvariables--;

                                for(let j = 0 ;j<this.uploadImgFilePath.length; j++){

                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].horizontalFile==true){

                                        this.multipleDeviceForm.value.devices[i].horizontalFileName=this.uploadImgFilePath[j].horizontalFileName;
                                        this.multipleDeviceForm.value.devices[i].horizontalFilePath=this.uploadImgFilePath[j].horizontalFilePath;
                                        this.multipleDeviceForm.value.devices[i].horizontalFileType=this.uploadImgFilePath[j].horizontalFileType;

                                    }

                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].verticalFile== true){

                                        this.multipleDeviceForm.value.devices[i].verticalFileName=this.uploadImgFilePath[j].verticalFileName;
                                        this.multipleDeviceForm.value.devices[i].verticalFilePath=this.uploadImgFilePath[j].verticalFilePath;
                                        this.multipleDeviceForm.value.devices[i].verticalFileType=this.uploadImgFilePath[j].verticalFileType;

                                    }

                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].verticalFilePlain== true){
                                        this.multipleDeviceForm.value.devices[i].verticalFileNamePlain=this.uploadImgFilePath[j].verticalFileNamePlain;
                                        this.multipleDeviceForm.value.devices[i].verticalFilePathPlain=this.uploadImgFilePath[j].verticalFilePathPlain;
                                        this.multipleDeviceForm.value.devices[i].verticalFileTypePlain=this.uploadImgFilePath[j].verticalFileTypePlain;
                                    }

                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].horizontalFile2==true){

                                        this.multipleDeviceForm.value.devices[i].horizontalFileName2=this.uploadImgFilePath[j].horizontalFileName2;
                                        this.multipleDeviceForm.value.devices[i].horizontalFilePath2=this.uploadImgFilePath[j].horizontalFilePath2;
                                        this.multipleDeviceForm.value.devices[i].horizontalFileType2=this.uploadImgFilePath[j].horizontalFileType2;

                                    }

                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].verticalFile2== true){

                                        this.multipleDeviceForm.value.devices[i].verticalFileName2=this.uploadImgFilePath[j].verticalFileName2;
                                        this.multipleDeviceForm.value.devices[i].verticalFilePath2=this.uploadImgFilePath[j].verticalFilePath2;
                                        this.multipleDeviceForm.value.devices[i].verticalFileType2=this.uploadImgFilePath[j].verticalFileType2;

                                    }
                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].verticalFilePlain2== true){
                                        this.multipleDeviceForm.value.devices[i].verticalFileNamePlain2=this.uploadImgFilePath[j].verticalFileNamePlain2;
                                        this.multipleDeviceForm.value.devices[i].verticalFilePathPlain2=this.uploadImgFilePath[j].verticalFilePathPlain2;
                                        this.multipleDeviceForm.value.devices[i].verticalFileTypePlain2=this.uploadImgFilePath[j].verticalFileTypePlain2;
                                    }
                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].horizontalFile3==true){
                                        this.multipleDeviceForm.value.devices[i].horizontalFileName3=this.uploadImgFilePath[j].horizontalFileName3;
                                        this.multipleDeviceForm.value.devices[i].horizontalFilePath3=this.uploadImgFilePath[j].horizontalFilePath3;
                                        this.multipleDeviceForm.value.devices[i].horizontalFileType3=this.uploadImgFilePath[j].horizontalFileType3;
                                    }
                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].verticalFile3== true){
                                        this.multipleDeviceForm.value.devices[i].verticalFileName3=this.uploadImgFilePath[j].verticalFileName3;
                                        this.multipleDeviceForm.value.devices[i].verticalFilePath3=this.uploadImgFilePath[j].verticalFilePath3;
                                        this.multipleDeviceForm.value.devices[i].verticalFileType3=this.uploadImgFilePath[j].verticalFileType3;
                                    }
                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].verticalFilePlain3== true){
                                        this.multipleDeviceForm.value.devices[i].verticalFileNamePlain3=this.uploadImgFilePath[j].verticalFileNamePlain3;
                                        this.multipleDeviceForm.value.devices[i].verticalFilePathPlain3=this.uploadImgFilePath[j].verticalFilePathPlain3;
                                        this.multipleDeviceForm.value.devices[i].verticalFileTypePlain3=this.uploadImgFilePath[j].verticalFileTypePlain3;
                                    }
                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].horizontalFile4==true){
                                        this.multipleDeviceForm.value.devices[i].horizontalFileName4=this.uploadImgFilePath[j].horizontalFileName4;
                                        this.multipleDeviceForm.value.devices[i].horizontalFilePath4=this.uploadImgFilePath[j].horizontalFilePath4;
                                        this.multipleDeviceForm.value.devices[i].horizontalFileType4=this.uploadImgFilePath[j].horizontalFileType4;
                                    }
                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].verticalFile4== true){
                                        this.multipleDeviceForm.value.devices[i].verticalFileName4=this.uploadImgFilePath[j].verticalFileName4;
                                        this.multipleDeviceForm.value.devices[i].verticalFilePath4=this.uploadImgFilePath[j].verticalFilePath4;
                                        this.multipleDeviceForm.value.devices[i].verticalFileType4=this.uploadImgFilePath[j].verticalFileType4;
                                    }
                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].verticalFilePlain4== true){
                                        this.multipleDeviceForm.value.devices[i].verticalFileNamePlain4=this.uploadImgFilePath[j].verticalFileNamePlain4;
                                        this.multipleDeviceForm.value.devices[i].verticalFilePathPlain4=this.uploadImgFilePath[j].verticalFilePathPlain4;
                                        this.multipleDeviceForm.value.devices[i].verticalFileTypePlain4=this.uploadImgFilePath[j].verticalFileTypePlain4;
                                    }
                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].horizontalFile5==true){
                                        this.multipleDeviceForm.value.devices[i].horizontalFileName5=this.uploadImgFilePath[j].horizontalFileName5;
                                        this.multipleDeviceForm.value.devices[i].horizontalFilePath5=this.uploadImgFilePath[j].horizontalFilePath5;
                                        this.multipleDeviceForm.value.devices[i].horizontalFileType5=this.uploadImgFilePath[j].horizontalFileType5;
                                    }
                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].verticalFile5== true){
                                        this.multipleDeviceForm.value.devices[i].verticalFileName5=this.uploadImgFilePath[j].verticalFileName5;
                                        this.multipleDeviceForm.value.devices[i].verticalFilePath5=this.uploadImgFilePath[j].verticalFilePath5;
                                        this.multipleDeviceForm.value.devices[i].verticalFileType5=this.uploadImgFilePath[j].verticalFileType5;
                                    }
                                    if(this.uploadImgFilePath[j].deviceType == this.multipleDeviceForm.value.devices[i].dtypeId && this.uploadImgFilePath[j].verticalFilePlain5== true){
                                        this.multipleDeviceForm.value.devices[i].verticalFileNamePlain5=this.uploadImgFilePath[j].verticalFileNamePlain5;
                                        this.multipleDeviceForm.value.devices[i].verticalFilePathPlain5=this.uploadImgFilePath[j].verticalFilePathPlain5;
                                        this.multipleDeviceForm.value.devices[i].verticalFileTypePlain5=this.uploadImgFilePath[j].verticalFileTypePlain5;
                                    }


                                }
                            }

                            if(asyncvariables == 0){

                                this.createAssetGroupSubmitted = true;

                                // if(!this.multipleDeviceForm.valid){
                                //     // this.loader = false;
                                //     this.commonService.changeloader(false);
                                //     return
                                // }

                                // if(!this.createAssetGroupForm.valid){
                                //     // this.loader = false;
                                //     this.commonService.changeloader(false);
                                //     return
                                // }
                                this.createAssetGroupForm.controls['productDeviceTypeConfigure'].setValue(this.multipleDeviceForm.value.devices)

                                 this.postCAllAssetGroup();
                                //New Code for right side for from
                                //this.onContentReadyToReview();


                            }
                        }
                    })
                }
            }

        }
    }


    //New Code for right side for from
    onContentReadyToReview(){
        // if(this.multipleDeviceForm.value.devices.length >1 && this.all=== true){
        //     // this.loader= false;
        //     this.commonService.changeloader(false);
        //     this.createAssetGroupSubmitted = true;
        //     return;

        // }

        // if(this.createAssetGroupForm.invalid || this.multipleDeviceForm.invalid ){
        //     // this.loader= false;
        //     this.commonService.changeloader(false);
            this.createAssetGroupSubmitted = true;
        //     return;

        // }

        // this.loader = false;


        this.contentReadyToReview = true;
        this.shareMassage = 'review';

    }


    isContentReadyToReviewReceived(event){

        console.log("we are in",event);
        this.contentReadyToReview = false;

       //New Code start
        if(event == 'No'){

            this.contentReadyToReview = false;

        }
        //New Code end

        if(event == 'Yes'){

            this.createAssetGroupForm.controls['contentState'].setValue(['Completed']);
            // this.postCAllAssetGroup();
            this.saveCreateAssetGroup();

        }
        if(event == 'Cancel'){

            this.createAssetGroupForm.controls['contentState'].setValue(['In-Progress']);
            this.resetForm();
            this.contentReadyToReview = false;
            this.router.navigate(['asset_management/asset_group/list']);
            // this.postCAllAssetGroup();
            // this.saveCreateAssetGroup();
        }

    }

    postCAllAssetGroup(){

        console.log("createNewProductForm",this.createAssetGroupForm);

        this.syncTrailerAndPreviewToRoot();

        this.createAssetGroupForm.controls['langId'].setValue(localStorage.getItem('languageId'));
        // this.loader=true;
        this.commonService.changeloader(true);
        // this.createAssetGroupForm.controls['airStartDate'].setValue(this.createAssetGroupForm.value.airStartDate +' '+ this.createAssetGroupForm.value.airStartTime);
        // this.createAssetGroupForm.controls['airEndDate'].setValue(this.createAssetGroupForm.value.airEndDate +' '+  this.createAssetGroupForm.value.airEndTime);

        if(this.createAssetGroupForm.value.airStartDate!='')
        this.createAssetGroupForm.controls['airStartDate'].setValue(this.createAssetGroupForm.value.airStartDate +' '+ this.createAssetGroupForm.value.airStartTime);

        if(this.createAssetGroupForm.value.airStartTime =='')
        this.createAssetGroupForm.controls['airStartDate'].setValue(this.createAssetGroupForm.value.airStartDate)

        if(this.createAssetGroupForm.value.airEndTime =='')
        this.createAssetGroupForm.controls['airEndDate'].setValue(this.createAssetGroupForm.value.airEndDate)

        if(this.createAssetGroupForm.value.airEndDate!='')
        this.createAssetGroupForm.controls['airEndDate'].setValue(this.createAssetGroupForm.value.airEndDate +' '+  this.createAssetGroupForm.value.airEndTime);
        const requestPayload = this.buildAssetGroupRequestPayload();
          if( this.update == false ) {
            requestPayload.mapProductType.push({id: 1, itemName: "Entertainment"});
                delete requestPayload.id;
                this.assetService.insertAssetGroup(requestPayload)
                .subscribe((result:any)=>{

                    // this.loader=false;
                    this.commonService.changeloader(false);

                    this.removeTrailerIndex = null;
                    this.spinnerService.hide();
                    this.router.navigate(['asset_management/asset_group/list']);
                    this.toastrService.success('Asset Group Created Successfully.');
                    //New Code for right side for from
                   this.update = false;
                //   this.updateSend.emit();
                   this.resetForm();
                   this.createAssetGroupSubmitted = false;
                });

            }

            if(this.update) {
              console.log('..........update', requestPayload);
                this.createAssetGroupForm.controls['id'].setValue(this.id);
                requestPayload.id = this.id;
                this.assetService.updateAssetGroup(requestPayload)
                .subscribe((result:any)=>{

                    this.removeTrailerIndex = null;
                    // this.loader=false;
                    this.commonService.changeloader(false);
                    this.toastrService.success('Asset Group Updated Successfully.');
                    console.log('<====result result result============>',result);
                    this.spinnerService.hide();

                    // Stay on same route and refresh values from server.
                    this.update = true;
                    this.createAssetGroupSubmitted = false;
                    this.getAssetGroupInfo(this.id);

                });

            }
    }

    private buildAssetGroupRequestPayload(): any {

        const requestPayload = JSON.parse(JSON.stringify(this.createAssetGroupForm.value || {}));
        const liveDeviceConfigs = this.multipleDeviceForm && this.multipleDeviceForm.value && this.multipleDeviceForm.value.devices
            ? JSON.parse(JSON.stringify(this.multipleDeviceForm.value.devices))
            : [];
        const thumbnailPath = requestPayload.ThumbnailImage || '';
        const thumbnailName = requestPayload.TitleImageFileName || null;
        const thumbnailType = requestPayload.TitleImageFileType || null;
        const marketingBannerFileName = requestPayload.marketingBannerFileName || null;
        const marketingBannerFilePath = requestPayload.marketingBannerFilePath || null;
        const sourceConfigs = liveDeviceConfigs.length
            ? liveDeviceConfigs
            : (requestPayload.productDeviceTypeConfigure && requestPayload.productDeviceTypeConfigure.length
                ? requestPayload.productDeviceTypeConfigure
                : []);

        requestPayload.productDeviceTypeConfigure = sourceConfigs.map((config: any) => {
            const normalizedConfig = config && typeof config === 'object' && !Array.isArray(config)
                ? Object.assign({}, config)
                : {};

            normalizedConfig.thumbFileName = normalizedConfig.thumbFileName || thumbnailName;
            normalizedConfig.thumbFilePath = normalizedConfig.thumbFilePath || thumbnailPath;
            normalizedConfig.thumbFileType = normalizedConfig.thumbFileType || thumbnailType;
            normalizedConfig.verticalFileNamePlain1 = normalizedConfig.verticalFileNamePlain1 || normalizedConfig.verticalFileNamePlain2 || '';
            normalizedConfig.verticalFilePathPlain1 = normalizedConfig.verticalFilePathPlain1 || normalizedConfig.verticalFilePathPlain2 || '';
            normalizedConfig.verticalFileTypePlain1 = normalizedConfig.verticalFileTypePlain1 || normalizedConfig.verticalFileTypePlain2 || '';
            normalizedConfig.uploadVerticalImagePlain1 = normalizedConfig.uploadVerticalImagePlain1 || normalizedConfig.uploadVerticalImagePlain2 || '';
            return normalizedConfig;
        });

        requestPayload.ThumbnailImage = thumbnailPath;
        delete requestPayload.marketingBannerFileName;
        delete requestPayload.marketingBannerFilePath;

        if (marketingBannerFileName || marketingBannerFilePath || Object.keys(this.marketingSetupData || {}).length) {
            const marketingPayload = Object.assign({}, this.marketingSetupData || {});
            marketingPayload.bannerFileName = marketingBannerFileName;
            marketingPayload.bannerFilePath = marketingBannerFilePath;
            requestPayload.marketing = [marketingPayload];
        }

        return requestPayload;
    }

    private syncTrailerAndPreviewToRoot(): void {
        let trailerUrlFromRows = '';
        let previewUrlFromRows = '';

        let configs = this.createAssetGroupForm.value.productDeviceTypeConfigure;
        if (!configs || !configs.length) {
            configs = this.multipleDeviceForm && this.multipleDeviceForm.value
                ? this.multipleDeviceForm.value.devices
                : [];
        }

        if (configs && configs.length) {
            for (let i = 0; i < configs.length; i++) {
                const row = configs[i] || {};
                const rowTrailerUrl = row.trailerUrl || row.trailer_url || '';
                const rowPreviewUrl = row.previewUrl || row.preview_url || '';

                if (!trailerUrlFromRows && rowTrailerUrl) {
                    trailerUrlFromRows = rowTrailerUrl;
                }
                if (!previewUrlFromRows && rowPreviewUrl) {
                    previewUrlFromRows = rowPreviewUrl;
                }

                if (trailerUrlFromRows && previewUrlFromRows) {
                    break;
                }
            }
        }

        const trailerUrlValue = trailerUrlFromRows || this.createAssetGroupForm.value.trailerUrl || '';
        const previewUrlValue = previewUrlFromRows || this.createAssetGroupForm.value.previewUrl || '';
        this.createAssetGroupForm.controls['trailerUrl'].setValue(trailerUrlValue);
        this.createAssetGroupForm.controls['previewUrl'].setValue(previewUrlValue);
    }


    selectedProductTypeItems:any=[];

    private formatAudioLanguageOption(item: any, index: number) {
        if (item === null || item === undefined) {
            return null;
        }

        if (typeof item === 'string' || typeof item === 'number') {
            const value = item.toString().trim();
            if (!value) {
                return null;
            }
            return {
                id: value,
                itemName: value
            };
        }

        let optionId = item.id;
        if (optionId === undefined || optionId === null || optionId === '') {
            optionId = item.audioLanguageId;
        }
        if (optionId === undefined || optionId === null || optionId === '') {
            optionId = item.languageId;
        }
        if (optionId === undefined || optionId === null || optionId === '') {
            optionId = item.value;
        }
        if (optionId === undefined || optionId === null || optionId === '') {
            optionId = item.code;
        }

        let optionName = item.itemName;
        if (optionName === undefined || optionName === null || optionName === '') {
            optionName = item.audioLanguageName;
        }
        if (optionName === undefined || optionName === null || optionName === '') {
            optionName = item.languageName;
        }
        if (optionName === undefined || optionName === null || optionName === '') {
            optionName = item.name;
        }
        if (optionName === undefined || optionName === null || optionName === '') {
            optionName = item.title;
        }
        if (optionName === undefined || optionName === null || optionName === '') {
            optionName = item.label;
        }
        if (optionName === undefined || optionName === null || optionName === '') {
            optionName = item.value;
        }

        if (optionName === undefined || optionName === null) {
            return null;
        }

        optionName = optionName.toString().trim();
        if (!optionName) {
            return null;
        }

        if (optionId === undefined || optionId === null || optionId === '') {
            optionId = optionName + '_' + index;
        }

        return {
            id: optionId,
            itemName: optionName
        };
    }

    private setAudioLanguageValues(data: any) {
        let sourceAudioLanguage = [];

        if (data && Array.isArray(data.audioLanguage)) {
            sourceAudioLanguage = data.audioLanguage;
        } else if (data && Array.isArray(data.audio_language)) {
            sourceAudioLanguage = data.audio_language;
        } else if (data && data.results && Array.isArray(data.results.audioLanguage)) {
            sourceAudioLanguage = data.results.audioLanguage;
        } else if (data && data.results && Array.isArray(data.results.audio_language)) {
            sourceAudioLanguage = data.results.audio_language;
        }

        if (!sourceAudioLanguage.length) {
            this.createAssetGroupForm.controls['audioLanguage'].setValue([]);
            return;
        }

        let normalizedAudioLanguage = [];
        for (let i = 0; i < sourceAudioLanguage.length; i++) {
            const option = this.formatAudioLanguageOption(sourceAudioLanguage[i], i);
            if (option) {
                normalizedAudioLanguage.push(option);
            }
        }

        const selectedAudioLanguage = this.removeDuplicates(normalizedAudioLanguage, 'id');

        if (this.audioLanguageList.length) {
            this.audioLanguageList = this.removeDuplicates(this.audioLanguageList.concat(selectedAudioLanguage), 'id');
        } else {
            this.audioLanguageList = selectedAudioLanguage;
        }

        this.createAssetGroupForm.controls['audioLanguage'].setValue(selectedAudioLanguage);
    }

    private setSubtitleLanguageValues(data: any) {
        let sourceSubtitleLanguage = [];

        if (data && Array.isArray(data.subtitleLanguage)) {
            sourceSubtitleLanguage = data.subtitleLanguage;
        } else if (data && Array.isArray(data.subtitle_language)) {
            sourceSubtitleLanguage = data.subtitle_language;
        } else if (data && data.results && Array.isArray(data.results.subtitleLanguage)) {
            sourceSubtitleLanguage = data.results.subtitleLanguage;
        } else if (data && data.results && Array.isArray(data.results.subtitle_language)) {
            sourceSubtitleLanguage = data.results.subtitle_language;
        }

        if (!sourceSubtitleLanguage.length) {
            this.createAssetGroupForm.controls['subtitleLanguage'].setValue([]);
            return;
        }

        let normalizedSubtitleLanguage = [];
        for (let i = 0; i < sourceSubtitleLanguage.length; i++) {
            const option = this.formatAudioLanguageOption(sourceSubtitleLanguage[i], i);
            if (option) {
                normalizedSubtitleLanguage.push(option);
            }
        }

        const selectedSubtitleLanguage = this.removeDuplicates(normalizedSubtitleLanguage, 'id');

        if (this.subtitleLanguageList.length) {
            this.subtitleLanguageList = this.removeDuplicates(this.subtitleLanguageList.concat(selectedSubtitleLanguage), 'id');
        } else {
            this.subtitleLanguageList = selectedSubtitleLanguage;
        }

        this.createAssetGroupForm.controls['subtitleLanguage'].setValue(selectedSubtitleLanguage);
    }

    getAssetGroupInfo(id){

        // this.loader=true;
        this.commonService.changeloader(true);

        this.langId = localStorage.getItem('languageId');
        this.removeTrailerIndex = null;
        this.assetService.getAssetGroup(id, this.langId)
        .subscribe((result:any)=>{
                 this.mainObj = result.data[0];
                 console.log('main', this.mainObj)
                 this.removeTrailerIndex = null;
                 this.assetTitle = this.mainObj.title;
                 this.createdDate = moment(result.data[0].created_date).format('MM-DD-YYYY');
                 this.vendorName = '';
                 this.setVendorName(id, this.assetTitle);
                 this.loader=false;
                 this.commonService.changeloader(false);
                 let headerTitle = {
                    title:'Asset Management',
                    subTitle:'Asset Group (Series Setup)',
                    pageName:this.assetTitle
                }

                this.commonService.changeHeaderTitle(headerTitle);
                //(start) set dropdown by default empty
                //
                if(result.data[0].sameForAllProductType == null){
                    result.data[0].sameForAllProductType = "";
                }
                if(result.data[0].sameForAllZone == null){
                    result.data[0].sameForAllZone = "";
                }
                //(end) set dropdown by default empty

                // if(result.data[0].airStartDate!= null){

                //     let startTime = result.data[0].airStartDate.split('T').pop();
                //     console.log("startTime>>",startTime);
                //     startTime = startTime.slice(0, -5);


                //     this.createAssetGroupForm.controls['airStartDate'].setValue(moment(result.data[0].airStartDate).format("YYYY-MM-DD"));
                //     this.createAssetGroupForm.controls['airStartTime'].setValue(startTime);
                // }

                // if(result.data[0].airEndDate!= null){

                //     let endTime = result.data[0].airEndDate.split('T').pop();
                //     console.log("endTime>>",endTime);
                //     endTime = endTime.slice(0, -5);

                //     this.createAssetGroupForm.controls['airEndDate'].setValue(moment(result.data[0].airEndDate).format("YYYY-MM-DD"));
                //     this.createAssetGroupForm.controls['airEndTime'].setValue(endTime);
                // }

                // if(result.data[0].airStartDate!= null){

                //     let startTime = result.data[0].airStartDate.split('T').pop();
                //     let date = result.data[0].airStartDate.replace(startTime, '');
                //     date = date.replace('T', '');
                //     startTime = startTime.slice(0, -5);

                //     this.createAssetGroupForm.controls['airStartDate'].setValue(date);
                //     this.createAssetGroupForm.controls['airStartTime'].setValue(startTime);
                // }

                // if(result.data[0].airEndDate!= null){

                //     let endTime = result.data[0].airEndDate.split('T').pop();
                //     let date = result.data[0].airEndDate.replace(endTime, '');
                //     date = date.replace('T', '');
                //     endTime = endTime.slice(0, -5);

                //     this.createAssetGroupForm.controls['airEndDate'].setValue(date);
                //     this.createAssetGroupForm.controls['airEndTime'].setValue(endTime);
                // }

            this.title = result.data[0].title;
            //(end) set dropdown by default empty
            if(result.data[0].airStartDate!= null){

                let startTime = result.data[0].airStartDate.split('T').pop();
                let date = result.data[0].airStartDate.replace(startTime, '');
                 date = date.replace('T', '');

                startTime = startTime.slice(0, -5);
                console.log("date",date);

                if(startTime =='0000-00-00 00' || startTime ==''){

                    startTime = '';

                }


                if(date ==''){

                    date = '';

                }

                this.createAssetGroupForm.controls['airStartDate'].setValue(date);
                this.createAssetGroupForm.controls['airStartTime'].setValue(startTime);
            }

            if(result.data[0].airEndDate!= null){

                let endTime = result.data[0].airEndDate.split('T').pop();
                let date = result.data[0].airEndDate.replace(endTime, '');
                 date = date.replace('T', '');

                endTime = endTime.slice(0, -5);

                if(endTime =='0000-00-00 00'|| endTime =='' ){

                    endTime = null;

                }

                if(date ==''){

                    date = null;

                }
                console.log("date",date);
                console.log("endTime",endTime);

                this.createAssetGroupForm.controls['airEndDate'].setValue(date);
                // this.createNewAssetForm.controls['airEndDate'].setValue(moment(result.data[0].airEndDate).format("YYYY-MM-DD"));
                this.createAssetGroupForm.controls['airEndTime'].setValue(endTime);
            }


                this.createAssetGroupForm.controls['description'].setValue(result.data[0].description);
                this.createAssetGroupForm.controls['langMetadata'].setValue(result.data[0].langMetadata || []);
                this.createAssetGroupForm.controls['seconddescription'].setValue(result.data[0].seconddescription);
                this.createAssetGroupForm.controls['trailerUrl'].setValue(result.data[0].trailerUrl || '');
                this.createAssetGroupForm.controls['previewUrl'].setValue(result.data[0].previewUrl || '');
                this.createAssetGroupForm.controls['exclusionText'].setValue(result.data[0].exclusionText);
                this.createAssetGroupForm.controls['title'].setValue(result.data[0].title);
                this.createAssetGroupForm.controls['displayIndexing'].setValue(result.data[0].displayIndexing);
                this.createAssetGroupForm.controls['permaLink'].setValue(result.data[0].permaLink);
                this.createAssetGroupForm.controls['productionYear'].setValue(result.data[0].productionYear);
                this.createAssetGroupForm.controls['isActive'].setValue(result.data[0].isActive);
                this.createAssetGroupForm.controls['sameForAllProductType'].setValue(result.data[0].sameForAllProductType);
                this.createAssetGroupForm.controls['sameForAllZone'].setValue(result.data[0].sameForAllZone);
                this.createAssetGroupForm.controls['seoTitle'].setValue(result.data[0].seoTitle);
                this.createAssetGroupForm.controls['seoDescription'].setValue(result.data[0].seoDescription);
                this.createAssetGroupForm.controls['seoKeyword'].setValue(result.data[0].seoKeyword);
                this.createAssetGroupForm.controls['sorting'].setValue(result.data[0].sorting);
                this.createAssetGroupForm.controls['orderBy'].setValue(result.data[0].orderBy);
                this.createAssetGroupForm.controls['assetGroupType'].setValue(result.data[0].assetGroupType);
                this.createAssetGroupForm.controls['coinsType'].setValue(result.data[0].coinsType || 'uniform');
                this.createAssetGroupForm.controls['coinsToRedeem'].setValue(result.data[0].coinsToRedeem || 0);
                this.setAudioLanguageValues(result.data[0]);
                this.setSubtitleLanguageValues(result.data[0]);

                this.createAssetGroupForm.controls['publisherState'].setValue(result.data[0].publisherState);
                this.createAssetGroupForm.controls['reviewerState'].setValue(result.data[0].reviewerState);

                console.log("result.data[0]===",result.data[0]);
                if(result.data[0].contentState == null || result.data[0].contentState == '' || result.data[0].contentState == undefined){
                    this.createAssetGroupForm.controls['contentState'].setValue(['In-Progress']);
                }
                else{
                    this.createAssetGroupForm.controls['contentState'].setValue(result.data[0].contentState);
                }

                this.selectedProductTypeItems=[];
                this.selectedProductlist=[];
                this.productTypeMappingFilter.geoZoneId=[];

                if(result.data[0].results.geoZone.length>0){

                    for(let i = 0 ;i < result.data[0].results.geoZone.length;i++){
                      if(result.data[0].results.geoZone[i].geoZoneName == 'Global') {
                        this.isGlobal = true;
                      }
                        let obj={
                        'id':result.data[0].results.geoZone[i].geoZoneId,
                        'itemName':result.data[0].results.geoZone[i].geoZoneName,
                        }
                        this.selectedProductTypeItems.push(obj);
                        this.selectedProductTypeItems = this.removeDuplicates(this.selectedProductTypeItems, "id");

                        this.mapProductTypeArrayTemp = this.selectedProductTypeItems;
                        this.productTypeMappingFilter.geoZoneId.push(obj.id);
                    }
                    this.createAssetGroupForm.controls['mapGeoZone'].setValue(this.selectedProductTypeItems);
                    this.getProductTypeInfo(this.productTypeMappingFilter);

                }
            if( result.data[0].results.cast.length>0){

                this.selectedmapCast = [];

                    for(let i = 0 ;i < result.data[0].results.cast.length;i++){
                        let obj={
                        'id':result.data[0].results.cast[i].castId,
                        'itemName':result.data[0].results.cast[i].castFirstName,
                        }
                        this.selectedmapCast.push(obj);

                    }

               // this.createNewAssetForm.controls['mapCast'].setValue(this.selectedmapCast);
            }
            if( result.data[0].results.cast.length>0){

                let mapCast = [];

                for(let i = 0 ;i < result.data[0].results.cast.length;i++){

                    let obj={
                    'id':result.data[0].results.cast[i].castId,
                    'itemName':result.data[0].results.cast[i].castFirstName,
                    }

                    mapCast.push(obj);
                    this.createAssetGroupForm.controls['mapCast'].setValue(mapCast);

                }

                this.mapcastDynamicForm = this.formBuilder.group({
            
                    mapcasts: this.formBuilder.array([])
            
                });
            
                this.mapcasts = this.mapcastDynamicForm.get('mapcasts') as FormArray;
            
                for(let i=0;i< result.data[0].results.cast.length;i++){
            
                    this.mapcasts.push(this.updatefromgroup(result.data[0].results.cast[i],'cast'));
                }

        }

                // this.selectedmapCast=[];
                if( result.data[0].results.character.length>0){

                    for(let i = 0 ;i < result.data[0].results.character.length;i++){
                        let obj={
                        'id':result.data[0].results.character[i].characterId,
                        'itemName':result.data[0].results.character[i].characterFirstName,
                        }
                        // this.selectedmapCast.push(obj);
                        // this.createAssetGroupForm.controls['mapCharacter'].setValue(this.selectedmapCast);
                    }


                }

                if(result.data[0].results.primaryNavigation.length>0){

                    this.selectedprimaryNavigationList = [];

                    for(let i = 0 ;i < result.data[0].results.primaryNavigation.length;i++){
                        let obj={
                            'id':result.data[0].results.primaryNavigation[i].primaryNavigationId,
                            'itemName':result.data[0].results.primaryNavigation[i].primaryNavigationName,
                        }
                        this.selectedprimaryNavigationList.push(obj);
                        this.mapPrimaryNavigationArrayTemp = this.selectedprimaryNavigationList;
                        if(!this.menuCategoryMappingFilter.primaryNavigationId) this.menuCategoryMappingFilter.primaryNavigationId = []
                        this.menuCategoryMappingFilter.primaryNavigationId.push(obj.id);
                        this.selectedprimaryNavigationList = this.removeDuplicates(this.selectedprimaryNavigationList,"id");
                        this.createAssetGroupForm.controls['mapPrimaryNavigation'].setValue(this.selectedprimaryNavigationList);
                    }

                    this.getGlobalMenuCategory(this.menuCategoryMappingFilter);
                }

                let certificationArray=[];
                if( result.data[0].results.certification.length>0){

                    if(result.data[0].results.certification.length>0){

                        for(let i = 0 ;i < result.data[0].results.certification.length;i++){
                            let obj={
                            'id':result.data[0].results.certification[i].certificationId,
                            'itemName':result.data[0].results.certification[i].certificationName,
                            }
                            certificationArray.push(obj);

                            this.createAssetGroupForm.controls['mapCertification'].setValue(certificationArray);

                        }
                    }
                }

                if( result.data[0].results.menuCategory.length>0){

                    if(result.data[0].results.menuCategory.length>0){

                        this.selectedmenuCategoryList = [];

                        for(let i = 0 ;i < result.data[0].results.menuCategory.length;i++){
                            let obj={
                            'id':result.data[0].results.menuCategory[i].menuCategoryId,
                            'itemName':result.data[0].results.menuCategory[i].menuCategoryName,
                            }
                            this.selectedmenuCategoryList.push(obj);
                            this.mapMenuCategoryArrayTemp = this.selectedmenuCategoryList;
                        }
                    }
                    this.createAssetGroupForm.controls['mapMenuCategory'].setValue(this.selectedmenuCategoryList);
                }
                if(result.data[0].results.productType.length>0){

                    // this.selectedProductlist = [];

                    for(let i = 0 ;i < result.data[0].results.productType.length;i++){

                        let obj={
                        'id':result.data[0].results.productType[i].productTypeId,
                        'itemName':result.data[0].results.productType[i].productTypeName,
                        }
                        this.selectedProductlist.push(obj);
                        this.mapProductTypeArrayTemp=this.selectedProductlist;
                        this.primaryNavigationMappingFilter.productTypeId.push(obj.id);

                    }

                    // this.createAssetGroupForm.controls['mapProductType'].setValue(this.selectedProductlist);
                    this.getNavigationInfo(this.primaryNavigationMappingFilter);
                }

                let arrayObj=[]
                if(result.data[0].results.genre.length>0){

                    for(let i = 0 ;i < result.data[0].results.genre.length;i++){

                        let obj={
                        'id':result.data[0].results.genre[i].genreId,
                        'itemName':result.data[0].results.genre[i].genreName,
                        }
                        arrayObj.push(obj);
                    }
                    this.createAssetGroupForm.controls['mapGenre'].setValue(arrayObj);
                }

                arrayObj=[]
                if(result.data[0].results.sponsor.length>0){

                    for(let i = 0 ;i < result.data[0].results.sponsor.length;i++){

                        let obj={
                        'id':result.data[0].results.sponsor[i].sponsorId,
                        'itemName':result.data[0].results.sponsor[i].sponsorName,
                        }
                        arrayObj.push(obj);
                    }
                    this.createAssetGroupForm.controls['mapSponsor'].setValue(arrayObj);
                }

                arrayObj=[]
                if(result.data[0].results.language.length>0){

                    for(let i = 0 ;i < result.data[0].results.language.length;i++){

                        let obj={
                        'id':result.data[0].results.language[i].languageId,
                        'itemName':result.data[0].results.language[i].languageName,
                        }
                        arrayObj.push(obj);
                    }
                    this.createAssetGroupForm.controls['mapLanguage'].setValue(arrayObj);
                }

                arrayObj=[]
                if(result.data[0].results.library.length>0){

                    for(let i = 0 ;i < result.data[0].results.library.length;i++){

                        let obj={
                        'id':result.data[0].results.library[i].libraryId,
                        'itemName':result.data[0].results.library[i].libraryName,
                        }
                        arrayObj.push(obj);
                    }
                    this.createAssetGroupForm.controls['mapLibrary'].setValue(arrayObj);
                }

                arrayObj=[]
                if(result.data[0].results.review.length>0){

                    for(let i = 0 ;i < result.data[0].results.review.length;i++){

                        let obj={
                        'id':result.data[0].results.review[i].reviewId,
                        'itemName':result.data[0].results.review[i].reviewFirstName,
                        }
                        arrayObj.push(obj);
                    }
                    this.createAssetGroupForm.controls['mapReview'].setValue(arrayObj);
                }

                arrayObj=[]
                if(result.data[0].results.classification.length>0){

                    for(let i = 0 ;i < result.data[0].results.classification.length;i++){

                        let obj={
                        'id':result.data[0].results.classification[i].classificationId,
                        'itemName':result.data[0].results.classification[i].classificationName,
                        }
                        arrayObj.push(obj);
                    }
                    this.createAssetGroupForm.controls['mapClassification'].setValue(arrayObj);
                }

                const marketingData = result.data[0].results.marketing
                    && result.data[0].results.marketing.length
                    ? Object.assign({}, result.data[0].results.marketing[0])
                    : {};
                this.marketingSetupData = marketingData;
                this.createAssetGroupForm.controls['marketingBannerFileName'].setValue(marketingData.bannerFileName || '');
                this.createAssetGroupForm.controls['marketingBannerFilePath'].setValue(marketingData.bannerFilePath || '');
                this.setupBannerImageURL = marketingData.bannerFilePath || '';

                this.img=[];
                // Reset every per-row image array before repopulating, otherwise any leftover
                // seed entry (e.g. from init/reset) shifts the arrays out of sync with the
                // device rows and the image renders against the wrong (empty) index.
                this.img2=[];
                this.img3=[];
                this.img4=[];
                this.img5=[];
                this.imgPlain=[];
                this.imgPlain2=[];
                this.imgPlain3=[];
                this.imgPlain4=[];
                this.imgPlain5=[];
                if(result.data[0].results.productDeviceTypeConfigure.length>0){

                    this.multipleDeviceForm = this.formBuilder.group({
                        devices: this.formBuilder.array([])
                    });

                //device type validation code start
                    if(result.data[0].results.productDeviceTypeConfigure.length == 4){
                        this.deviceTypeFull = true;
                    }
                  //device type validation code end

                        this.devices = this.multipleDeviceForm.get('devices') as FormArray;

                        for(let i=0;i< result.data[0].results.productDeviceTypeConfigure.length;i++){

                            this.img.push({
                                horizontalURL:result.data[0].results.productDeviceTypeConfigure[i].horizontalFilePath,
                                verticalURL:result.data[0].results.productDeviceTypeConfigure[i].verticalFilePath
                            })
                            this.img2.push({
                                horizontalURL: result.data[0].results.productDeviceTypeConfigure[i].horizontalFilePath2,
                                // || result.data[0].results.productDeviceTypeConfigure[i].secondHorizontalFilePath
                                verticalURL: result.data[0].results.productDeviceTypeConfigure[i].verticalFilePath2
                                // || result.data[0].results.productDeviceTypeConfigure[i].secondVerticalFilePath 
                            })
                            this.img3.push({
                                horizontalURL: result.data[0].results.productDeviceTypeConfigure[i].horizontalFilePath3 || '',
                                verticalURL: result.data[0].results.productDeviceTypeConfigure[i].verticalFilePath3 || ''
                            })
                            this.img4.push({
                                horizontalURL: result.data[0].results.productDeviceTypeConfigure[i].horizontalFilePath4 || '',
                                verticalURL: result.data[0].results.productDeviceTypeConfigure[i].verticalFilePath4 || ''
                            })
                            this.img5.push({
                                horizontalURL: result.data[0].results.productDeviceTypeConfigure[i].horizontalFilePath5 || '',
                                verticalURL: result.data[0].results.productDeviceTypeConfigure[i].verticalFilePath5 || ''
                            })
                            this.imgPlain.push({
                                verticalPlainURL: this.resolveRenderableImageUrl(result.data[0].results.productDeviceTypeConfigure[i].verticalFilePathPlain, 'verticalFilePathPlain')
                            })
                            this.imgPlain2.push({
                                verticalPlainURL: this.resolveRenderableImageUrl(
                                    result.data[0].results.productDeviceTypeConfigure[i].verticalFilePathPlain2
                                        || result.data[0].results.productDeviceTypeConfigure[i].verticalFilePathPlain1,
                                    'verticalFilePathPlain2'
                                ) || this.resolveRenderableImageUrl(result.data[0].results.productDeviceTypeConfigure[i].verticalFilePathPlain1, 'verticalFilePathPlain1')
                            })
                            this.imgPlain3.push({
                                verticalPlainURL: this.resolveRenderableImageUrl(result.data[0].results.productDeviceTypeConfigure[i].verticalFilePathPlain3, 'verticalFilePathPlain3')
                            })
                            this.imgPlain4.push({
                                verticalPlainURL: this.resolveRenderableImageUrl(result.data[0].results.productDeviceTypeConfigure[i].verticalFilePathPlain4, 'verticalFilePathPlain4')
                            })
                            this.imgPlain5.push({
                                verticalPlainURL: this.resolveRenderableImageUrl(result.data[0].results.productDeviceTypeConfigure[i].verticalFilePathPlain5, 'verticalFilePathPlain5')
                            })

                            this.verticalfilepath = result.data[0].results.productDeviceTypeConfigure[i].verticalFilePath;

                            let objH = {
                                'index':"",
                                'deviceType':"",
                                'selectedFiles':"",
                                "horizontalFileName": "",
                                "horizontalFilePath": "",
                                "horizontalFileType": "",
                                'horizontalFile':false
                            }

                            let objV = {
                                'index':"",
                                'deviceType':"",
                                'selectedFiles':"",
                                "verticalFileName":"",
                                "verticalFilePath": "",
                                "verticalFileType":"",
                                'verticalFile':false,

                            }

                            let objVPlain = {
                                'index':"",
                                'deviceType':"",
                                'selectedFiles':"",
                                "verticalFileNamePlain":"",
                                "verticalFilePathPlain": "",
                                "verticalFileTypePlain":"",
                                'verticalFilePlain':false,
                            }

                            this.uploadImgFilePathHorizontal.push(objH);
                            this.uploadImgFilePathVertical.push(objV);
                            this.uploadImgFilePathVerticalPlain.push(objVPlain);

                            this.devices.push(this.updateItem(
                                result.data[0].results.productDeviceTypeConfigure[i],
                                result.data[0].trailerUrl,
                                result.data[0].previewUrl
                            ));
                            this.createAssetGroupForm.controls['vodOrLivePosterImageFileName'].setValue(result.data[0].results.productDeviceTypeConfigure[i].vodOrLivePosterImageFileName);
                            this.createAssetGroupForm.controls['vodOrLivePosterImageFilePath'].setValue(result.data[0].results.productDeviceTypeConfigure[i].vodOrLivePosterImageFilePath);
                            this.createAssetGroupForm.controls['vodOrLivePosterImageFileType'].setValue(result.data[0].results.productDeviceTypeConfigure[i].vodOrLivePosterImageFileType);
                            this.createAssetGroupForm.controls['TitleImageFileName'].setValue(
                                result.data[0].results.productDeviceTypeConfigure[i].thumbFileName
                                || result.data[0].results.productDeviceTypeConfigure[i].TitleImageFileName
                            );
                            this.createAssetGroupForm.controls['ThumbnailImage'].setValue(result.data[0].results.productDeviceTypeConfigure[i].thumbFilePath);
                            this.createAssetGroupForm.controls['TitleImageFileType'].setValue(
                                result.data[0].results.productDeviceTypeConfigure[i].thumbFileType
                                || result.data[0].results.productDeviceTypeConfigure[i].TitleImageFileType
                            );
                            this.createAssetGroupForm.controls['contentType'].setValue(result.data[0].results.productDeviceTypeConfigure[i].contentType);
                            this.createAssetGroupForm.controls['sorting'].setValue(result.data[0].results.productDeviceTypeConfigure[i].sorting);
                            this.createAssetGroupForm.controls['orderBy'].setValue(result.data[0].results.productDeviceTypeConfigure[i].orderBy);
                            this.createAssetGroupForm.controls['assetGroupType'].setValue(result.data[0].results.productDeviceTypeConfigure[i].assetGroupType);
                            this.FilePosterImageURL =result.data[0].results.productDeviceTypeConfigure[i].vodOrLivePosterImageFilePath;
                            this.FiletitleImageURL = result.data[0].results.productDeviceTypeConfigure[i].TitleFilePath || '';
                            this.FilethumbImageURL = result.data[0].results.productDeviceTypeConfigure[i].thumbFilePath || '';
                            this.FilePosterImageURL2 = result.data[0].results.productDeviceTypeConfigure[i].posterFilePath2 || '';
                            this.FiletitleImageURL2 = result.data[0].results.productDeviceTypeConfigure[i].titleFilePath2 || '';
                            this.FilethumbImageURL2 = result.data[0].results.productDeviceTypeConfigure[i].thumbFilePath2 || '';
                            this.FilePosterImageURL3 = result.data[0].results.productDeviceTypeConfigure[i].posterFilePath3 || '';
                            this.FiletitleImageURL3 = result.data[0].results.productDeviceTypeConfigure[i].titleFilePath3 || '';
                            this.FilethumbImageURL3 = result.data[0].results.productDeviceTypeConfigure[i].thumbFilePath3 || '';
                            this.FilePosterImageURL4 = result.data[0].results.productDeviceTypeConfigure[i].posterFilePath4 || '';
                            this.FiletitleImageURL4 = result.data[0].results.productDeviceTypeConfigure[i].titleFilePath4 || '';
                            this.FilethumbImageURL4 = result.data[0].results.productDeviceTypeConfigure[i].thumbFilePath4 || '';
                            this.FilePosterImageURL5 = result.data[0].results.productDeviceTypeConfigure[i].posterFilePath5 || '';
                            this.FiletitleImageURL5 = result.data[0].results.productDeviceTypeConfigure[i].titleFilePath5 || '';
                            this.FilethumbImageURL5 = result.data[0].results.productDeviceTypeConfigure[i].thumbFilePath5 || '';


                        }
                }

        });

    }

    //below function to maintain state of reviewer
    onReviewerStateChange(item,reviewerStateActive){

      console.log(reviewerStateActive, "item.statusmanagement",item);

          let contentStatusId = '';

          if(reviewerStateActive == "Un-approved"){

              contentStatusId = 'In-Progress';

          } else if(reviewerStateActive == "Approved"){

              contentStatusId = 'Completed';

          } else if(reviewerStateActive == "Rejected"){

              contentStatusId = 'In-Progress';
          }

          let statusObj = [
              {
                "contentType": 'asset_group',
                "contentIds": [ item.id],
                "statusType": "reviewer_state",
                "statusId":reviewerStateActive
              },
              {
                "contentType": 'asset_group',
                "contentIds": [ item.id],
                "statusType": "content_state",
                "statusId": contentStatusId
              }
          ]

          // this.actionApiSend.emit(statusObj)
                //below code is for status management
                this.statusService.updateStatus(statusObj)
                .subscribe((result:any)=>{
                    console.log('.......', result);
                    // this.toastrService.success('Status Updated Successfully.');
                })
    }
    castFilter: any = {};

    getCastInfo(){

        this.commonService.getGlobalCast(this.castFilter,this.startCast,10).subscribe((result:any)=>{

          //  this.mapCastList = [];
          this.searchDecouncer$.next(null);

            if(result.data.data.length > 0){

                if(this.isSearch == true){

                    this.mapCastList = [];
                    this.isSearch = false;

                }

                for (let castLists of result.data.data) {

                    if(castLists.castFirstName!=''){
                    this.mapCastList.push(
                        {
                            'id': castLists.castId,
                            'itemName': castLists.castFirstName
                        });
                    }
                    var ids = new Set(this.selectedmapCast.map(({ id }) => id));

                    this.mapCastList = this.mapCastList.filter(({ id }) => !ids.has(id));
                    this.mapCastList = this.removeDuplicates(this.mapCastList, "id");

                }

            }

        });

    }

    startCast = 0;
    fetchMoreGetCast(event){

        if ((event.endIndex == this.mapCastList.length - 1) && (this.mapCastList.length>=8)) {

                this.startCast = this.startCast + 10;
                this.getCastInfo();

        }
    }

    selectFileVertical(e ,i) {

        if(e.target.files[0].name==undefined)
        return;

        this.uploadImgFilePathVertical[i].index = i;
        this.uploadImgFilePathVertical[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
        this.uploadImgFilePathVertical[i].selectedFiles = e.target.files.item(0);
        this.uploadImgFilePathVertical[i].verticalFileName =  e.target.files[0].name;
        this.uploadImgFilePathVertical[i].verticalFileType = e.target.files[0].type;
        this.uploadImgFilePathVertical[i].verticalFile = true;

            var mimeType = e.target.files[0].type;
            if (mimeType.match(/image\/*/) == null) {
                console.log("Only images are supported.");
                return;
            }

        var reader = new FileReader();

            reader.readAsDataURL(e.target.files[0]);
            reader.onload = (_event) => {

                this.img[i].verticalURL=reader.result;
                console.log("this.img[i].",this.img[i]);
            }

            e.target.value = '';


    }
    selectFileVertical2(e ,i) {

        if(e.target.files[0].name==undefined)
        return;

        if(!this.uploadImgFilePathVertical2[i]){
            this.uploadImgFilePathVertical2[i] = {};
        }
        if(!this.img2[i]){
            this.img2[i] = { horizontalURL:'', verticalURL:'' };
        }
        this.uploadImgFilePathVertical2[i].index = i;
        this.uploadImgFilePathVertical2[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
        this.uploadImgFilePathVertical2[i].selectedFiles = e.target.files.item(0);
        this.uploadImgFilePathVertical2[i].verticalFileName2 =  e.target.files[0].name;
        this.uploadImgFilePathVertical2[i].verticalFileType2 = e.target.files[0].type;
        this.uploadImgFilePathVertical2[i].verticalFile2 = true;

            var mimeType = e.target.files[0].type;
            if (mimeType.match(/image\/*/) == null) {
                console.log("Only images are supported.");
                return;
            }

        var reader = new FileReader();

            reader.readAsDataURL(e.target.files[0]);
            reader.onload = (_event) => {

                this.img2[i].verticalURL=reader.result;
                console.log("this.img2[i].",this.img2[i]);
            }

            e.target.value = '';
    }
    selectFileVertical3(e ,i) {
        if(e.target.files[0].name==undefined) return;
        if(!this.uploadImgFilePathVertical3[i]) this.uploadImgFilePathVertical3[i] = {};
        if(!this.img3[i]) this.img3[i] = { horizontalURL:'', verticalURL:'' };
        this.uploadImgFilePathVertical3[i].index = i;
        this.uploadImgFilePathVertical3[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
        this.uploadImgFilePathVertical3[i].selectedFiles = e.target.files.item(0);
        this.uploadImgFilePathVertical3[i].verticalFileName3 = e.target.files[0].name;
        this.uploadImgFilePathVertical3[i].verticalFileType3 = e.target.files[0].type;
        this.uploadImgFilePathVertical3[i].verticalFile3 = true;
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) return;
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.img3[i].verticalURL=reader.result; };
        e.target.value = '';
    }
    selectFileVertical4(e ,i) {
        if(e.target.files[0].name==undefined) return;
        if(!this.uploadImgFilePathVertical4[i]) this.uploadImgFilePathVertical4[i] = {};
        if(!this.img4[i]) this.img4[i] = { horizontalURL:'', verticalURL:'' };
        this.uploadImgFilePathVertical4[i].index = i;
        this.uploadImgFilePathVertical4[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
        this.uploadImgFilePathVertical4[i].selectedFiles = e.target.files.item(0);
        this.uploadImgFilePathVertical4[i].verticalFileName4 = e.target.files[0].name;
        this.uploadImgFilePathVertical4[i].verticalFileType4 = e.target.files[0].type;
        this.uploadImgFilePathVertical4[i].verticalFile4 = true;
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) return;
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.img4[i].verticalURL=reader.result; };
        e.target.value = '';
    }
    selectFileVertical5(e ,i) {
        if(e.target.files[0].name==undefined) return;
        if(!this.uploadImgFilePathVertical5[i]) this.uploadImgFilePathVertical5[i] = {};
        if(!this.img5[i]) this.img5[i] = { horizontalURL:'', verticalURL:'' };
        this.uploadImgFilePathVertical5[i].index = i;
        this.uploadImgFilePathVertical5[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
        this.uploadImgFilePathVertical5[i].selectedFiles = e.target.files.item(0);
        this.uploadImgFilePathVertical5[i].verticalFileName5 = e.target.files[0].name;
        this.uploadImgFilePathVertical5[i].verticalFileType5 = e.target.files[0].type;
        this.uploadImgFilePathVertical5[i].verticalFile5 = true;
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) return;
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.img5[i].verticalURL=reader.result; };
        e.target.value = '';
    }

    selectFileVerticalPlain(e ,i) {
        if(e.target.files[0].name==undefined)
        return;
        if(!this.uploadImgFilePathVerticalPlain[i]){
            this.uploadImgFilePathVerticalPlain[i] = {};
        }
        if(!this.imgPlain[i]){
            this.imgPlain[i] = { verticalPlainURL:'' };
        }
        this.uploadImgFilePathVerticalPlain[i].index = i;
        this.uploadImgFilePathVerticalPlain[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
        this.uploadImgFilePathVerticalPlain[i].selectedFiles = e.target.files.item(0);
        this.uploadImgFilePathVerticalPlain[i].verticalFileNamePlain =  e.target.files[0].name;
        this.uploadImgFilePathVerticalPlain[i].verticalFileTypePlain = e.target.files[0].type;
        this.uploadImgFilePathVerticalPlain[i].verticalFilePlain = true;
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            return;
        }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => {
            this.imgPlain[i].verticalPlainURL=reader.result;
        }
        e.target.value = '';
    }

    selectFileVerticalPlain2(e ,i) {
        if(e.target.files[0].name==undefined) return;
        if(!this.uploadImgFilePathVerticalPlain2[i]) this.uploadImgFilePathVerticalPlain2[i] = {};
        if(!this.imgPlain2[i]) this.imgPlain2[i] = { verticalPlainURL:'' };
        this.uploadImgFilePathVerticalPlain2[i].index = i;
        this.uploadImgFilePathVerticalPlain2[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
        this.uploadImgFilePathVerticalPlain2[i].selectedFiles = e.target.files.item(0);
        this.uploadImgFilePathVerticalPlain2[i].verticalFileNamePlain2 = e.target.files[0].name;
        this.uploadImgFilePathVerticalPlain2[i].verticalFileTypePlain2 = e.target.files[0].type;
        this.uploadImgFilePathVerticalPlain2[i].verticalFilePlain2 = true;
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) return;
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.imgPlain2[i].verticalPlainURL=reader.result; };
        e.target.value = '';
    }

    selectFileVerticalPlain3(e ,i) {
        if(e.target.files[0].name==undefined) return;
        if(!this.uploadImgFilePathVerticalPlain3[i]) this.uploadImgFilePathVerticalPlain3[i] = {};
        if(!this.imgPlain3[i]) this.imgPlain3[i] = { verticalPlainURL:'' };
        this.uploadImgFilePathVerticalPlain3[i].index = i;
        this.uploadImgFilePathVerticalPlain3[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
        this.uploadImgFilePathVerticalPlain3[i].selectedFiles = e.target.files.item(0);
        this.uploadImgFilePathVerticalPlain3[i].verticalFileNamePlain3 = e.target.files[0].name;
        this.uploadImgFilePathVerticalPlain3[i].verticalFileTypePlain3 = e.target.files[0].type;
        this.uploadImgFilePathVerticalPlain3[i].verticalFilePlain3 = true;
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) return;
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.imgPlain3[i].verticalPlainURL=reader.result; };
        e.target.value = '';
    }

    selectFileVerticalPlain4(e ,i) {
        if(e.target.files[0].name==undefined) return;
        if(!this.uploadImgFilePathVerticalPlain4[i]) this.uploadImgFilePathVerticalPlain4[i] = {};
        if(!this.imgPlain4[i]) this.imgPlain4[i] = { verticalPlainURL:'' };
        this.uploadImgFilePathVerticalPlain4[i].index = i;
        this.uploadImgFilePathVerticalPlain4[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
        this.uploadImgFilePathVerticalPlain4[i].selectedFiles = e.target.files.item(0);
        this.uploadImgFilePathVerticalPlain4[i].verticalFileNamePlain4 = e.target.files[0].name;
        this.uploadImgFilePathVerticalPlain4[i].verticalFileTypePlain4 = e.target.files[0].type;
        this.uploadImgFilePathVerticalPlain4[i].verticalFilePlain4 = true;
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) return;
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.imgPlain4[i].verticalPlainURL=reader.result; };
        e.target.value = '';
    }

    selectFileVerticalPlain5(e ,i) {
        if(e.target.files[0].name==undefined) return;
        if(!this.uploadImgFilePathVerticalPlain5[i]) this.uploadImgFilePathVerticalPlain5[i] = {};
        if(!this.imgPlain5[i]) this.imgPlain5[i] = { verticalPlainURL:'' };
        this.uploadImgFilePathVerticalPlain5[i].index = i;
        this.uploadImgFilePathVerticalPlain5[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
        this.uploadImgFilePathVerticalPlain5[i].selectedFiles = e.target.files.item(0);
        this.uploadImgFilePathVerticalPlain5[i].verticalFileNamePlain5 = e.target.files[0].name;
        this.uploadImgFilePathVerticalPlain5[i].verticalFileTypePlain5 = e.target.files[0].type;
        this.uploadImgFilePathVerticalPlain5[i].verticalFilePlain5 = true;
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) return;
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.imgPlain5[i].verticalPlainURL=reader.result; };
        e.target.value = '';
    }

    isGlobal =  false;
    OnGlobal(eve) {
        this.mapGeoZoneError = false;
      if(eve.target.checked == true) {
         this.isGlobal = true;
         let obj={
          'id': 1,
          'itemName': 'Global',
          }
          if(this.createAssetGroupForm.value.mapGeoZone.length > 0) {
            this.createAssetGroupForm.value.mapGeoZone = [];
            this.createAssetGroupForm.controls['mapGeoZone'].setValue([]);
            return this.createAssetGroupForm.value.mapGeoZone.push(obj)
          } else {
            return this.createAssetGroupForm.value.mapGeoZone.push(obj);
          }

      } else {
         this.isGlobal = false;
      }
    }
    selectFileHorizontal(e ,i) {

      //set obj for file upload of horizontal section
      if(e.target.files[0].name==undefined)
      return;

      this.uploadImgFilePathHorizontal[i].index = i;
      this.uploadImgFilePathHorizontal[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
      this.uploadImgFilePathHorizontal[i].selectedFiles = e.target.files.item(0);
      this.uploadImgFilePathHorizontal[i].horizontalFileName =  e.target.files[0].name;
      this.uploadImgFilePathHorizontal[i].horizontalFileType = e.target.files[0].type;
      this.uploadImgFilePathHorizontal[i].horizontalFile = true;

        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            console.log("Only images are supported.");
            return;
        }

        this.img.push({
            horizontalURL:'',
            verticalURL:''
        })

        var reader = new FileReader();

            reader.readAsDataURL(e.target.files[0]);
            reader.onload = (_event) => {
                this.img[i].horizontalURL=reader.result;
                console.log("this.img[i].",this.img[i]);
            }

            e.target.value = '';

    }
    selectFileHorizontal2(e ,i) {

      if(e.target.files[0].name==undefined)
      return;

      if(!this.uploadImgFilePathHorizontal2[i]){
        this.uploadImgFilePathHorizontal2[i] = {};
      }
      if(!this.img2[i]){
        this.img2[i] = { horizontalURL:'', verticalURL:'' };
      }
      this.uploadImgFilePathHorizontal2[i].index = i;
      this.uploadImgFilePathHorizontal2[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
      this.uploadImgFilePathHorizontal2[i].selectedFiles = e.target.files.item(0);
      this.uploadImgFilePathHorizontal2[i].horizontalFileName2 =  e.target.files[0].name;
      this.uploadImgFilePathHorizontal2[i].horizontalFileType2 = e.target.files[0].type;
      this.uploadImgFilePathHorizontal2[i].horizontalFile2 = true;

        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            console.log("Only images are supported.");
            return;
        }

        var reader = new FileReader();

            reader.readAsDataURL(e.target.files[0]);
            reader.onload = (_event) => {
                this.img2[i].horizontalURL=reader.result;
                console.log("this.img2[i].",this.img2[i]);
            }

            e.target.value = '';

    }
    selectFileHorizontal3(e ,i) {
      if(e.target.files[0].name==undefined) return;
      if(!this.uploadImgFilePathHorizontal3[i]) this.uploadImgFilePathHorizontal3[i] = {};
      if(!this.img3[i]) this.img3[i] = { horizontalURL:'', verticalURL:'' };
      this.uploadImgFilePathHorizontal3[i].index = i;
      this.uploadImgFilePathHorizontal3[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
      this.uploadImgFilePathHorizontal3[i].selectedFiles = e.target.files.item(0);
      this.uploadImgFilePathHorizontal3[i].horizontalFileName3 = e.target.files[0].name;
      this.uploadImgFilePathHorizontal3[i].horizontalFileType3 = e.target.files[0].type;
      this.uploadImgFilePathHorizontal3[i].horizontalFile3 = true;
      var mimeType = e.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) return;
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (_event) => { this.img3[i].horizontalURL=reader.result; };
      e.target.value = '';
    }
    selectFileHorizontal4(e ,i) {
      if(e.target.files[0].name==undefined) return;
      if(!this.uploadImgFilePathHorizontal4[i]) this.uploadImgFilePathHorizontal4[i] = {};
      if(!this.img4[i]) this.img4[i] = { horizontalURL:'', verticalURL:'' };
      this.uploadImgFilePathHorizontal4[i].index = i;
      this.uploadImgFilePathHorizontal4[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
      this.uploadImgFilePathHorizontal4[i].selectedFiles = e.target.files.item(0);
      this.uploadImgFilePathHorizontal4[i].horizontalFileName4 = e.target.files[0].name;
      this.uploadImgFilePathHorizontal4[i].horizontalFileType4 = e.target.files[0].type;
      this.uploadImgFilePathHorizontal4[i].horizontalFile4 = true;
      var mimeType = e.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) return;
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (_event) => { this.img4[i].horizontalURL=reader.result; };
      e.target.value = '';
    }
    selectFileHorizontal5(e ,i) {
      if(e.target.files[0].name==undefined) return;
      if(!this.uploadImgFilePathHorizontal5[i]) this.uploadImgFilePathHorizontal5[i] = {};
      if(!this.img5[i]) this.img5[i] = { horizontalURL:'', verticalURL:'' };
      this.uploadImgFilePathHorizontal5[i].index = i;
      this.uploadImgFilePathHorizontal5[i].deviceType = this.multipleDeviceForm.value.devices[i].dtypeId;
      this.uploadImgFilePathHorizontal5[i].selectedFiles = e.target.files.item(0);
      this.uploadImgFilePathHorizontal5[i].horizontalFileName5 = e.target.files[0].name;
      this.uploadImgFilePathHorizontal5[i].horizontalFileType5 = e.target.files[0].type;
      this.uploadImgFilePathHorizontal5[i].horizontalFile5 = true;
      var mimeType = e.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) return;
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (_event) => { this.img5[i].horizontalURL=reader.result; };
      e.target.value = '';
    }
    selectFilePosterImage(e){

        console.log("e.target.files>>>",e);

       this.loader = true;

       this.uploadImgFilePosterImage=[];

        let obj = {
            'index':0,
            'selectedFiles':e.target.files.item(0),
            "fileName": e.target.files[0].name,
            "filePath": "",
            "fileType": e.target.files[0].type,
        }


        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            console.log("Only images are supported.");
            return;
        }

        var reader = new FileReader();

            reader.readAsDataURL(e.target.files[0]);
            reader.onload = (_event) => {

                this.FilePosterImageURL=reader.result;

            }

            console.log("this.upload>>>",this.uploadImgFilePosterImage);
        this.uploadImgFilePosterImage.push(obj);
        if(this.uploadImgFilePosterImage.length>0){

          this.loader = true;

            for (let i = 0; i < this.uploadImgFilePosterImage.length; i++) {

                this.productConfigurationService.uploadFile(this.uploadImgFilePosterImage[i].selectedFiles, awsPath.asset).then(res => {

                    if (res && res.Location) {

                    this.ClosedCaption;
                    this.loader = false;
                    e.target.value = '';
                    this.uploadImgFilePosterImage[i].FilePath=res.Location;
                    this.createAssetGroupForm.controls['vodOrLivePosterImageFileName'].setValue(this.uploadImgFilePosterImage[i].fileName);
                    this.createAssetGroupForm.controls['vodOrLivePosterImageFilePath'].setValue(res.Location);
                    this.createAssetGroupForm.controls['vodOrLivePosterImageFileType'].setValue(this.uploadImgFilePosterImage[i].fileType);
                    console.log("createNewProductForm",this.createAssetGroupForm);

                    }

                })
            }
        }else{
            this.ClosedCaption=true;
        }

    }


    selectFiletitleImage(e){

        console.log("e.target.files>>>",e);

        // if( e.target.files[0].name == undefined){

        //     this.loader = false;
        //     return
        // }

       // e.target.value = '';

       this.loader = true;

       this.uploadImgFileTitleImage=[];

        let obj = {
            'index':0,
            'selectedFiles':e.target.files.item(0),
            "fileName": e.target.files[0].name,
            "filePath": "",
            "fileType": e.target.files[0].type,
        }


        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            console.log("Only images are supported.");
            return;
        }

        var reader = new FileReader();

            reader.readAsDataURL(e.target.files[0]);
            reader.onload = (_event) => {

                this.FiletitleImageURL=reader.result;

            }

            console.log("this.upload>>>",this.uploadImgFileTitleImage);
        this.uploadImgFileTitleImage.push(obj);
        if(this.uploadImgFileTitleImage.length>0){

          this.loader = true;

            for (let i = 0; i < this.uploadImgFileTitleImage.length; i++) {

                this.productConfigurationService.uploadFile(this.uploadImgFileTitleImage[i].selectedFiles, awsPath.asset).then(res => {

                    if (res && res.Location) {

                    this.ClosedCaption;
                    this.loader = false;
                    e.target.value = '';
                    this.uploadImgFileTitleImage[i].FilePath=res.Location;
                    this.createAssetGroupForm.controls['TitleImageFileName'].setValue(this.uploadImgFileTitleImage[i].fileName);
                    this.createAssetGroupForm.controls['ThumbnailImage'].setValue(res.Location);
                    this.createAssetGroupForm.controls['TitleImageFileType'].setValue(this.uploadImgFileTitleImage[i].fileType);
                    console.log("createNewProductForm",this.createAssetGroupForm);

                    }

                })
            }
        }else{
            this.ClosedCaption=true;
        }

    }
    selectFilePosterImage2(e, i){
        if(e.target.files[0].name==undefined){
            return;
        }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            console.log("Only images are supported.");
            return;
        }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => {
            this.FilePosterImageURL2 = reader.result;
        };

        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) {
                this.multipleDeviceForm.value.devices[i].vodOrLivePosterImageFilePath2 = res.Location;
            }
        });
        e.target.value = '';
    }

    selectFiletitleImage2(e, i){
        if(e.target.files[0].name==undefined){
            return;
        }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            console.log("Only images are supported.");
            return;
        }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => {
            this.FiletitleImageURL2 = reader.result;
        };

        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) {
                this.multipleDeviceForm.value.devices[i].TitleFilePath2 = res.Location;
            }
        });
        e.target.value = '';
    }

    selectFileThumbImage2(e, i){
        if(e.target.files[0].name==undefined){
            return;
        }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            console.log("Only images are supported.");
            return;
        }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => {
            this.FilethumbImageURL2 = reader.result;
        };

        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) {
                this.multipleDeviceForm.value.devices[i].thumbFilePath2 = res.Location;
            }
        });
        e.target.value = '';
    }
    selectFilePosterImage3(e, i){
        if(e.target.files[0].name==undefined){ return; }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) { return; }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.FilePosterImageURL3 = reader.result; };
        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) this.multipleDeviceForm.value.devices[i].posterFilePath3 = res.Location;
        });
        e.target.value = '';
    }
    selectFiletitleImage3(e, i){
        if(e.target.files[0].name==undefined){ return; }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) { return; }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.FiletitleImageURL3 = reader.result; };
        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) this.multipleDeviceForm.value.devices[i].titleFilePath3 = res.Location;
        });
        e.target.value = '';
    }
    selectFileThumbImage3(e, i){
        if(e.target.files[0].name==undefined){ return; }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) { return; }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.FilethumbImageURL3 = reader.result; };
        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) this.multipleDeviceForm.value.devices[i].thumbFilePath3 = res.Location;
        });
        e.target.value = '';
    }
    selectFilePosterImage4(e, i){
        if(e.target.files[0].name==undefined){ return; }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) { return; }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.FilePosterImageURL4 = reader.result; };
        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) this.multipleDeviceForm.value.devices[i].posterFilePath4 = res.Location;
        });
        e.target.value = '';
    }
    selectFiletitleImage4(e, i){
        if(e.target.files[0].name==undefined){ return; }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) { return; }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.FiletitleImageURL4 = reader.result; };
        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) this.multipleDeviceForm.value.devices[i].titleFilePath4 = res.Location;
        });
        e.target.value = '';
    }
    selectFileThumbImage4(e, i){
        if(e.target.files[0].name==undefined){ return; }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) { return; }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.FilethumbImageURL4 = reader.result; };
        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) this.multipleDeviceForm.value.devices[i].thumbFilePath4 = res.Location;
        });
        e.target.value = '';
    }
    selectFilePosterImage5(e, i){
        if(e.target.files[0].name==undefined){ return; }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) { return; }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.FilePosterImageURL5 = reader.result; };
        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) this.multipleDeviceForm.value.devices[i].posterFilePath5 = res.Location;
        });
        e.target.value = '';
    }
    selectFiletitleImage5(e, i){
        if(e.target.files[0].name==undefined){ return; }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) { return; }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.FiletitleImageURL5 = reader.result; };
        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) this.multipleDeviceForm.value.devices[i].titleFilePath5 = res.Location;
        });
        e.target.value = '';
    }
    selectFileThumbImage5(e, i){
        if(e.target.files[0].name==undefined){ return; }
        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) { return; }
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => { this.FilethumbImageURL5 = reader.result; };
        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.asset).then(res => {
            if (res && res.Location) this.multipleDeviceForm.value.devices[i].thumbFilePath5 = res.Location;
        });
        e.target.value = '';
    }

    selectSetupBannerImage(e){
        if(!e.target.files || !e.target.files[0] || e.target.files[0].name == undefined){
            return;
        }

        var mimeType = e.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            return;
        }

        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (_event) => {
            this.setupBannerImageURL = reader.result;
        };

        this.loader = true;
        this.productConfigurationService.uploadFile(e.target.files.item(0), awsPath.assetGroup).then(res => {
            this.loader = false;
            if (res && res.Location) {
                this.marketingSetupData = Object.assign({}, this.marketingSetupData || {}, {
                    bannerFileName: e.target.files[0].name,
                    bannerFilePath: res.Location
                });
                this.setupBannerImageURL = res.Location;
                this.createAssetGroupForm.controls['marketingBannerFileName'].setValue(e.target.files[0].name);
                this.createAssetGroupForm.controls['marketingBannerFilePath'].setValue(res.Location);
            }
            e.target.value = '';
        }, () => {
            this.loader = false;
            e.target.value = '';
        });
    }

    deleteSetupBannerImage(){
        this.setupBannerImageURL = '';
        this.marketingSetupData = Object.assign({}, this.marketingSetupData || {}, {
            bannerFileName: null,
            bannerFilePath: null
        });
        this.createAssetGroupForm.controls['marketingBannerFileName'].setValue('');
        this.createAssetGroupForm.controls['marketingBannerFilePath'].setValue('');
    }

    isDeleteDeviceType(event){

        console.log('event Mayuri',event)
        if(event=='Cancel'){
            this.isDeleteAction=false;
        }

        if(event=='Yes'){
            this.isDeleteAction=false;
            this.delInput(this.deleteDeviceTypeIndex);
        }

    }

    isDeleteDeviceTypeYes(i){
        this.deleteDeviceTypeIndex = i;
    }
    isDeletePosterImage(event){

        console.log('isDeletePosterImageAction event = ',event)
        if(event=='Cancel'){
            this.isDeletePosterImageAction=false;
        }

        if(event=='Yes'){
            this.isDeletePosterImageAction=false;
            delete this.FilePosterImageURL;

            this.createAssetGroupForm.controls['vodOrLivePosterImageFileName'].setValue(['']);
            this.createAssetGroupForm.controls['vodOrLivePosterImageFilePath'].setValue(['']);
            this.createAssetGroupForm.controls['vodOrLivePosterImageFileType'].setValue(['']);
        }

    }

    isDeleteClosedCaptionImage(event){

        console.log('isDeleteClosedCaptionImageAction event = ',event)
        if(event=='Cancel'){

        this.isDeletetitleImageAction=false;
    }

    if(event=='Yes'){
        this.isDeletetitleImageAction=false;
        delete this.FiletitleImageURL

            this.createAssetGroupForm.controls['TitleImageFileName'].setValue(['']);
            this.createAssetGroupForm.controls['ThumbnailImage'].setValue(['']);
            this.createAssetGroupForm.controls['TitleImageFileType'].setValue(['']);

        }

    }

    isDeleteThumbImage(event){

        if(event=='Cancel'){
            this.isDeleteThumbImageAction=false;
        }

        if(event=='Yes'){
            this.isDeleteThumbImageAction=false;
            delete this.FilethumbImageURL;
        }
    }

    deletePosterImage2(){
        delete this.FilePosterImageURL2;
    }

    deleteTitleImage2(){
        delete this.FiletitleImageURL2;
    }

    deleteThumbImage2(){
        delete this.FilethumbImageURL2;
    }
    deletePosterImage3(){
        delete this.FilePosterImageURL3;
    }
    deleteTitleImage3(){
        delete this.FiletitleImageURL3;
    }
    deleteThumbImage3(){
        delete this.FilethumbImageURL3;
    }
    deletePosterImage4(){
        delete this.FilePosterImageURL4;
    }
    deleteTitleImage4(){
        delete this.FiletitleImageURL4;
    }
    deleteThumbImage4(){
        delete this.FilethumbImageURL4;
    }
    deletePosterImage5(){
        delete this.FilePosterImageURL5;
    }
    deleteTitleImage5(){
        delete this.FiletitleImageURL5;
    }
    deleteThumbImage5(){
        delete this.FilethumbImageURL5;
    }

    //need to false assetGroup
    tabFalse(){
        this.formTabs = {

            assetInfo:{

             asset:false,
             mapGeoZone:false,
             information:false,
             HierarchyMapping:false,
             seo:false,
            },
            deviceType:{

                configurationType:false,
                configuration:false,
                horizontal:false,
                vertical:false

            },
            assetLiveVod:{

                vod:false,
                live:false,
                assetLiveVod:false
            },
            metadata:{

                metadata:false,
                metadataHierarchy:false,
                Information:false,
                castAndCrew:false,
                orderingAndSorting:false

            }
        }
    }

    // asset group tab
    onItemSelectDevice(e,info){
        console.log(e)
        console.log(info)
        this.removeTrailerIndex = null;

    }

    onAssetInfoTabClick(){

        this.formTabs = {

            assetInfo:{

             asset:true,
             mapGeoZone:true,
             information:false,
             hierarchyMapping:false,
             seo:false,
            },
            deviceType:{

                configurationType:false,
                configuration:false,
                horizontal:false,
                vertical:false

            },
            assetLiveVod:{

                vod:false,
                live:false,
                assetLiveVod:false
            },
            metadata:{

                metadata:false,
                metadataHierarchy:false,
                Information:false,
                castAndCrew:false,
                orderingAndSorting:false
            },
            // ordering:false,
            // otherMapping:false,
            // seo:false
        }
    }

    onHierarchyTabClick(){

        this.selectedprimaryNavigationList = this.removeDuplicates(this.selectedprimaryNavigationList,'id');

        setTimeout(()=>{

            this.createAssetGroupForm.controls['mapPrimaryNavigation'].setValue(this.selectedprimaryNavigationList);

        },300)

        this.formTabs = {

            assetInfo:{

             asset:true,
             mapGeoZone:false,
             information:false,
             hierarchyMapping:true,
             seo:false,
            },
            deviceType:{

                configurationType:false,
                configuration:false,
                horizontal:false,
                vertical:false

            },
            assetLiveVod:{

                vod:false,
                live:false,
                assetLiveVod:false
            },
            metadata:{

                metadata:false,
                metadataHierarchy:false,
                Information:false,
                castAndCrew:false,
                orderingAndSorting:false

            },
            // ordering:false,
            // otherMapping:false,
            // seo:false
        }
    }

    oninformationTabClick(){


        this.formTabs = {

            assetInfo:{

             asset:true,
             mapGeoZone:false,
             information:true,
             HierarchyMapping:false,
             seo:false,
            },
            deviceType:{

                configurationType:false,
                configuration:false,
                horizontal:false,
                vertical:false

            },
            assetLiveVod:{

                vod:false,
                live:false,
                assetLiveVod:false
            },
            metadata:{

                metadata:false,
                metadataHierarchy:false,
                Information:false,
                castAndCrew:false,
                orderingAndSorting:false

            },
            // ordering:false,
            // otherMapping:false,
            // seo:false
        }


    }

    oncastAndCrewTabClick(){

        this.formTabs = {

            assetInfo:{

             asset:false,
             mapGeoZone:false,
             information:false,
             HierarchyMapping:false,
             seo:false,
            },
            deviceType:{

                configurationType:false,
                configuration:false,
                horizontal:false,
                vertical:false

            },
            assetLiveVod:{

                vod:false,
                live:false,
                assetLiveVod:false
            },
            metadata:{

                metadata:true,
                metadataHierarchy:false,
                Information:false,
                castAndCrew:true,
                orderingAndSorting:false

            },
            // ordering:false,
            // otherMapping:false,
            // seo:false
        }
    }

    onOrderingTabClick(){

        this.formTabs = {

            assetInfo:{

             asset:false,
             mapGeoZone:false,
             information:false,
             HierarchyMapping:false,
             seo:false
            },
            deviceType:{

                configurationType:false,
                configuration:false,
                horizontal:false,
                vertical:false

            },
            assetLiveVod:{

                vod:false,
                live:false,
                assetLiveVod:false
            },
            metadata:{

                metadata:true,
                Information:false,
                castAndCrew:false,
                orderingAndSorting:true

            },
            // ordering:true,
            // otherMapping:false,
            // seo:false
        }

    }

    onOtherMappingTabClick(){

        this.formTabs = {

            assetInfo:{

             asset:false,
             mapGeoZone:false,
             information:false,
             HierarchyMapping:false,
             seo:false,
            },
            deviceType:{

                configurationType:false,
                configuration:false,
                horizontal:false,
                vertical:false

            },
            assetLiveVod:{

                vod:false,
                live:false,
                assetLiveVod:false
            },
            metadata:{

                metadata:true,
                metadataHierarchy:false,
                Information:true,
                castAndCrew:false,
                orderingAndSorting:false

            },
            // ordering:false,
            // otherMapping:true,
            // seo:false
        }

    }

    onHorizontalTabClick(){
        this.formTabs = {

            assetInfo:{

             asset:false,
             mapGeoZone:false,
             information:false,
             HierarchyMapping:false,
             seo:false,
            },
            deviceType:{

                configurationType:true,
                configuration:false,
                horizontal:true,
                vertical:false

            },
            assetLiveVod:{

                vod:false,
                live:false,
                assetLiveVod:false
            },
            metadata:{

                metadata:false,
                metadataHierarchy:false,
                Information:false,
                castAndCrew:false,
                orderingAndSorting:false
            },
            // ordering:false,
            // otherMapping:false,
            // seo:false
        }
    }

    onVerticalTabClick(){

        this.formTabs = {

            assetInfo:{

            asset:false,
            mapGeoZone:false,
            information:false,
            HierarchyMapping:false,
            seo:false,
            },
            deviceType:{

                configurationType:true,
                configuration:false,
                horizontal:false,
                vertical:true

            },
            assetLiveVod:{

                vod:false,
                live:false,
                assetLiveVod:false
            },
            metadata:{

                metadata:false,
                metadataHierarchy:false,
                Information:false,
                castAndCrew:false,
                orderingAndSorting:false
            },
            // ordering:false,
            // otherMapping:false,
            // seo:false
        }
    }


    onDeviceTypeTabClick(){

       this.formTabs = {

        assetInfo:{

         asset:false,
         mapGeoZone:false,
         information:false,
         HierarchyMapping:false,
         seo:false,
        },
        deviceType:{

            configurationType:true,
            configuration:true,
            horizontal:false,
            vertical:false

        },
        assetLiveVod:{

            vod:false,
            live:false,
            assetLiveVod:false
        },
        metadata:{

            metadata:false,
            metadataHierarchy:false,
            Information:false,
            castAndCrew:false,
            orderingAndSorting:false
        },
        // ordering:false,
        // otherMapping:false,
        // seo:false
    }
    }

    onSeoTabClick(){

            this.formTabs = {

                assetInfo:{

                asset:true,
                mapGeoZone:false,
                information:false,
                HierarchyMapping:false,
                seo:true,

                },
                deviceType:{

                    configurationType:false,
                    configuration:false,
                    horizontal:false,
                    vertical:false

                },
                assetLiveVod:{

                    vod:false,
                    live:false,
                    assetLiveVod:false
                },
                metadata:{

                    metadata:false,
                    metadataHierarchy:false,
                    Information:false,
                    castAndCrew:false,
                    orderingAndSorting:false
                },
                // ordering:false,
                // otherMapping:false,
                // seo:false
            }

    }

    isDeleteHorizontalImage(event){

            console.log('isDeleteHorizontalImageAction event = ',event)
            if(event=='Cancel'){
                this.isDeleteHorizontalImageAction=false;
            }

            if(event=='Yes'){
                this.isDeleteHorizontalImageAction=false;
                delete this.img[this.deleteDeviceTypeIndex].horizontalURL;
                this.multipleDeviceForm.value.devices[this.deleteDeviceTypeIndex].horizontalFilePath="";

                this.uploadImgFilePathHorizontal[this.deleteDeviceTypeIndex].selectedFiles = '';
                this.uploadImgFilePathHorizontal[this.deleteDeviceTypeIndex].deviceType = '';
            }

    }

    deleteHorizontalImageYes(i){
        this.deleteDeviceTypeIndex=i;
    }

    deleteHorizontalImage2(i){
        if(this.img2[i]){
            delete this.img2[i].horizontalURL;
        }
        if(this.multipleDeviceForm.value.devices[i]){
            this.multipleDeviceForm.value.devices[i].horizontalFilePath2 = "";
        }
        if(this.uploadImgFilePathHorizontal2[i]){
            this.uploadImgFilePathHorizontal2[i].selectedFiles = '';
            this.uploadImgFilePathHorizontal2[i].deviceType = '';
        }
    }

    isDeleteVerticalImage(event){

        console.log('isDeleteVerticalImageAction event = ',event)
        if(event=='Cancel'){
            this.isDeleteVerticalImageAction=false;
        }

        if(event=='Yes'){

            this.isDeleteVerticalImageAction=false;
            delete this.img[this.deleteDeviceTypeIndex].verticalURL;
            this.multipleDeviceForm.value.devices[this.deleteDeviceTypeIndex].verticalFilePath="";

            this.uploadImgFilePathVertical[this.deleteDeviceTypeIndex].selectedFiles = '';
            this.uploadImgFilePathVertical[this.deleteDeviceTypeIndex].deviceType = '';

        }

    }

    deleteVerticalImageYes(i){
        this.deleteDeviceTypeIndex=i;
    }

    deleteVerticalImage2(i){
        if(this.img2[i]){
            delete this.img2[i].verticalURL;
        }
        if(this.multipleDeviceForm.value.devices[i]){
            this.multipleDeviceForm.value.devices[i].verticalFilePath2 = "";
        }
        if(this.uploadImgFilePathVertical2[i]){
            this.uploadImgFilePathVertical2[i].selectedFiles = '';
            this.uploadImgFilePathVertical2[i].deviceType = '';
        }
    }
    deleteHorizontalImage3(i){
        if(this.img3[i]) delete this.img3[i].horizontalURL;
        if(this.multipleDeviceForm.value.devices[i]) this.multipleDeviceForm.value.devices[i].horizontalFilePath3 = "";
        if(this.uploadImgFilePathHorizontal3[i]){
            this.uploadImgFilePathHorizontal3[i].selectedFiles = '';
            this.uploadImgFilePathHorizontal3[i].deviceType = '';
        }
    }
    deleteVerticalImage3(i){
        if(this.img3[i]) delete this.img3[i].verticalURL;
        if(this.multipleDeviceForm.value.devices[i]) this.multipleDeviceForm.value.devices[i].verticalFilePath3 = "";
        if(this.uploadImgFilePathVertical3[i]){
            this.uploadImgFilePathVertical3[i].selectedFiles = '';
            this.uploadImgFilePathVertical3[i].deviceType = '';
        }
    }
    deleteHorizontalImage4(i){
        if(this.img4[i]) delete this.img4[i].horizontalURL;
        if(this.multipleDeviceForm.value.devices[i]) this.multipleDeviceForm.value.devices[i].horizontalFilePath4 = "";
        if(this.uploadImgFilePathHorizontal4[i]){
            this.uploadImgFilePathHorizontal4[i].selectedFiles = '';
            this.uploadImgFilePathHorizontal4[i].deviceType = '';
        }
    }
    deleteVerticalImage4(i){
        if(this.img4[i]) delete this.img4[i].verticalURL;
        if(this.multipleDeviceForm.value.devices[i]) this.multipleDeviceForm.value.devices[i].verticalFilePath4 = "";
        if(this.uploadImgFilePathVertical4[i]){
            this.uploadImgFilePathVertical4[i].selectedFiles = '';
            this.uploadImgFilePathVertical4[i].deviceType = '';
        }
    }
    deleteHorizontalImage5(i){
        if(this.img5[i]) delete this.img5[i].horizontalURL;
        if(this.multipleDeviceForm.value.devices[i]) this.multipleDeviceForm.value.devices[i].horizontalFilePath5 = "";
        if(this.uploadImgFilePathHorizontal5[i]){
            this.uploadImgFilePathHorizontal5[i].selectedFiles = '';
            this.uploadImgFilePathHorizontal5[i].deviceType = '';
        }
    }
    deleteVerticalImage5(i){
        if(this.img5[i]) delete this.img5[i].verticalURL;
        if(this.multipleDeviceForm.value.devices[i]) this.multipleDeviceForm.value.devices[i].verticalFilePath5 = "";
        if(this.uploadImgFilePathVertical5[i]){
            this.uploadImgFilePathVertical5[i].selectedFiles = '';
            this.uploadImgFilePathVertical5[i].deviceType = '';
        }
    }

    deleteVerticalPlainImage(i){
        if(this.imgPlain[i]) delete this.imgPlain[i].verticalPlainURL;
        if(this.multipleDeviceForm.value.devices[i]){
            this.multipleDeviceForm.value.devices[i].verticalFilePathPlain = "";
            this.multipleDeviceForm.value.devices[i].verticalFileNamePlain = "";
            this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain = "";
        }
        if(this.uploadImgFilePathVerticalPlain[i]){
            this.uploadImgFilePathVerticalPlain[i].selectedFiles = '';
            this.uploadImgFilePathVerticalPlain[i].deviceType = '';
        }
    }
    deleteVerticalPlainImage2(i){
        if(this.imgPlain2[i]) delete this.imgPlain2[i].verticalPlainURL;
        if(this.multipleDeviceForm.value.devices[i]){
            this.multipleDeviceForm.value.devices[i].verticalFilePathPlain2 = "";
            this.multipleDeviceForm.value.devices[i].verticalFileNamePlain2 = "";
            this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain2 = "";
        }
        if(this.uploadImgFilePathVerticalPlain2[i]){
            this.uploadImgFilePathVerticalPlain2[i].selectedFiles = '';
            this.uploadImgFilePathVerticalPlain2[i].deviceType = '';
        }
    }
    deleteVerticalPlainImage3(i){
        if(this.imgPlain3[i]) delete this.imgPlain3[i].verticalPlainURL;
        if(this.multipleDeviceForm.value.devices[i]){
            this.multipleDeviceForm.value.devices[i].verticalFilePathPlain3 = "";
            this.multipleDeviceForm.value.devices[i].verticalFileNamePlain3 = "";
            this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain3 = "";
        }
        if(this.uploadImgFilePathVerticalPlain3[i]){
            this.uploadImgFilePathVerticalPlain3[i].selectedFiles = '';
            this.uploadImgFilePathVerticalPlain3[i].deviceType = '';
        }
    }
    deleteVerticalPlainImage4(i){
        if(this.imgPlain4[i]) delete this.imgPlain4[i].verticalPlainURL;
        if(this.multipleDeviceForm.value.devices[i]){
            this.multipleDeviceForm.value.devices[i].verticalFilePathPlain4 = "";
            this.multipleDeviceForm.value.devices[i].verticalFileNamePlain4 = "";
            this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain4 = "";
        }
        if(this.uploadImgFilePathVerticalPlain4[i]){
            this.uploadImgFilePathVerticalPlain4[i].selectedFiles = '';
            this.uploadImgFilePathVerticalPlain4[i].deviceType = '';
        }
    }
    deleteVerticalPlainImage5(i){
        if(this.imgPlain5[i]) delete this.imgPlain5[i].verticalPlainURL;
        if(this.multipleDeviceForm.value.devices[i]){
            this.multipleDeviceForm.value.devices[i].verticalFilePathPlain5 = "";
            this.multipleDeviceForm.value.devices[i].verticalFileNamePlain5 = "";
            this.multipleDeviceForm.value.devices[i].uploadVerticalImagePlain5 = "";
        }
        if(this.uploadImgFilePathVerticalPlain5[i]){
            this.uploadImgFilePathVerticalPlain5[i].selectedFiles = '';
            this.uploadImgFilePathVerticalPlain5[i].deviceType = '';
        }
    }


    resetForm(){


    this.productTypeMappingFilter = {};
    this.primaryNavigationMappingFilter = {};
    this.menuCategoryMappingFilter = {};
    this.selectedprimaryNavigationList = [];
    this.mapPrimaryNavigationArrayTemp = [];
        this.trailerVideoList = [];
        this.mapProductTypeArrayTemp = [];
        this.mapLanguageList = [];
        this.audioLanguageList = [];
        this.subtitleLanguageList = [];
        this.audioLanguageFilter = {};
        this.subtitleLanguageFilter = {};
        this.startAudioLanguage = 0;
        this.startSubtitleLanguage = 0;
        this.productScrollCount = 0;
        this.mapMenuCategoryArrayTemp = [];
        this.mapPrimaryNavigationArrayTemp = [];

        this.mapSponsoreList = [];

        this.SponsoredScrollCount = 0;
        this.startSponsored = 0;
        this.characterScrollCount = 0;

        this.startReview = 0;

        this.onAssetInfoTabClick();

        this.update = false;
        this.img = [];
        this.imgPlain = [];
        this.imgPlain2 = [];
        this.imgPlain3 = [];
        this.imgPlain4 = [];
        this.imgPlain5 = [];
        this.img2 = [];
        this.img3 = [];
        this.img4 = [];
        this.img5 = [];
        this.setupBannerImageURL = '';
        this.marketingSetupData = {};
        const arrayControl = this.multipleDeviceForm.get('devices') as FormArray;
        while (arrayControl.length !== 0) {

            arrayControl.removeAt(0);

        }

        this.id = null;

        this.uploadImgFilePathHorizontal = [];
        this.uploadImgFilePathVertical = [];
        this.uploadImgFilePathHorizontal2 = [];
        this.uploadImgFilePathVertical2 = [];
        this.uploadImgFilePathHorizontal3 = [];
        this.uploadImgFilePathVertical3 = [];
        this.uploadImgFilePathHorizontal4 = [];
        this.uploadImgFilePathVertical4 = [];
        this.uploadImgFilePathHorizontal5 = [];
        this.uploadImgFilePathVertical5 = [];
        this.uploadImgFilePathVerticalPlain = [];
        this.uploadImgFilePathVerticalPlain2 = [];
        this.uploadImgFilePathVerticalPlain3 = [];
        this.uploadImgFilePathVerticalPlain4 = [];
        this.uploadImgFilePathVerticalPlain5 = [];

        let objH = {
            'index':"",
            'deviceType':"",
            'selectedFiles':"",
            "horizontalFileName": "",
            "horizontalFilePath": "",
            "horizontalFileType": "",
            'horizontalFile':false
        }

        let objV = {
            'index':"",
            'deviceType':"",
            'selectedFiles':"",
            "verticalFileName":"",
            "verticalFilePath": "",
            "verticalFileType":"",
            'verticalFile':false,

        }

        let objVPlain = {
            'index':"",
            'deviceType':"",
            'selectedFiles':"",
            "verticalFileNamePlain":"",
            "verticalFilePathPlain": "",
            "verticalFileTypePlain":"",
            'verticalFilePlain':false,
        }

        this.uploadImgFilePathHorizontal.push(objH);
        this.uploadImgFilePathVertical.push(objV);
        this.uploadImgFilePathVerticalPlain.push(objVPlain);

        this.createAssetGroupForm = this.formBuilder.group({
            id:[""],
            assetGroupType : [""],
            contentType :[""],
            isActive : ["1"],
            langId: [this.langId],
            companyId : [""],
            isVisible:[''],
            title :["",Validators.required],
            displayIndexing: [''],
            permaLink:[''],
            productionYear:[''],
            sameForAllZone : [''],
            sameForAllProductType : [''],
            airStartDate : [''],
            airEndDate : [""],
            airStartTime:[''],
            airEndTime:[''],
            exclusionText : [""],
            description : [""],
            seoTitle : [""],
            seoKeyword : [""],
            seoDescription : [""],
            trailerUrl : [""],
            previewUrl : [""],
            orderBy : [""],
            sorting : [""],
            mapGeoZone:[[], Validators.compose([Validators.required])],
            langMetadata:[[]],
            productDeviceTypeConfigure:[[]],
            mapProductType:[[], Validators.compose([Validators.required])],
            mapPrimaryNavigation:[[]],
            mapMenuCategory:[[]],
            mapCertification:[[]],
            mapClassification:[[]],
            mapCast:[[]],
            mapGenre:[[]],
            mapCharacter:[[]],
            vodOrLivePosterImageFileName: [''],
            vodOrLivePosterImageFilePath: [''],
            vodOrLivePosterImageFileType:[''],
            TitleImageFileName: [''],
            ThumbnailImage: [''],
            TitleImageFileType:[''],
            marketingBannerFileName: [''],
            marketingBannerFilePath: [''],
            // mapAssetLibrary:[[]],
            mapLibrary:[[]],
            mapLanguage:[[]],
            audioLanguage:[[]],
            subtitleLanguage:[[]],
            mapSponsor:[[]],
            mapReview:[[]],
            contentState:['In-Progress'],
            publisherState:['Un-published'],
            reviewerState:['Un-approved'],
            created_by:[localStorage.getItem('ud')],
            coinsType: ['uniform', Validators.required],
            coinsToRedeem: [0, [Validators.required, Validators.min(0)]]

        })



        this.update = false;

        //////////////////////

        // this.img.push({
        //     horizontalURL:'',
        //     verticalURL:''
        // })

        //reset device type image
        this.img = [];
        this.img.push({
            horizontalURL:'',
            verticalURL:''
        })
        this.imgPlain = [];
        this.imgPlain.push({
            verticalPlainURL:''
        })
        this.img2.push({
            horizontalURL:'',
            verticalURL:''
        })
        this.img3.push({
            horizontalURL:'',
            verticalURL:''
        })
        this.img4.push({
            horizontalURL:'',
            verticalURL:''
        })
        this.img5.push({
            horizontalURL:'',
            verticalURL:''
        })
        this.FilePosterImageURL ='';
        this.FilePosterImageURL2 ='';
        this.FilePosterImageURL3 ='';
        this.FilePosterImageURL4 ='';
        this.FilePosterImageURL5 ='';

        this.updateSend.emit();

        this.multipleDeviceForm = this.formBuilder.group({

            devices: this.formBuilder.array([this.createItem()])

        });

        this.showCreateNewButton('show');

    }


    showCreateNewButton(isShow){

        if(isShow == 'show'){

            this.isCreateNewShow = true;
        }
        else{
            this.isCreateNewShow = false;
        }
    }


    createcast(): FormGroup {

        return this.formBuilder.group({
    
            mapCast:[[]],
            displayIndexing:['',Validators.pattern(displayIndexingPattern)]
    
        });
    }

    addcast(): void {

        this.mapcasts = this.mapcastDynamicForm.get('mapcasts') as FormArray;
        this.mapcasts.push(this.createcast());

    }

    isDeleteAssetMapYes(i:any,type:any){
        const arrayControl = this.mapcastDynamicForm.get('mapcasts') as FormArray;
        arrayControl.removeAt(i);
    }



    updatefromgroup(obj, type): FormGroup {


        console.log("obj.assetId,",obj ,type)
        if (type == 'asset') {
        let arrayObj = {
            'id': obj.assetId,
            'itemName':obj.assetName,
        }

        return this.formBuilder.group({

            mapAsset:[[arrayObj]],
            displayIndexing:obj.displayIndexing

        });
    }

    if (type == 'assetGroup') {
        let arrayObj = {
            'id': obj.assetGroupId,
            'itemName':obj.assetGroupName,
        }
        console.log(arrayObj)
        return this.formBuilder.group({

            mapAssetgroup:[[arrayObj]],
            displayIndexing:obj.displayIndexing

        });
    }

    if (type == 'genre') {
        let arrayObj = {
            'id': obj.genreId,
            'itemName':obj.genreName,
        }
        console.log(arrayObj)
        return this.formBuilder.group({

            mapgenre:[[arrayObj]],
            displayIndexing:obj.displayIndexing

        });
    }

    if (type == 'cast') {
        let arrayObj = {
            'id': obj.castId,
            'itemName':obj.castFirstName,
        }
        console.log(arrayObj)
        return this.formBuilder.group({

            mapCast:[[arrayObj]],
            displayIndexing:obj.displayIndex

        });
    }

    }

    OnItemSelect(event){
        this.selectedmapCast.push(event)
        console.log(this.selectedmapCast)
    }

    getLangMetadataValue(language: any, key: string): string {
        const langId = this.getLangMetadataLanguageId(language);
        const list = this.createAssetGroupForm && this.createAssetGroupForm.value && this.createAssetGroupForm.value.langMetadata
            ? this.createAssetGroupForm.value.langMetadata
            : [];
        const item = Array.isArray(list) ? list.find((entry: any) => String(entry.langId) === String(langId)) : null;
        return item && item[key] !== undefined && item[key] !== null ? item[key] : '';
    }

    setLangMetadataValue(language: any, key: string, value: any): void {
        if (!this.createAssetGroupForm || !this.createAssetGroupForm.controls['langMetadata']) {
            return;
        }
        const langId = this.getLangMetadataLanguageId(language);
        const current = this.createAssetGroupForm.controls['langMetadata'].value;
        const list = Array.isArray(current) ? current.slice() : [];
        let item = list.find((entry: any) => String(entry.langId) === String(langId));
        if (!item) {
            item = { langId: langId };
            list.push(item);
        }
        item[key] = value;
        this.createAssetGroupForm.controls['langMetadata'].setValue(list);
    }

    getLangMetadataLanguageName(language: any): string {
        return language && (language.itemName || language.langaugeName || language.langauge_name || language.languageName || language.name || language.title || language.langauge_code || language.id) || '';
    }

    private getLangMetadataLanguageId(language: any): any {
        return language && (language.id || language.langId || language.languageId || language.langaugeId || language.language_id);
    }

 
}
